// src/collegesDetails.js


export const collegesDetails = [
  {
    slug: "upes-college",
    name: "UPES College",
location: "P.O. Bidholi & P.O. Kandoli, Via Premnagar, Dehradun - 248007, Uttarakhand",
   
    image : "/images/upes.webp"
,   brochure: "/brochures/upes_fees_structure.pdf",
cdbrochure: "/brochures/upes_fees_structure.pdf",

    logo: "/images/logo/upes.webp",  // Add this
whyusimg:[
  "/images/whyus/Screenshot 2025-12-16 201516.webp",
  "/images/whyus/Screenshot 2025-12-16 201532.webp",
  "/images/whyus/Screenshot 2025-12-16 201621.webp"
],
// feeStructureImage: ["/images/fee/uu-1.webp", "/images/fee/uu-2.webp"],

aboutImages: [
"/images/UPES-College/imgi_73_Untitled design (13).webp",
"/images/UPES-College/imgi_74_cc-1 copy.webp",
"/images/UPES-College/imgi_76_campus-toor-bidholi-1.webp"
],
    overview:
      "UPES Dehradun is a leading private university known for its industry-focused programs in engineering, management, law, design, and computer science. It offers strong placements, modern infrastructure, and specialized courses in energy, petroleum, and emerging technologies.",
    established: "2003",
 
    fees_btech: "₹2.5 – 4.5 Lakhs/year",
    admissions: {
  examsAccepted: "UPESEAT / JEE Main / Board Merit",
  applicationMode: "Online",
  applicationFee: "₹1,350",
  importantDates: [
    "Application Opens: January",
    "Last Date to Apply: May end",
    "Entrance Exam: June"
  ]
},

faqs: [
  {
    question: "What are the core specialized programs offered at UPES?",
    answer: "UPES is renowned for its industry-aligned specialization courses in Oil & Gas, Power, Aviation, Infrastructure, IT, Design, Law, and Business. It offers over 150 specialized programs across 8 schools, focusing on core sectors like Energy and Cloud Computing."
  },
  {
    question: "How is the placement record at UPES Dehradun?",
    answer: "UPES maintains a placement record of over 90% annually. For the 2024-25 session, the highest package reached approximately ₹50 LPA, with over 600+ recruiters including giants like Schlumberger, Microsoft, and Amazon visiting the campus."
  },
  {
    question: "What is the fee structure for B.Tech programs at UPES?",
    answer: "The B.Tech fees at UPES generally range from ₹3.5 Lakhs to ₹4.5 Lakhs per year depending on the specialization. The total course fee for 4 years usually falls between ₹16 Lakhs and ₹20 Lakhs, excluding hostel charges."
  },
  {
    question: "Does UPES provide hostel facilities for all students?",
    answer: "Yes, UPES offers separate on-campus hostels for boys and girls with options for triple and double sharing rooms. The hostel fee ranges from ₹1.8 Lakhs to ₹2.3 Lakhs per year, which includes mess charges and amenities."
  },
  {
    question: "Is UPES a UGC-recognized university?",
    answer: "Yes, UPES is recognized by the UGC under Section 2(f) of the UGC Act, 1956. It is also accredited by NAAC with an 'A' grade and holds various other accreditations like NBA for specific engineering programs."
  },
  {
    question: "What entrance exams are accepted for UPES MBA admission?",
    answer: "For MBA admissions, UPES accepts scores from CAT, MAT, XAT, CMAT, NMAT, and GMAT. Alternatively, students can appear for the university's own entrance test, UPESMET, followed by a personal interview."
  },
  {
    question: "Does UPES offer scholarships to students?",
    answer: "Yes, UPES offers scholarships up to 100% based on merit in board exams (Class 12th) and entrance exams like JEE Mains, CAT, and CLAT. Special concessions are also available for Uttarakhand domicile students and girl students."
  },
  {
    question: "How far is the UPES campus from Dehradun city center?",
    answer: "UPES has two campuses: Bidholi (Energy/Engineering) and Kandoli (Law/Design). Bidholi is about 15-18 km from the city center (Clock Tower), while Kandoli is slightly nearby. The drive takes around 45-60 minutes."
  },
  {
    question: "What is the 'Design Your Own Degree' concept at UPES?",
    answer: "UPES allows students to curate their learning through a flexible curriculum. Students can choose a core subject, specialization, and minors from different schools (e.g., a B.Tech student taking a minor in Psychology or Design)."
  },
  {
    question: "Is attendance mandatory at UPES?",
    answer: "Yes, UPES has a strict attendance policy requiring a minimum of 75% attendance in all subjects to be eligible for end-semester examinations. Shortage of attendance can lead to debarment from exams."
  }
],

highlights: [
  { icon: "🏆", label: "NAAC Grade", value: "A" },
  { icon: "📊", label: "NIRF Rank", value: "#45" },
  { icon: "👥", label: "Students", value: "15k+" },
  { icon: "📚", label: "Programs", value: "150+" },
  { icon: "💼", label: "Placement", value: "92%" },
  { icon: "🏢", label: "Recruiters", value: "800+" },
],


    eligibility: "10+2 with PCM and minimum 50% marks + UPESEAT / JEE score",
    // Update collegesDetails.js - Add placements object to each college
placements: {
  highestPackage: "₹52 LPA",
  recruitersIndustries: "800+",
  gloriousAlumni: "30000+",
  placementRecords: "92%",
  recruitersImage: "/images/recruiters/upes.webp"
},

    ranking: "Ranked among top private universities in Dehradun",
    ranking_details:
      "• NIRF-ranked institution for engineering and management.\n• Recognized for strong industry partnerships and domain-specialized programs.",
    facts: [
      "Specializations in Energy, Petroleum, Computer Science and Design",
      "Modern campus with laboratories, libraries, and sports facilities",
      "Strong industry collaborations and internship opportunities",
      "Active student clubs for tech, culture, and entrepreneurship"
    ],
    whyChooseUsData: [
    {
      id: 1,
      title: 'Expert Faculty',
      description: 'Learn from industry veterans and experienced academicians dedicated to your success.',
      imageUrl: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    },
    {
      id: 2,
      title: 'World-Class Infrastructure',
      description: 'Access modern labs, well-stocked libraries, and advanced facilities for hands-on learning.',
      imageUrl: 'https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    },
    {
      id: 3,
      title: 'Top Placements',
      description: 'Strong industry connections and career support services ensure placement in top companies.',
      imageUrl: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    },]
,



   galleryImages: [

"/images/UPES-College/imgi_173_about-upes.webp",
"/images/UPES-College/imgi_176_IMG_9171.webp",
"/images/UPES-College/imgi_178_IMG-20240918-WA0017.webp",
"/images/UPES-College/imgi_184_upes_school_of_design_ef6aa511713f16a0d672936594b877ca.webp",
"/images/UPES-College/imgi_185_1729927537Screenshot20241026125454.webp",
"/images/UPES-College/imgi_22_IMG-20250616-WA0014.webp",
"/images/UPES-College/imgi_32_takeTour_1.webp",
"/images/UPES-College/imgi_34_takeTour_2.webp",

"/images/UPES-College/imgi_13_IMG_20251230_145838.webp",
"/images/UPES-College/imgi_14_IMG_20251230_145847.webp",
"/images/UPES-College/imgi_36_176406774114401507918pg_infra-lrge2.webp",
"/images/UPES-College/imgi_37_176406774114401507919pg_infra-lrge3.webp",
"/images/UPES-College/imgi_38_176406774114401507917pg_INFRA-LRGE1.webp",
"/images/UPES-College/imgi_40_takeTour_4_0.webp",
"/images/UPES-College/imgi_42_takeTour_6_0.webp",
"/images/UPES-College/imgi_48_take-tour-sob_0.webp",

"/images/UPES-College/imgi_76_campus-toor-bidholi-1.webp",
"/images/UPES-College/inbound4781120732670183534.webp"
],

     courses: [
{
name: "B.Tech Computer Science & Engineering (AI/ML)",
duration: "4 years"
},
{
name: "B.Tech Aerospace Engineering",
duration: "4 years"
},
{
name: "B.Tech Mechanical Engineering",
duration: "4 years"
},
{
name: "B.Tech Civil Engineering",
duration: "4 years"
},
{
name: "B.Tech Electronics & Communication Engineering",
duration: "4 years"
},
{
name: "B.Tech Electrical Engineering",
duration: "4 years"
},
{
name: "B.Tech Chemical Engineering",
duration: "4 years"
},
{
name: "B.Tech Petroleum Engineering",
duration: "4 years"
},
{
name: "B.Tech Fire & Safety Engineering",
duration: "4 years"
},
{
name: "B.Tech Mechatronics",
duration: "4 years"
},
{
name: "BBA Digital Business",
duration: "3 years"
},
{
name: "MBA Oil & Gas Management",
duration: "2 years"
},
{
name: "MBA Business Analytics",
duration: "2 years"
},
{
name: "B.Des Product Design",
duration: "4 years"
},
{
name: "M.Des Transportation Design",
duration: "2 years"
},
{
name: "B.Pharma",
duration: "4 years"
},
{
name: "B.Sc Chemistry",
duration: "3 years"
},
{
name: "M.Sc Data Science",
duration: "2 years"
},
{
name: "BCA",
duration: "3 years"
},
{
name: "MCA",
duration: "2 years"
}
]
  },
  
  {
  slug: "uit-college",
  name: "Uttaranchal University - [UIT]",
location: "Arcadia Grant, P.O. Chandanwari, Premnagar, Dehradun - 248007, Uttarakhand",
  type: "Government / University Institute",
  rating: "4.3/5",
image: "/images/uit.webp",
brochure: "/brochures/uu.pdf",
cdbrochure: "/brochures/uu.pdf",

faqs: [
  {
    question: "What is the NAAC grade of Uttaranchal University?",
    answer: "Uttaranchal University has been accredited with the prestigious NAAC 'A+' Grade, making it one of the top-rated private universities in the region for quality education and infrastructure."
  },
  {
    question: "How is the Law College (LCD) at Uttaranchal University?",
    answer: "Law College Dehradun (LCD) under Uttaranchal University is one of the oldest and most reputed law schools in the state. It is famous for its strict discipline, excellent moot court culture, and high success rate in judicial exams."
  },
  {
    question: "What are the fees for the B.Tech CSE program?",
    answer: "The fee for B.Tech CSE is approximately ₹2.1 Lakhs to ₹2.6 Lakhs per year depending on domicile and scholarship. Uttarakhand domicile students typically get a 26% rebate on tuition fees."
  },
  {
    question: "Does Uttaranchal University offer scholarships?",
    answer: "Yes, scholarships are awarded to students based on merit (Class 12th/JEE marks), Uttarakhand Domicile (26% fee waiver), and for wards of Defence Personnel (5% fee concession)."
  },
  {
    question: "How are the placements at Uttaranchal University?",
    answer: "The university has a dedicated Corporate Resource Cell. The highest package has gone up to ₹22.5 LPA recently, with average packages hovering around ₹4-6 LPA. Recruiters include Deloitte, Amazon, and Capgemini."
  },
  {
    question: "Is the campus of Uttaranchal University Wi-Fi enabled?",
    answer: "Yes, the campus is fully Wi-Fi enabled. It is a lush green, sprawling campus of over 70 acres near Prem Nagar, known for its beautiful architecture and well-maintained grounds."
  },
  {
    question: "What are the hostel rules and fees?",
    answer: "Hostels are strictly monitored with biometric entry. Fees range from ₹85,000 to ₹1.2 Lakhs per year depending on Single/Double/Triple sharing and AC/Non-AC options. Laundry and mess are included."
  },
  {
    question: "Can I apply for admission online?",
    answer: "Yes, the application process is completely online. Students can fill the form on the official website, pay the registration fee of ₹1200, and upload necessary documents for provisional admission."
  },
  {
    question: "Does the university provide transport facilities?",
    answer: "Yes, Uttaranchal University has a fleet of buses covering all major routes in Dehradun, Vikas Nagar, and nearby areas, ensuring safe and convenient commute for day scholars."
  },
  {
    question: "What sports facilities are available?",
    answer: "The university has extensive sports facilities including a cricket ground, football field, basketball and volleyball courts, and an indoor games hall. It regularly hosts inter-college sports tournaments."
  }
]
,
aboutImages: [
"/images/UIT-College/imgi_53_main-banner.webp",
"/images/UIT-College/imgi_54_engineering-1.webp",
"/images/UIT-College/imgi_55_enginnering-2.webp"
],
whyusimg: [
  "/images/whyus/Screenshot 2025-12-16 202818.webp",
    "/images/whyus/Screenshot 2025-12-16 202935.webp",

  "/images/whyus/Screenshot 2025-12-16 202906.webp",
],
  overview:
    "Uttaranchal University is recognized by the UGC under sections 2(f) and 12 (B) of the UGC Act, 1956, and by other statutory bodies of the State and the Nation. The University has been promoted by Sushila Devi Centre for Professional Studies & Research, a society registered under the Societies Registration Act (1860). The University has been accredited with the prestigious “A+ Grade” by the National Assessment and Accreditation Council (NAAC). Uttaranchal University has become the first university in the State of Uttarakhand to receive NAAC A+ Grade in the first cycle of Accreditation and thus created a history.",
    galleryImages: [
      "/images/UIT-College/download.webp",
"/images/UIT-College/imgi_10_outdorclub.webp",
"/images/UIT-College/imgi_10_program-video-thumb.webp",

"/images/UIT-College/imgi_53_main-banner.webp",
"/images/UIT-College/imgi_54_engineering-1.webp",
"/images/UIT-College/imgi_55_enginnering-2.webp",
"/images/UIT-College/imgi_9_Yoga-2.webp",
   
    "/images/UIT-College/imgi_11_outdors.webp",
"/images/UIT-College/imgi_12_IndoorSports6.webp",

"/images/UIT-College/imgi_16_thumbnail.webp",
"/images/UIT-College/imgi_51_header-academics-img.webp",
       
          "/images/UIT-College/imgi_13_Indoor-Sports-4.webp",
"/images/UIT-College/imgi_14_P1046372.webp",
            
    ],
highlights: [
  { icon: "🏆", label: "NAAC Grade", value: "A" },
  { icon: "📊", label: "NIRF Rank", value: "N/A" },
  { icon: "👥", label: "Students", value: "8k+" },
  { icon: "📚", label: "Programs", value: "80+" },
  { icon: "💼", label: "Placement", value: "75-80%" },
  { icon: "🏢", label: "Recruiters", value: "200+" },
],
  logo : "/images/logo/uu.webp",
placements: {
  highestPackage: "₹46.5 LPA",
  recruitersIndustries: "200+",
  gloriousAlumni: "23000+",
  placementRecords: "80%",
  recruitersImage: "/images/recruiters/uu.webp"
},
whyChooseUsData: [
  {
    id: 1,
    title: 'Comprehensive Technical Education',
    description: 'Specialized programs in engineering with emphasis on hands-on learning and practical skill development.',
    imageUrl: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 2,
    title: 'Strong Industry Connections',
    description: 'Partnerships with 200+ leading companies ensuring internship and placement opportunities for students.',
    imageUrl: 'https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 3,
    title: 'Expert Faculty & Modern Labs',
    description: 'Experienced educators combined with well-equipped laboratories and technology-enabled learning environments.',
    imageUrl: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
],

established: "2005",
  fees_btech: "₹1.3 – 1.8 Lakhs/year",
  admissions: {
    examsAccepted: "JEE Main / UU Entrance Test / 10+2 Merit (as per university norms)",
    applicationMode: "Online & Offline through Uttaranchal University portal",
    applicationFee: "₹1,200 (approx.)",
    importantDates: [
      "Application Opens: December–January",
      "Early Round Counselling: April–May",
      "Main Counselling & Seat Allotment: June–July"
    ]
  },

  eligibility:
    "10+2 with Physics & Mathematics and one of Chemistry/Computer Science, minimum 50–60% aggregate (relaxation for reserved categories).",
  topRecruiters:
    "TCS, Wipro, Infosys, Capgemini, Cognizant, Accenture, Tech Mahindra, HCL and regional IT companies.",
  placement_highest: "₹50 LPA (domestic tech role; higher international offers reported at university level)",
  placement_avg: "₹4–6 LPA (B.Tech CSE / IT range)",
  placement_perc: "75–80% (for eligible B.Tech batches)",
  ranking:
    "Engineering institute under an NAAC A+ accredited university with improving placements and industry connect in North India.",

  ranking_details:
    "• Part of Uttaranchal University, which holds NAAC A+ accreditation and is recognized as a growing private university in North India.\n• B.Tech CSE students have received high packages in recent years, including international offers above ₹1 Cr at university level.\n• Consistent improvement in campus recruitment drives and number of recruiters visiting the campus.",

  facts: [
    "Offers B.Tech programs in CSE, IT and core engineering branches along with lateral entry options.",
    "Industry‑oriented curriculum with emphasis on programming, aptitude training and soft skills for placements.",
    "Wi‑Fi enabled campus with laboratories, library, hostels and sports facilities.",
    "Active technical and cultural clubs providing hackathons, workshops and fest activities.",
    "University‑level placement cell that conducts pooled drives with 200+ recruiters each season."
  ],

  courses: [
  // B.Tech – Undergraduate
  {
    name: "B.Tech Computer Science & Engineering (CSE)",
    level: "UG",
    stream: "Engineering",
    duration: "4 years",
    fees: "₹1.4 – 1.8 Lakhs/year",
    eligibility: "10+2 with Physics, Mathematics and one of Chemistry/Computer Science; 55–60% aggregate; JEE Main / university entrance",
    avgPackage: "₹4.5 – 6 LPA",
    highlights: [
      "Core CSE curriculum covering programming, data structures, DBMS, OS and networks",
      "Strong focus on coding skills and aptitude for IT/ software roles",
      "Access to coding clubs, hackathons and university placement cell"
    ]
  },
  {
    name: "B.Tech CSE with specialization in Cloud Computing",
    level: "UG",
    stream: "Engineering",
    duration: "4 years",
    fees: "₹1.5 – 1.9 Lakhs/year",
    eligibility: "10+2 with PCM, 55–60% aggregate; admission via JEE Main / university test and counselling",
    avgPackage: "₹4.5 – 6.5 LPA",
    highlights: [
      "CSE foundation with advanced courses in cloud platforms, virtualization and DevOps",
      "Projects on deploying scalable apps and services on cloud infrastructure",
      "Suitable for cloud engineer, DevOps and backend roles"
    ]
  },
  {
    name: "B.Tech CSE with specialization in Big Data Analytics",
    level: "UG",
    stream: "Engineering",
    duration: "4 years",
    fees: "₹1.5 – 1.9 Lakhs/year",
    eligibility: "10+2 with PCM, 55–60% aggregate; entrance/merit as per university norms",
    avgPackage: "₹4.5 – 6.5 LPA",
    highlights: [
      "Focus on data engineering, data warehousing and analytics tools",
      "Courses in statistics, machine learning foundations and visualization",
      "Prepares for data analyst, BI engineer and data engineer roles"
    ]
  },
  {
    name: "B.Tech CSE with specialization in Artificial Intelligence & Machine Learning",
    level: "UG",
    stream: "Engineering",
    duration: "4 years",
    fees: "₹1.5 – 2.0 Lakhs/year",
    eligibility: "10+2 with PCM, 60%+ preferred; JEE Main / university entrance",
    avgPackage: "₹5 – 7 LPA (for AI/ML profiles)",
    highlights: [
      "CSE core plus AI, ML, deep learning and Python/R based analytics",
      "Hands‑on projects in vision, NLP and predictive modelling",
      "Good pathway for AI engineer / ML engineer roles and higher studies"
    ]
  },
  {
    name: "B.Tech CSE with specialization in Cyber Security",
    level: "UG",
    stream: "Engineering",
    duration: "4 years",
    fees: "₹1.5 – 2.0 Lakhs/year",
    eligibility: "10+2 with PCM, 55–60% aggregate; entrance/merit based admission",
    avgPackage: "₹4.5 – 6.5 LPA",
    highlights: [
      "Topics in network security, ethical hacking, cryptography and digital forensics",
      "Lab‑based learning with security tools and simulations",
      "Prepares for SOC analyst, security engineer and related roles"
    ]
  },
  {
    name: "B.Tech Civil Engineering",
    level: "UG",
    stream: "Engineering",
    duration: "4 years",
    fees: "₹1.3 – 1.7 Lakhs/year",
    eligibility: "10+2 with PCM, minimum 50% aggregate; JEE Main / university entrance",
    avgPackage: "₹3 – 4 LPA",
    highlights: [
      "Covers structural, geotechnical, transportation and environmental engineering",
      "Field work and surveying along with design and analysis software exposure",
      "Career opportunities in construction, infrastructure and government exams"
    ]
  },
  {
    name: "B.Tech Aerospace Engineering",
    level: "UG",
    stream: "Engineering",
    duration: "4 years",
    fees: "₹1.4 – 1.9 Lakhs/year",
    eligibility: "10+2 with PCM, 60%+ preferred; entrance/merit based",
    avgPackage: "₹3.5 – 5 LPA",
    highlights: [
      "Curriculum in aerodynamics, propulsion, aircraft structures and flight mechanics",
      "Projects related to aircraft design, UAVs and aerospace materials",
      "Scope in aerospace, defense, R&D and higher studies"
    ]
  },
  {
    name: "B.Tech Mechanical Engineering",
    level: "UG",
    stream: "Engineering",
    duration: "4 years",
    fees: "₹1.3 – 1.7 Lakhs/year",
    eligibility: "10+2 with PCM, 50%+ aggregate; JEE Main / university test",
    avgPackage: "₹3.5 – 4.5 LPA",
    highlights: [
      "Core mechanical subjects: design, manufacturing, thermal and fluid sciences",
      "Well‑equipped workshops and labs for hands‑on learning",
      "Suitable for manufacturing, automotive, power and PSU exam preparation"
    ]
  },
  {
    name: "B.Tech Electronics and Computer Engineering",
    level: "UG",
    stream: "Engineering",
    duration: "4 years",
    fees: "₹1.4 – 1.8 Lakhs/year",
    eligibility: "10+2 with PCM, 55%+ aggregate; entrance/merit as per university norms",
    avgPackage: "₹3.5 – 5 LPA",
    highlights: [
      "Blend of electronics, embedded systems and computer science",
      "Courses in microcontrollers, communication systems and programming",
      "Opens roles in embedded, telecom, IoT and software"
    ]
  },

  // Other UG Programs
  {
    name: "Bachelor of Computer Applications (BCA)",
    level: "UG",
    stream: "IT & Computer Applications",
    duration: "3 years",
    fees: "₹80,000 – 1.2 Lakhs/year",
    eligibility: "10+2 (any stream) with Mathematics/Computer Science preferred, 50%+ aggregate",
    avgPackage: "₹3 – 4.5 LPA",
    highlights: [
      "Foundation in programming, databases, web technologies and networking",
      "Good starting point for software developer and support engineer roles",
      "Option to pursue MCA / M.Sc IT or lateral roles in IT industry"
    ]
  },
  {
    name: "Bachelor of Business Administration (BBA)",
    level: "UG",
    stream: "Management",
    duration: "3 years",
    fees: "₹80,000 – 1.3 Lakhs/year",
    eligibility: "10+2 (any stream) with 50%+ aggregate",
    avgPackage: "₹3 – 4 LPA",
    highlights: [
      "Covers basics of marketing, finance, HR, operations and business communication",
      "Case‑study based learning and presentations",
      "Good foundation for MBA and entry‑level corporate roles"
    ]
  },
  {
    name: "B.Sc Animation",
    level: "UG",
    stream: "Design & Media",
    duration: "3 years",
    fees: "₹90,000 – 1.4 Lakhs/year",
    eligibility: "10+2 (any stream), basic drawing / creativity skills preferred",
    avgPackage: "₹3 – 4 LPA",
    highlights: [
      "3D animation, VFX, motion graphics and digital media tools",
      "Portfolio‑based evaluation with project work and showreels",
      "Career options in animation studios, gaming and media"
    ]
  },
  {
    name: "B.Sc Fashion Design",
    level: "UG",
    stream: "Design",
    duration: "3 years",
    fees: "₹90,000 – 1.4 Lakhs/year",
    eligibility: "10+2 (any stream), 50%+ aggregate",
    avgPackage: "₹3 – 4 LPA",
    highlights: [
      "Courses in fashion illustration, garment construction, textiles and merchandising",
      "Fashion shows, portfolio development and industry exposure",
      "Opportunities as fashion designer, stylist, merchandiser"
    ]
  },
  {
    name: "B.Sc Nursing",
    level: "UG",
    stream: "Health Sciences",
    duration: "4 years",
    fees: "₹1.2 – 1.8 Lakhs/year",
    eligibility: "10+2 with PCB, 45–50%+ aggregate; entrance/merit as per nursing council norms",
    avgPackage: "₹3 – 4.5 LPA",
    highlights: [
      "Training in medical‑surgical, community health, pediatrics and obstetrics nursing",
      "Clinical postings in associated hospitals",
      "High demand in hospitals, clinics and abroad"
    ]
  },
  {
    name: "Bachelor of Pharmacy (B.Pharma)",
    level: "UG",
    stream: "Pharmacy",
    duration: "4 years",
    fees: "₹1.2 – 1.7 Lakhs/year",
    eligibility: "10+2 with PCB/PCM, 45–50%+ aggregate",
    avgPackage: "₹3 – 4 LPA",
    highlights: [
      "Focus on pharmaceutics, pharmacology, medicinal chemistry and drug regulation",
      "Enables registration as pharmacist as per norms",
      "Career in pharma industry, hospitals, quality control and marketing"
    ]
  },

  
  {
    name: "M.Tech Construction Technology & Management",
    level: "PG",
    stream: "Engineering",
    duration: "2 years",
    fees: "₹1 – 1.6 Lakhs/year",
    eligibility: "B.Tech in Civil or related branch with required CGPA",
    avgPackage: "₹4.5 – 6.5 LPA",
    highlights: [
      "Combines civil engineering with project management, contracts and cost control",
      "Prepares for roles like project engineer, planning engineer and construction manager",
      "Useful for infrastructure and real‑estate sector careers"
    ]
  },
  {
    name: "M.Tech Thermal Engineering",
    level: "PG",
    stream: "Engineering",
    duration: "2 years",
    fees: "₹1 – 1.4 Lakhs/year",
    eligibility: "B.Tech/BE in Mechanical or related field with required marks",
    avgPackage: "₹4.5 – 6.5 LPA",
    highlights: [
      "Advanced thermodynamics, heat transfer, IC engines and power plant engineering",
      "Relevant for automotive, power, HVAC and research roles",
      "Lab and simulation‑based coursework"
    ]
  },
  {
    name: "M.Tech Energy Management & Sustainability",
    level: "PG",
    stream: "Engineering / Energy",
    duration: "2 years",
    fees: "₹1 – 1.5 Lakhs/year",
    eligibility: "B.Tech/BE in relevant branch (Mechanical/Electrical/Energy) or equivalent",
    avgPackage: "₹4.5 – 6.5 LPA",
    highlights: [
      "Covers renewable energy, energy efficiency and sustainable technologies",
      "Project work around solar, wind and green buildings",
      "Opportunities in energy consulting and sustainability roles"
    ]
  },
  {
    name: "M.Tech Internet of Things (IoT)",
    level: "PG",
    stream: "Engineering & Technology",
    duration: "2 years",
    fees: "₹1 – 1.6 Lakhs/year",
    eligibility: "B.Tech/BE in ECE/CSE/IT or related branches with required CGPA",
    avgPackage: "₹5 – 7 LPA",
    highlights: [
      "Embedded systems, sensors, wireless communication and cloud‑based IoT platforms",
      "Hands‑on projects building IoT prototypes and applications",
      "Prepares for IoT developer, embedded engineer and system architect roles"
    ]
  },
  {
    name: "M.Tech Drone Technology",
    level: "PG",
    stream: "Engineering & Aerospace",
    duration: "2 years",
    fees: "₹1 – 1.6 Lakhs/year",
    eligibility: "B.Tech in Aerospace/Mechanical/ECE/CSE or related field as per program norms",
    avgPackage: "₹5 – 7 LPA (niche domain)",
    highlights: [
      "Specialized program focusing on UAV design, navigation, control and applications",
      "Covers drone regulations, mapping and industrial use‑cases",
      "Scope in defense, surveying, agriculture tech and start‑ups in drone ecosystem"
    ]
  }
]

},

  {
    slug: "graphic-era-dehradun",
    name: "Graphic Era (Deemed to be University)",
    type: "Deemed-to-be University (Private)",
    location: "566/6, Bell Road, Society Area, Clement Town, Dehradun - 248002, Uttarakhand",
    rating: "4.4/5",
    image:
      "/images/geu.webp",
    brochure: "/brochures/geu.pdf",
    cdbrochure: "/brochures/geu.pdf",

    logo: "/images/logo/geu.webp",
 whyusimg: [
"/images/Graphic-Era-University/imgi_10_grafest-day-2-3.webp",
"/images/Graphic-Era-University/imgi_12_grafest-day-4-10.webp",
"/images/Graphic-Era-University/imgi_19_geu-campus-main-front-image.webp"
],
faqs: [
  {
    question: "What is the difference between Graphic Era University and Graphic Era Hill University?",
    answer: "Graphic Era Deemed to be University (GEU) is the main deemed university with higher NIRF rankings. Graphic Era Hill University (GEHU) is a separate state private university established later, with campuses in Dehradun, Bhimtal, and Haldwani."
  },
  {
    question: "What is the highest placement package offered at Graphic Era?",
    answer: "Graphic Era has seen exceptional placements, with the highest package reportedly hitting ₹84.88 LPA in recent years. Top recruiters include Adobe, Google, Amazon, and Morgan Stanley."
  },
  {
    question: "What are the B.Tech fees at Graphic Era University?",
    answer: "The B.Tech tuition fee varies by branch and merit scholarship, typically ranging from ₹2.5 Lakhs to ₹3.2 Lakhs per year. The total 4-year cost is usually between ₹10 Lakhs and ₹14 Lakhs."
  },
  {
    question: "How does the scholarship system work at Graphic Era?",
    answer: "Scholarships are awarded based on Class 12th percentage or JEE Mains scores. The fee waiver can range from 10% to 100% on tuition fees, and it is updated every semester based on the student's CGPA."
  },
  {
    question: "Is Graphic Era University NAAC accredited?",
    answer: "Yes, Graphic Era Deemed to be University is accredited with an 'A+' grade by NAAC. It is also consistently ranked among the top 100 engineering institutions in India by NIRF."
  },
  {
    question: "Does Graphic Era have a dress code or uniform?",
    answer: "Graphic Era University generally does not have a strict uniform for most courses, except for specific programs like Hotel Management. However, decent casual wear is expected, and formal wear is required for presentations and placement drives."
  },
  {
    question: "How are the hostel facilities at Graphic Era?",
    answer: "The university provides on-campus hostels (Chandra Shekhar Azad, Lakshmi Bai, etc.) with AC and Non-AC options. Mess food is vegetarian, and fees range from roughly ₹1.1 Lakhs to ₹1.6 Lakhs per year depending on the room type."
  },
  {
    question: "What is the admission process for B.Tech?",
    answer: "Admission to B.Tech is primarily merit-based on JEE Mains scores or Class 12th PCM percentage. Candidates can apply online or visit the campus for counseling and seat allocation."
  },
  {
    question: "Does Graphic Era offer distance learning programs?",
    answer: "Yes, Graphic Era offers Directorate of Distance and Online Education (DDOE) programs including MBA, BBA, BCA, and B.Com, which are UGC-DEB approved and suitable for working professionals."
  },
  {
    question: "Can I get direct admission in the second year (Lateral Entry)?",
    answer: "Yes, Graphic Era offers lateral entry to B.Tech and some other programs for diploma holders and B.Sc graduates, subject to vacancy and meeting the specific eligibility criteria of the university."
  }
]
,
    aboutImages: [
"/images/Graphic-Era-University/imgi_4_grafest-day-one-4.webp",
"/images/Graphic-Era-University/imgi_4_grafest-day-third-2.webp",
"/images/Graphic-Era-University/imgi_7_grafest-day-one-7.webp"
],
    overview:
      "Graphic Era Dehradun is a reputed deemed-to-be university known for strong engineering, management, computer science, and allied programs, with high placement records and modern campus infrastructure.",
    established: "1997",
    fees_btech: "₹2.5 – 3.8 Lakhs/year (approx.)",
    admissions: {
      examsAccepted:
        "JEE Main / CUET / 10+2 Board Merit (institutional criteria)",
      applicationMode: "Online & Offline",
      applicationFee:
        "₹1,200 – ₹1,500 (approx., check latest on official site)",
      importantDates: [
        "Application Opens: November–December for next session",
        "Last Date to Apply: May–June (varies by year)",
        "Counselling/Admission Rounds: May–July"
      ]
    },
    highlights: [
      { icon: "🏆", label: "NAAC Grade", value: "A+" },
      {
        icon: "📊",
        label: "NIRF Rank",
        value: "#100"
      },
      { icon: "👥", label: "Students", value: "15,000+" },
      { icon: "📚", label: "Programs", value: "100+ " },
      {
        icon: "💼",
        label: "Placement",
        value: "92%"
      },
      {
        icon: "🏢",
        label: "Recruiters",
        value: "250+"
      }
    ],
    eligibility:
      "10+2 with PCM and minimum 45–50% aggregate (as per program) + JEE Main / CUET / Board-based merit as per university norms.",
    placements: {
      highestPackage: "₹61.99 LPA",
      recruitersIndustries:
        "1000+",
      gloriousAlumni:
        "80000+",
      placementRecords:
        "90%",
      recruitersImage: "/images/recruiters/graphic.webp"
    },
    ranking:
      "Recognized among top private universities in Uttarakhand with national-level NIRF presence.",
    ranking_details:
      "- Listed in NIRF for Engineering and University categories in recent cycles.\n- Recognized for high placement outcomes and industry-linked curricula.",
    facts: [
      "Offers wide B.Tech specializations including CSE, AI/ML, Mechanical, Civil, ECE, and more.",
      "Campus includes advanced laboratories, computing facilities, libraries, and residential hostels.",
      "Strong placement cell with multiple offers above ₹30 LPA in recent years.",
      "Collaborations and MOUs with industry partners for internships and live projects."
    ],
    whyChooseUsData: [
      {
        id: 1,
        title: "High-End Tech Placements",
        description:
          "Multiple B.Tech CSE students have received packages above ₹40–60 LPA from global product companies in recent drives.",
        imageUrl:
          "https://images.unsplash.com/photo-1542744094-3a31f272c490?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80"
      },
      {
        id: 2,
        title: "Modern Campus & Facilities",
        description:
          "Smart classrooms, advanced labs, Wi-Fi campus, and extensive library resources support hands-on, industry-oriented learning.",
        imageUrl:
          "https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80"
      },
      {
        id: 3,
        title: "Industry-Aligned Curriculum",
        description:
          "Programs are frequently updated to align with current technologies, certifications, and industry skill requirements.",
        imageUrl:
          "https://images.unsplash.com/photo-1545239351-1141bd82e8a6?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80"
      }
    ],
    galleryImages: [
      "/images/Graphic-Era-University/imgi_10_grafest-day-2-3.webp",
"/images/Graphic-Era-University/imgi_12_grafest-day-4-10.webp",
"/images/Graphic-Era-University/imgi_19_geu-campus-main-front-image.webp",
"/images/Graphic-Era-University/imgi_3_grafest-day-2-1.webp",
"/images/Graphic-Era-University/imgi_4_grafest-day-2-2.webp",
"/images/Graphic-Era-University/imgi_4_grafest-day-one-4.webp",
"/images/Graphic-Era-University/imgi_4_grafest-day-third-2.webp",
"/images/Graphic-Era-University/imgi_7_grafest-day-one-7.webp",
      
     

    ],
     // GRAPHIC ERA – 15 popular courses
courses: [
  {
    name: "B.Tech Computer Science and Engineering (CSE)",
    duration: "4 years",
    eligibility:
      "10+2 with PCM, minimum 60% (program-specific) + JEE Main / CUET / Board merit.",
    approxFees: "₹3 – 3.8 Lakhs/year (approx.).",
    keyHighlights: [
      "Flagship engineering program with strong placements and multiple CSE specializations.",
      "High intake and industry demand across software, product, and IT services roles."
    ]
  },
  {
    name: "B.Tech CSE (AI & Machine Learning)",
    duration: "4 years",
    eligibility: "10+2 with PCM, minimum 60% + JEE Main / institutional criteria.",
    approxFees: "₹3.5 – 3.8 Lakhs/year (approx.).",
    keyHighlights: [
      "Specialization in AI, ML, deep learning, and related emerging technologies.",
      "Prepares students for AI/ML engineer and data-driven tech roles."
    ]
  },
  {
    name: "B.Tech CSE (AI & Data Science)",
    duration: "4 years",
    eligibility: "10+2 with PCM, minimum 60% + JEE Main / institutional criteria.",
    approxFees: "₹3.5 – 3.8 Lakhs/year (approx.).",
    keyHighlights: [
      "Focus on data science, big data, analytics, and data engineering.",
      "Project-based learning with modern tools and platforms."
    ]
  },
  {
    name: "B.Tech in Civil / Mechanical / ECE / EEE",
    duration: "4 years",
    eligibility: "10+2 with PCM, 45–50% minimum as per branch.",
    approxFees: "₹2.5 – 3.2 Lakhs/year (approx., branch-wise).",
    keyHighlights: [
      "Core engineering branches with modern labs and workshop facilities.",
      "Recruitment from core and infrastructure companies."
    ]
  },
  {
    name: "B.Tech in Aerospace / Petroleum / Biotechnology",
    duration: "4 years",
    eligibility: "10+2 with PCM, minimum marks as per university norms.",
    approxFees: "₹3 – 3.5 Lakhs/year (approx.).",
    keyHighlights: [
      "Domain-specific B.Tech options in high-growth, niche sectors.",
      "Curriculum aligned with industry practices and regulations."
    ]
  },
  {
    name: "BCA (Bachelor of Computer Applications)",
    duration: "3 years",
    eligibility:
      "10+2 (any stream; Mathematics/Computer Science preferred) with required aggregate.",
    approxFees: "₹90,000 – 1.5 Lakhs/year (approx.).",
    keyHighlights: [
      "Popular UG IT program with options for advanced tracks like AI & Data Science, Cybersecurity.",
      "Clear progression to MCA, M.Sc IT, and software roles."
    ]
  },
  {
    name: "BCA (AI & Data Science / Cybersecurity – Industry Integrated)",
    duration: "3 years",
    eligibility: "10+2 in any stream with Maths/CS preferred.",
    approxFees: "Higher band within BCA fee range (industry-integrated).",
    keyHighlights: [
      "Skill-focused curriculum with industry projects and integrated training.",
      "Designed for high-employability IT profiles at the UG level."
    ]
  },
  {
    name: "B.Sc IT / B.Sc Computer Science",
    duration: "3 years",
    eligibility: "10+2 (Science/Maths) with required aggregate.",
    approxFees: "₹80,000 – 1.5 Lakhs/year (approx.).",
    keyHighlights: [
      "Strong foundation in computing, networking, and software systems.",
      "Alternative to B.Tech for students preferring a science-focused route."
    ]
  },
  {
    name: "B.Sc Biotechnology / Microbiology / Food Technology",
    duration: "3 years",
    eligibility: "10+2 (PCB/PCM) with required marks.",
    approxFees: "₹80,000 – 1.5 Lakhs/year (approx.).",
    keyHighlights: [
      "Popular life-science programs with laboratory-intensive training.",
      "Opportunities in biotech, food industry, and research."
    ]
  },
  {
    name: "BBA (General / AI & Data Science / International Finance / Aviation / Digital Marketing)",
    duration: "3 years",
    eligibility: "10+2 in any stream with 45–50% aggregate.",
    approxFees: "₹1 – 1.8 Lakhs/year (approx.).",
    keyHighlights: [
      "Large portfolio of BBA specializations for different career tracks.",
      "Strong base for MBA and management careers."
    ]
  },
  {
    name: "B.Com / B.Com (Hons)",
    duration: "3 years",
    eligibility: "10+2 (Commerce/Any stream) with required marks.",
    approxFees: "₹70,000 – 1.5 Lakhs/year (approx.).",
    keyHighlights: [
      "Commerce-focused programs covering accounting, finance, and taxation.",
      "Good pathway to CA, CMA, CS, MBA, and banking roles."
    ]
  },
  {
    name: "BPT (Bachelor of Physiotherapy)",
    duration: "4.5 years",
    eligibility: "10+2 with PCB and minimum qualifying marks.",
    approxFees: "As per health-science fee band (check latest structure).",
    keyHighlights: [
      "Popular health-science program with clinical training.",
      "Opportunities in hospitals, clinics, and sports rehab."
    ]
  },
  {
    name: "BMLT / BMRIT (Medical Lab & Radiology)",
    duration: "3–4 years",
    eligibility: "10+2 (Science) with PCB/PCM.",
    approxFees: "Program-specific health-science fee band.",
    keyHighlights: [
      "Allied health courses in lab technology and imaging.",
      "High demand in diagnostic centers and hospitals."
    ]
  },
  {
    name: "BA (Hons) English",
    duration: "3 years"
  },
  {
    name: "MA English",
    duration: "2 years"
  },
  {
    name: "B.Des Fashion Design",
    duration: "4 years"
  },
  
  {
    name: "MBA (General, Impact, and Specialized MBAs)",
    duration: "2 years",
    eligibility:
      "Graduation with minimum 50% marks; scores in CAT/MAT/XAT/CMAT or university test.",
    approxFees: "₹3 – 5 Lakhs total (approx.).",
    keyHighlights: [
      "Offered in 15+ specializations like Finance, HR, Marketing, Logistics, Business Analytics.",
      "Second-most popular program after B.Tech with large intake and strong placements."
    ]
  },
  {
    name: "MCA / M.Tech / M.Sc (IT, Biotechnology, Microbiology, etc.)",
    duration: "2 years",
    eligibility: "Relevant UG degree in the same/related discipline with required marks.",
    approxFees: "PG-level fee band (varies by program).",
    keyHighlights: [
      "Popular PG options for specialization in IT, engineering, and sciences.",
      "Enhances research and advanced technical career prospects."
    ]
  }
]

  },
  {
    slug: "sgrru-dehradun",
    name: "Shri Guru Ram Rai University (SGRRU)",
location: "Patel Nagar, Dehradun - 248001, Uttarakhand",
    type: "Private University",
    rating: "4.0/5",
    image:
      "/images/sgr.webp",
    brochure: "/brochures/sgrru.pdf",
    cdbrochure: "/brochures/sgrru.pdf",

    logo: "/images/logo/sgr.webp",
whyusimg: [
"/images/SGRR-University/imgi_10_121_auditorium.webp",
"/images/SGRR-University/imgi_130_1583567701why-sgrru-4-full.webp",
"/images/SGRR-University/imgi_142_1629968091infrastructure.webp"
],
faqs: [
  {
    question: "What is the history of Shri Guru Ram Rai (SGRR) University?",
    answer: "SGRR University was established in 2017, but its roots go back to the SGRR Education Mission founded in 1952. It is managed by the Darbar Sahib, which has a legacy of over 300 years in serving society through education and healthcare."
  },
  {
    question: "Is SGRR University good for medical and paramedical courses?",
    answer: "Yes, SGRR is excellent for medical fields as it is attached to the 1500-bedded Shri Mahant Indiresh Hospital. It offers MBBS, Nursing, Physiotherapy, and Pharmaceutical sciences with hands-on clinical exposure."
  },
  {
    question: "What is the fee range for the MBA program at SGRR?",
    answer: "The MBA fees at SGRR University are quite affordable compared to other private colleges, typically ranging around ₹1.5 Lakhs to ₹2 Lakhs per year. The total program cost is approximately ₹3 Lakhs to ₹4 Lakhs."
  },
  {
    question: "Does SGRR University offer Ph.D. programs?",
    answer: "Yes, SGRR University offers Ph.D. programs in various disciplines including Management, Education, Science, Pharmacy, and Humanities, following UGC guidelines with an entrance test and interview."
  },
  {
    question: "Are there hostel facilities available on campus?",
    answer: "SGRR provides separate hostel facilities for boys and girls. The hostels are basic but comfortable, with fees ranging from ₹75,000 to ₹1 Lakh per year including mess charges."
  },
  {
    question: "What are the eligibility criteria for B.Sc Agriculture?",
    answer: "For B.Sc Agriculture, candidates must have passed 10+2 with Physics, Chemistry, and Biology/Mathematics/Agriculture with at least 45-50% aggregate marks. Admission is often merit-based."
  },
  {
    question: "Does SGRR University have its own entrance exam?",
    answer: "SGRR conducts its own entrance exam or counseling for certain professional courses. However, for most UG courses, admission is based on merit in the qualifying examination (Class 12th marks)."
  },
  {
    question: "How is the campus environment at SGRR?",
    answer: "The campus is spread over a large area in the heart of Dehradun (Patel Nagar). It has a disciplined, traditional academic atmosphere with a focus on values, alongside modern labs and libraries."
  },
  {
    question: "What recruiters visit SGRR University?",
    answer: "Common recruiters include Lupin, Sun Pharma, Fortis, Max Hospital (for healthcare), and companies like HCL, Wipro, and Axis Bank for management and IT streams. Average packages are usually between ₹3-5 LPA."
  },
  {
    question: "Is SGRR University recognized by UGC?",
    answer: "Yes, Shri Guru Ram Rai University is established under the State Act and is recognized by the University Grants Commission (UGC) under section 2(f), making its degrees valid for government jobs and higher studies."
  }
]
,
    aboutImages: [
"/images/SGRR-University/imgi_8_315imguf_labs.webp",
"/images/SGRR-University/imgi_8_316imguf_library.webp",
"/images/SGRR-University/imgi_9_306imguf_residential.webp"
],
    overview:
      "Shri Guru Ram Rai University Dehradun is a multidisciplinary private university offering programs in engineering, health sciences, management, and humanities with a focus on affordable education and regional outreach.",
    established: "2017",
    fees_btech: "₹1 – 1.5 Lakhs/year (approx., based on course and year).",
    admissions: {
      examsAccepted:
        "10+2 merit-based admission for many programs; some technical/health programs may consider entrance or university-level tests.",
      applicationMode: "Online & Offline (as per university portal).",
      applicationFee:
        "₹1,000 – ₹1,500 (typical range; confirm on official portal).",
      importantDates: [
        "Application Window: Typically opens around March–April.",
        "Last Date to Apply: As notified for each session (commonly June–July).",
        "Counselling/Admission: Conducted after merit list / entrance results."
      ]
    },
 highlights: [
      { icon: "🏆", label: "NAAC Grade", value: "A" },
      {
        icon: "📊",
        label: "NIRF Rank",
        value: "NA"
      },
      { icon: "👥", label: "Students", value: "10,000+" },
      { icon: "📚", label: "Programs", value: "45+ " },
      {
        icon: "💼",
        label: "Placement",
        value: "85%"
      },
      {
        icon: "🏢",
        label: "Recruiters",
        value: "300+"
      }
    ],
    eligibility:
      "For B.Tech: 10+2 with Physics, Mathematics, and Chemistry/Computer Science and minimum marks as per university norms; similar 10+2 criteria for other UG programs.",
    placements: {
      highestPackage:
        "₹10 LPA ",
      recruitersIndustries:
        "300+",
      gloriousAlumni:
        "100000+",
      placementRecords:
        "92%",
      recruitersImage: "/images/recruiters/sgrru.webp"
    },
    ranking:
      "Regionally known private university in Dehradun with focus on medical and allied sciences; not yet in top national NIRF brackets like older universities.",
    ranking_details:
      "- Recognized for health and paramedical education in the region.\n- Building reputation in engineering and management through industry linkages and placements.",
    facts: [
      "Offers programs in B.Tech, Nursing, Pharmacy, Physiotherapy, Management, Science, and Humanities.",
      "Provides fee waivers and scholarships based on merit and special schemes.",
      "Has its own teaching hospital and associated facilities for medical and allied programs."
    ],
    whyChooseUsData: [
      {
        id: 1,
        title: "Affordable Education",
        description:
          "Course fees are relatively lower than many private universities in the region, with scholarships available for eligible students.",
        imageUrl:
          "https://images.unsplash.com/photo-1556740749-887f6717d7e4?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80"
      },
      {
        id: 2,
        title: "Healthcare & Allied Focus",
        description:
          "Strong emphasis on healthcare, pharmacy, and paramedical courses with clinical exposure and hospital linkages.",
        imageUrl:
          "https://images.unsplash.com/photo-1584466977773-e625c37cdd50?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80"
      },
      {
        id: 3,
        title: "Multi-Disciplinary Campus",
        description:
          "Students from engineering, management, science, and health disciplines share a collaborative learning environment.",
        imageUrl:
          "https://images.unsplash.com/photo-1523580846011-1e8a1a97f6c1?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80"
      }
    ],
    galleryImages: [
      "/images/SGRR-University/imgi_10_121_auditorium.webp",
"/images/SGRR-University/imgi_10_122_classroom988.webp",
"/images/SGRR-University/imgi_10_126_library.webp",
"/images/SGRR-University/imgi_130_1583567701why-sgrru-4-full.webp",
"/images/SGRR-University/imgi_142_1629968091infrastructure.webp",
"/images/SGRR-University/imgi_143_1629968091it_overview.webp",
"/images/SGRR-University/imgi_153_162996903483pg_Classroom.webp",
"/images/SGRR-University/imgi_15_127_other.webp",
"/images/SGRR-University/imgi_161_1000034805.webp",
"/images/SGRR-University/imgi_35_IMG_20221209_132557.webp",
"/images/SGRR-University/imgi_3_menu-item-aboutus.webp",
"/images/SGRR-University/imgi_6_menu-item-student-life.webp",
"/images/SGRR-University/imgi_8_311imguf_auditorium.webp",
"/images/SGRR-University/imgi_8_312imguf_classroom.webp",
"/images/SGRR-University/imgi_8_315imguf_labs.webp",
"/images/SGRR-University/imgi_8_316imguf_library.webp",
"/images/SGRR-University/imgi_9_306imguf_residential.webp",
   "/images/sgr1.webp",
     "/images/sgr2.webp",
   "/images/sgr4.webp",
   "/images/sgr3.webp",
   "/images/sgr5.webp",

    ],
    courses: [
{
name: "BA History",
duration: "3 years"
},
{
name: "BA Economics",
duration: "3 years"
},
{
name: "BA English",
duration: "3 years"
},
{
name: "B.Sc Botany",
duration: "3 years"
},
{
name: "B.Sc Zoology",
duration: "3 years"
},
{
name: "B.Sc Chemistry",
duration: "3 years"
},
{
name: "B.Sc Computer Science",
duration: "3 years"
},
{
name: "B.Sc Mathematics",
duration: "3 years"
},
{
name: "B.Sc Physics",
duration: "3 years"
},
{
name: "B.Sc Geology",
duration: "3 years"
},
{
name: "MA History",
duration: "2 years"
},
{
name: "MA Economics",
duration: "2 years"
},
{
name: "MA English",
duration: "2 years"
},
{
name: "M.Sc Physics",
duration: "2 years"
},
{
name: "M.Sc Chemistry",
duration: "2 years"
},
{
name: "M.Sc Mathematics",
duration: "2 years"
},
{
name: "PhD Physics",
duration: "3-6 years"
},
{
name: "PhD Economics",
duration: "3-6 years"
},
{
name: "PhD Geology",
duration: "3-6 years"
},
{
name: "PhD English",
duration: "3-6 years"
}
]
  },




  {
   
  slug: "hit-college",
  name: "Himalayan Institute of Technology – [HIT]",
location: "Near Central Excise Office, Haridwar Road, Dehradun - 248001, Uttarakhand",
  type: "Private College",
  rating: "4.2/5",
image: "/images/hit.webp",
logo : "/images/logo/hit.webp",
whyusimg: [
  "/images/whyus/hit1.webp",
  "/images/whyus/hit2.webp",
  "/images/whyus/hti3.webp",
],
faqs: [
  {
    question: "Is HIT Dehradun a university or an affiliated college?",
    answer: "Himalayan Institute of Technology (HIT) is an affiliated college. It is affiliated with HNB Garhwal University (a Central University) and Sri Dev Suman Uttarakhand University for various courses."
  },
  {
    question: "What are the most popular courses at HIT Dehradun?",
    answer: "HIT is best known for its BHM (Hotel Management), B.Sc Agriculture, B.Sc Forestry, and BCA programs. These courses focus heavily on practical skills and industry exposure."
  },
  {
    question: "What is the fee structure for Hotel Management (BHM)?",
    answer: "The fees for the Bachelor of Hotel Management (BHM) are very competitive, typically around ₹70,000 to ₹85,000 per year. This makes it an affordable option for students seeking a career in hospitality."
  },
  {
    question: "Does HIT provide placement assistance?",
    answer: "Yes, HIT has a dedicated placement cell. For Hotel Management, they place students in top chains like Taj, Oberoi, and Marriott. For IT and Management, companies like Wipro and Genpact are regular recruiters."
  },
  {
    question: "Where is the HIT campus located?",
    answer: "The campus is located in the peaceful Jolly Grant area, near the Dehradun Airport. This location offers a serene environment for studies, away from the city's hustle but well-connected by road."
  },
  {
    question: "Are there hostel facilities at HIT?",
    answer: "Yes, HIT offers separate hostel accommodation for boys and girls. The hostels provide basic amenities, hygienic food, and a secure environment. Hostel fees are approximately ₹70,000 - ₹80,000 per year."
  },
  {
    question: "Is admission to HIT merit-based or entrance-based?",
    answer: "Admission to most undergraduate courses at HIT is direct, based on merit in Class 12th. There is usually no separate entrance exam, but early registration is recommended due to limited seats."
  },
  {
    question: "Does HIT offer practical training for Agriculture students?",
    answer: "Yes, HIT has its own agricultural land and tie-ups with local farms where B.Sc Agriculture and Forestry students undergo practical field training and research work as part of their curriculum."
  },
  {
    question: "What documents are required for admission at HIT?",
    answer: "Required documents include Class 10th and 12th marksheets, Transfer Certificate (TC), Migration Certificate, Character Certificate, Aadhaar Card, and passport-sized photographs."
  },
  {
    question: "Is HIT Dehradun approved by AICTE?",
    answer: "HIT runs courses recognized by the UGC (through its affiliating universities). For specific technical courses, it adheres to the norms required by the respective statutory bodies."
  }
]
,
aboutImages: [
"/images/HIT-College/imgi_8_817-class-room-7.webp",
"/images/HIT-College/imgi_9_3.webp",
"/images/HIT-College/imgi_9_slider-4.webp"
],
brochure: "/brochures/hit.pdf",
cdbrochure: "/brochures/hit.pdf",

  overview:
    "Himalayan Institute of Technology (HIT) Dehradun is a private college offering undergraduate and postgraduate programs in management, commerce, computer applications, hotel management, agriculture and life sciences. The institute focuses on skill‑based learning, industry exposure and career‑oriented training.",
galleryImages: [
"/images/HIT-College/imgi_10_4.webp",
"/images/HIT-College/imgi_11_5.webp",
"/images/HIT-College/imgi_12_6.webp",
"/images/HIT-College/imgi_14_8.webp",
"/images/HIT-College/imgi_17_11.webp",

"/images/HIT-College/imgi_21_15.webp",
"/images/HIT-College/imgi_22_16.webp",
"/images/HIT-College/imgi_28_22.webp",
"/images/HIT-College/imgi_30_24.webp",

"/images/HIT-College/imgi_8_2.webp",
"/images/HIT-College/imgi_8_817_class-room-7.webp",
"/images/HIT-College/imgi_9_3.webp",
"/images/HIT-College/imgi_9_slider-4.webp",


"/images/HIT-College/imgi_5_slider-5.webp",
"/images/HIT-College/imgi_6_slider-1.webp",
"/images/HIT-College/imgi_7_1.webp",
"/images/HIT-College/imgi_7_934_hit-infra1.webp",


],
highlights: [
  { icon: "🏆", label: "NAAC Grade", value: "A" },
  { icon: "📊", label: "NIRF Rank", value: "N/A" },
  { icon: "👥", label: "Students", value: "5k+" },
  { icon: "📚", label: "Programs", value: "60+" },
  { icon: "💼", label: "Placement", value: "70-80%" },
  { icon: "🏢", label: "Recruiters", value: "150+" },
],
placements: {
  highestPackage: "₹9 LPA",
  recruitersIndustries: "30+",
  gloriousAlumni: "2100+",
  placementRecords: "85%",
  recruitersImage: "/images/recruiters/hit.webp"
},
whyChooseUsData: [
  {
    id: 1,
    title: 'Scenic Mountain Campus',
    description: 'Located in breathtaking Dhauladhar Range surroundings providing a serene and distraction-free learning environment.',
    imageUrl: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 2,
    title: 'Fully Digital Campus Infrastructure',
    description: 'State-of-the-art e-library, e-learning facilities, and fully equipped functional labs & workshops.',
    imageUrl: 'https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 3,
    title: 'Quality Placement Support',
    description: 'Dedicated Training & Placement Cell working with MNCs and reputed organizations for career development.',
    imageUrl: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
],
  established: "2001",
   // no B.Tech here, you can hide this on UI if empty
  admissions: {
    examsAccepted: "Institute / university‑level entrance tests and 10+2 / graduation merit, depending on program.",
    applicationMode: "Online application form and offline campus application.",
    applicationFee: "₹800 – ₹1,000 (approx., program‑wise).",
    importantDates: [
      "Applications typically open: February–March",
      "First counselling / admission rounds: May–June",
      "Late admission window (with limited seats): July–August"
    ]
  },

  eligibility:
    "Eligibility varies by program; UG courses generally require 10+2 in relevant stream with 45–50%+ marks, while PG courses require a relevant bachelor’s degree with 50%+.",
  topRecruiters:
    "Hospitality chains, hotels and resorts, agro‑based companies, FMCG and retail firms, banks, IT & BPO companies and regional industries.",
  placement_highest: "₹8 – 10 LPA (for top management / hospitality profiles reported in recent years).",
  placement_avg: "₹3 – 4.5 LPA (across major UG and PG programs).",
  placement_perc: "70–80% (for interested and eligible students across flagship courses).",

  ranking:
    "Known regionally in Dehradun for hotel management, agriculture and applied sciences with a focus on affordable career‑oriented education.",

  ranking_details:
    "• Recognized as a regional institute for Hotel Management, Agriculture and Applied Sciences in Dehradun.\n• Offers industry‑linked training and internships in hospitality, IT, agriculture and allied sectors.\n• Provides a mix of professional and traditional degrees catering to students from multiple streams.",

  facts: [
    "Offers a combination of professional programs like BBA, BCA, BHM and traditional degrees like B.Sc, B.Com (Hons.), M.Sc and M.Com.",
    "Focus on practical learning through internships, industrial visits and field work in hospitality, agriculture and laboratories.",
    "Student‑centric campus environment with clubs, fests and co‑curricular activities.",
    "Emphasis on soft‑skills, personality development and interview preparation for placements."
  ],

  courses: [
{
name: "BCA",
duration: "3 years"
},
{
name: "BBA",
duration: "3 years"
},
{
name: "MBA",
duration: "2 years"
},
{
name: "B.Sc Agriculture",
duration: "4 years"
},
{
name: "B.Sc Forestry",
duration: "4 years"
},
{
name: "B.Sc Horticulture",
duration: "4 years"
},
{
name: "B.Sc IT",
duration: "3 years"
},
{
name: "B.Sc Computer Science",
duration: "3 years"
},
{
name: "B.Sc Biotechnology",
duration: "3 years"
},
{
name: "B.Sc Microbiology",
duration: "3 years"
},
{
name: "B.Sc Food Technology",
duration: "3 years"
},
{
name: "B.Sc Fashion Design",
duration: "3 years"
},
{
name: "B.Sc Interior Design",
duration: "3 years"
},
{
name: "B.Sc Hotel Management",
duration: "3 years"
},
{
name: "B.Sc Yoga",
duration: "3 years"
},
{
name: "M.Sc Agriculture",
duration: "2 years"
},
{
name: "M.Sc Horticulture",
duration: "2 years"
},
{
name: "M.Sc Forestry",
duration: "2 years"
},
{
name: "M.Sc Biotechnology",
duration: "2 years"
},
{
name: "M.Sc Microbiology",
duration: "2 years"
}
]
  
},{
  
  slug: "dbit-college",
  name: "Dev Bhoomi Uttarakhand University [DBUU]",
location: "Dev Bhoomi Campus, Chakrata Road, Navgaon, Manduwala, Dehradun - 248007, Uttarakhand",  type: "Private Engineering College",
  rating: "3.9/5",
  logo : "/images/logo/dbuu.webp",
whyusimg: [
  "/images/whyus/dbuu1.webp",
  "/images/whyus/dbuu2.webp",
  "/images/whyus/dbuu3.webp"
],

feeStructureImage: [
  "/images/fee/dbuu-1.webp", 
  "/images/fee/dbuu-2.webp"
],
faqs: [
  {
    question: "Is DBIT different from Dev Bhoomi Uttarakhand University (DBUU)?",
    answer: "DBIT (Dev Bhoomi Institute of Technology) was the flagship institute that has now transformed into Dev Bhoomi Uttarakhand University (DBUU). The legacy of DBIT continues under the university framework, offering the same engineering excellence with broader university privileges."
  },
  {
    question: "What is the highest placement package at DBIT/DBUU?",
    answer: "The highest placement package recorded recently was ₹40 LPA. The university has a strong placement cell that ensures around 80% placement rate, with companies like NuVeda, Tommy Hilfiger, and Rubico IT visiting the campus."
  },
  {
    question: "What are the B.Tech fees at Dev Bhoomi?",
    answer: "B.Tech fees generally range between ₹1.5 Lakhs and ₹1.65 Lakhs per year depending on the specialization. The total 4-year fee comes to approximately ₹6 Lakhs to ₹6.6 Lakhs, which is quite affordable compared to other private universities."
  },
  {
    question: "Are there scholarship options available?",
    answer: "Yes, DBUU offers 'Pinak' scholarships based on academic performance in 10+2 or JEE Mains, and for Uttarakhand domicile students (up to 25% fee waiver). There are also scholarships for girl students and martyrs' wards."
  },
  {
    question: "Does the college provide transportation facilities?",
    answer: "Yes, the university has a fleet of buses covering Dehradun, Vikas Nagar, and Paonta Sahib areas. The transport fee is separate and varies based on the pickup point distance."
  },
  {
    question: "What entrance exams are accepted for admission?",
    answer: "For B.Tech, JEE Mains scores are preferred. For MBA, CAT/MAT/CMAT scores are accepted. However, the university also conducts its own entrance process and accepts direct admissions based on merit for many courses."
  },
  {
    question: "How is the hostel facility at DBIT?",
    answer: "The campus has on-campus hostels for boys and girls with 24/7 Wi-Fi, gym, and mess facilities. Hostel fees range from ₹80,000 to ₹1.10 Lakhs per year depending on the room category (2-seater/3-seater)."
  },
  {
    question: "Is attendance strict at Dev Bhoomi?",
    answer: "Yes, the university maintains a strict attendance policy requiring 75% minimum attendance to appear in end-semester exams. Regular monitoring is done, and parents are informed about shortages."
  },
  {
    question: "What other courses are popular besides Engineering?",
    answer: "Apart from B.Tech, popular courses include B.Sc Agriculture, B.Pharma, BCA, BHM (Hotel Management), and MBA. The BAMS (Ayurveda) course is also highly sought after under the medical wing."
  },
  {
    question: "Is the campus ragging-free?",
    answer: "Yes, Dev Bhoomi has a zero-tolerance policy towards ragging. It is a fully ragging-free campus with an active anti-ragging committee and squad to ensure student safety."
  }
]
,
aboutImages: [
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_6_dbuu-1.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_7_dbuu-2.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_8_dbuu-3.webp"
],
  brochure: "/brochures/dbuu.pdf",
  cdbrochure: "/brochures/dbuu.pdf",

image : "/images/dbuu.webp",
  overview: "Dev Bhoomi Institute of Technology (DBIT) Dehradun offers B.Tech programs in CSE, IT, Civil, Mechanical, Aerospace and specializations with focus on engineering fundamentals, placements and industry training.",
  established: "2005",
  fees_btech: "₹1.3 – 1.8 Lakhs/year",
  admissions: {
    examsAccepted: "JEE Main / DBIT Entrance / 10+2 Merit",
    applicationMode: "Online & Offline through DBIT portal",
    applicationFee: "₹1,200",
    importantDates: [
      "Application Opens: December–January",
      "Counselling: April–July"
    ]
  },
highlights: [
  { icon: "🏆", label: "NAAC Grade", value: "A+" },
  { icon: "📊", label: "NIRF Rank", value: "#151-200" },
  { icon: "👥", label: "Students", value: "6k+" },
  { icon: "📚", label: "Programs", value: "70+" },
  { icon: "💼", label: "Placement", value: "75-80%" },
  { icon: "🏢", label: "Recruiters", value: "198+" },
],
  galleryImages: [
    "/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_10_dbuu-5.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_11_dbuu-6.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_13_green-campus-11.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_14_green-campus-1.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_16_green-campus-3.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_20_green-campus-7.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_21_green-campus-8.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_22_green-campus-9.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_28_sport-3.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_30_22.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_30_smart-3.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_31_smart-1.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_33_smart-4.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_35_canteen-1.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_36_canteen-2.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_39_Hall1.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_40_Library1.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_4_campus-life-dbuu.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_62_dbuu-campus-webp-1.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_63_dbuu-campus-webp-1.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_6_dbuu-1.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_7_dbuu-2.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_8_dbuu-3.webp",
"/images/Dev-Bhoomi-Uttarakhand-University-DBUU/imgi_9_dbuu-4.webp",

   
  ],
  placements: {
  highestPackage: "₹40 LPA",
  recruitersIndustries: "850+",
  gloriousAlumni: "17,500+",
  placementRecords: "80%",
  recruitersImage: "/images/recruiters/dbuu.webp"
},
whyChooseUsData: [
  {
    id: 1,
    title: 'State-of-the-Art Laboratories',
    description: 'Advanced labs equipped with latest technology, modern gadgets, and comprehensive measuring instruments for practical learning.',
    imageUrl: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 2,
    title: 'Premier Technical Education',
    description: 'Accredited engineering institute with industry-aligned curriculum and recognized quality standards in technical education.',
    imageUrl: 'https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 3,
    title: 'Strong Placement Records',
    description: '40 LPA highest package with 850+ recruiter industries and 80% placement rate ensuring career success.',
    imageUrl: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
],
  eligibility: "10+2 with PCM, 50% aggregate (45% for reserved categories)",
  topRecruiters: "TCS, Wipro, Infosys, Capgemini, HCL, Tech Mahindra",
  placement_highest: "₹50 LPA",
  placement_avg: "₹4–6 LPA",
  placement_perc: "75–80%",
  ranking: "Top engineering college in Dehradun with strong tech placements",
  ranking_details: "• Affiliated to Dev Bhoomi Uttarakhand University\n• NAAC accredited parent university\n• Consistent placement improvement",
  facts: [
    "B.Tech specializations in AI/ML, Cyber Security, Data Science",
    "Modern labs, workshops, Wi-Fi campus",
    "Active placement cell with 100+ companies",
    "Technical clubs and hackathons",
    "Hostel and sports facilities available"
  ],
  courses: [
    {
      name: "B.Tech Computer Science & Engineering",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹1.4 – 1.8 Lakhs/year",
      eligibility: "10+2 PCM 50%+ JEE Main/merit",
      avgPackage: "₹4.5–6 LPA",
      highlights: [
        "Core CSE curriculum with programming focus",
        "Coding clubs and placement training",
        "Software developer roles"
      ]
    },
    {
      name: "B.Tech CSE Artificial Intelligence & ML",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹1.5 – 1.9 Lakhs/year",
      eligibility: "10+2 PCM 50%+",
      avgPackage: "₹5–7 LPA",
      highlights: [
        "AI/ML algorithms and Python",
        "Machine learning projects",
        "AI engineer roles"
      ]
    },
    {
      name: "B.Tech CSE Cyber Security",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹1.5 – 1.9 Lakhs/year",
      eligibility: "10+2 PCM 50%",
      avgPackage: "₹4.5–6.5 LPA",
      highlights: [
        "Ethical hacking and cryptography",
        "Security labs and tools",
        "Cyber security careers"
      ]
    },
    {
      name: "B.Tech Civil Engineering",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹1.3 – 1.7 Lakhs/year",
      eligibility: "10+2 PCM 50%",
      avgPackage: "₹3.5–5 LPA",
      highlights: [
        "Structural and geotechnical engineering",
        "Design software training",
        "Construction industry roles"
      ]
    },
    {
      name: "B.Tech Mechanical Engineering",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹1.3 – 1.7 Lakhs/year",
      eligibility: "10+2 PCM 50%",
      avgPackage: "₹3.5–5 LPA",
      highlights: [
        "Design manufacturing thermal sciences",
        "Workshop training",
        "Core engineering roles"
      ]
    },
    {
      name: "B.Tech Aerospace Engineering",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹1.4 – 1.9 Lakhs/year",
      eligibility: "10+2 PCM 55%",
      avgPackage: "₹4–6 LPA",
      highlights: [
        "Aerodynamics propulsion UAV design",
        "Aerospace projects",
        "Defense aviation careers"
      ]
    },
    {
      name: "B.Tech Electronics & Communication",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹1.4 – 1.8 Lakhs/year",
      eligibility: "10+2 PCM 50%",
      avgPackage: "₹4–5.5 LPA",
      highlights: [
        "Embedded systems communication",
        "IoT and VLSI focus",
        "Electronics industry roles"
      ]
    },
    {
      name: "BCA",
      level: "UG",
      stream: "Computer Applications",
      duration: "3 years",
      fees: "₹80k–1.2 Lakhs/year",
      eligibility: "10+2 with Maths 50%",
      avgPackage: "₹3.5–5 LPA",
      highlights: [
        "Programming web development",
        "IT support roles",
        "MCA preparation"
      ]
    }
  ]
},
{
  slug: "grd-college",
  name: "GRD Institute of Management and Technology (GRD IMT)",
location: "214, Rajpur Road, Dehradun - 248009, Uttarakhand",
  type: "Private Institute",
  rating: "3.5/5",
image : "/images/grd.webp",
logo : "/images/logo/grd.webp",
whyusimg: [
  "/images/whyus/grd1.webp",
  "/images/whyus/grd2.webp",
  "/images/whyus/grd3.webp",
],faqs: [
  {
    question: "Who is the GRD Institute named after?",
    answer: "The institute is named after Guru Ram Das, the fourth Sikh Guru. It operates under the aegis of the Guru Ram Das Educational Trust, emphasizing values of service and humility alongside technical education."
  },
  {
    question: "What are the main courses offered at GRD Institute?",
    answer: "GRD offers a wide range of courses including B.Tech (CSE, ME, CE, EE), B.Pharma, M.Pharma, MBA, and Polytechnic diplomas. It is particularly known for its Pharmacy and Management programs."
  },
  {
    question: "How are the placements at GRD Institute?",
    answer: "Placements are decent, with a focus on core engineering and pharma sectors. Average packages range from ₹3.5 LPA to ₹5 LPA. Regular recruiters include Cipla, Sun Pharma, and mid-sized IT firms."
  },
  {
    question: "What is the fee structure for B.Pharma?",
    answer: "The B.Pharma fee is approximately ₹1 Lakh to ₹1.10 Lakhs per year. The course is approved by the Pharmacy Council of India (PCI) and AICTE, ensuring it meets all regulatory standards."
  },
  {
    question: "Is GRD Institute affiliated with any university?",
    answer: "Yes, the technical courses (B.Tech, MBA) are affiliated with Uttarakhand Technical University (UTU), and the Pharmacy courses are affiliated with UTU and approved by PCI."
  },
  {
    question: "Does the college have a uniform code?",
    answer: "Yes, GRD Institute has a strict uniform code for all students to ensure equality and discipline. Students are expected to wear the prescribed uniform on all working days."
  },
  {
    question: "Are hostel facilities available for outstation students?",
    answer: "Yes, there are separate hostels for boys and girls within the campus. The hostel fee is moderate, ranging from ₹70,000 to ₹85,000 per year, which includes food and lodging."
  },
  {
    question: "How far is GRD Institute from Dehradun Railway Station?",
    answer: "The institute is located on Rajpur Road, about 10-12 km from the Dehradun Railway Station. It is easily accessible by local buses and auto-rickshaws."
  },
  {
    question: "Does GRD offer lateral entry admission?",
    answer: "Yes, lateral entry admission directly into the 2nd year of B.Tech and B.Pharma is available for Diploma holders and B.Sc graduates, subject to UKSEE counseling norms."
  },
  {
    question: "What extracurricular activities are there?",
    answer: "The college organizes an annual fest, sports week, and various cultural events. There are also student clubs for photography, dance, and technical projects to ensure holistic development."
  }
]
,
aboutImages: [
"/images/GRD-College/imgi_5_search-img.webp",
"/images/GRD-College/imgi_6_3-0x0.webp",
"/images/GRD-College/imgi_8_2-0x0.webp"
],
brochure: "/brochures/grd.pdf",
cdbrochure: "/brochures/grd.pdf",

  overview:
    "GRD IMT Dehradun is a private institute offering engineering, pharmacy, management, computer applications, hotel management, commerce and science programs with a focus on affordable education, practical exposure and improving placements.",
  established: "1989",
  fees_btech: "₹2.1 – 3.3 Lakhs/year",
  total_intake_btech: 510,
  total_intake_bpharma: 100,
  avg_package_overall: "₹4 – 5.5 LPA",
  highest_package_overall: "₹16 – 18 LPA",
  placement_rate_overall: "70–80%",
  admissions: {
    examsAccepted: "JEE Main / CBSE/ISC/UK 12th merit / institute-level test (course-wise)",
    applicationMode: "Online & Offline via GRD IMT portal",
    applicationFee: "₹1,000 – 1,200 (approx.)",
    importantDates: [
      "Applications: November – June (rolling for some courses)",
      "Merit Lists / Entrance: February – July",
      "Counselling & Admission: May – August"
    ]
  },
  highlights: [
  { icon: "🏆", label: "NAAC Grade", value: "A" },
  { icon: "📊", label: "NIRF Rank", value: "N/A" },
  { icon: "👥", label: "Students", value: "5k+" },
  { icon: "📚", label: "Programs", value: "50+" },
  { icon: "💼", label: "Placement", value: "70-80%" },
  { icon: "🏢", label: "Recruiters", value: "150+" },
],
  placements: {
  highestPackage: "₹18 LPA",
  recruitersIndustries: "150+",
  gloriousAlumni: "15000+",
  placementRecords: "80%",
  recruitersImage: "/images/recruiters/Screenshot 2025-12-15 201050.webp"
},
galleryImages: [

"/images/GRD-College/imgi_10_grd-banners.webp",
"/images/GRD-College/imgi_21_D.webp",

"/images/GRD-College/imgi_30_img-slide-4.webp",
"/images/GRD-College/imgi_56_TanmayGautam.webp",
"/images/GRD-College/imgi_5_search-img.webp",
"/images/GRD-College/imgi_6_3-0x0.webp",
"/images/GRD-College/imgi_8_2-0x0.webp",

"/images/GRD-College/imgi_27_img-slide-3.webp",
"/images/GRD-College/imgi_28_img-slide-2.webp",
"/images/GRD-College/imgi_29_img-slide-1.webp",

],
whyChooseUsData: [
  {
    id: 1,
    title: 'Industry-Ready Curriculum',
    description: 'Programs designed to meet current industry requirements with practical training and certification courses included.',
    imageUrl: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 2,
    title: 'Beautiful Hill Campus Setting',
    description: 'Located on 14 acres of pristine Rajpur hills, offering a peaceful yet productive academic environment.',
    imageUrl: 'https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 3,
    title: 'Supportive & Accessible Faculty',
    description: 'Highly qualified teachers available anytime for guidance ensuring students develop into worthy professionals.',
    imageUrl: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
],

  eligibility:
    "For B.Tech: 10+2 with PCM and minimum 45% aggregate; for B.Pharm: 10+2 with PCB/PCM 45%+; for BBA/BCA/BSc/BCom: 10+2 in any/relevant stream; for MBA/M.Tech/M.Pharm: graduation with ~50% in relevant field plus entrance/merit as applicable.",

  topRecruiters:
    "Sun Pharma, Dabur, Mankind, Himalaya, Rubicon, Usha, Byju’s, Infosys, Wipro and regional IT/industrial firms.",

  placement_highest: "₹16 – 18 LPA",
  placement_avg: "₹4 – 5.5 LPA",
  placement_perc: "70–80% (overall reported range)",

  ranking:
    "Known as an affordable private institute in Dehradun with AICTE/PCI-approved programs, growing intake and improving placement outcomes in engineering and pharmacy.",

  ranking_details:
    "• Offers around 38 UG and 12 PG programs with an overall seat count near 1,500.\n• B.Tech total approved intake is about 510 seats and B.Pharm about 100 seats.\n• Active corporate resource cell organizing 150+ company visits and 40+ pooled drives in recent years.",

  facts: [
    "Offers B.Tech, B.Sc, BBA, BCA, B.Com, B.Pharm, D.Pharm, BHM, MBA, M.Tech, M.Pharm and various diplomas.",
    "Approved by AICTE for technical programs and PCI for pharmacy programs.",
    "Wi‑Fi campus with separate hostels, laboratories, workshops and sports facilities.",
    "Regular industrial visits, guest lectures and technical/cultural fests.",
    "Scholarships/fee concessions available based on merit and category (institute policy)."
  ],

  courses: [
    // B.Tech – core & specializations
    {
      name: "B.Tech Computer Science & Engineering (CSE)",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹2.1 – 3.3 Lakhs/year",
      seats: 120,
      eligibility: "10+2 with PCM, minimum 45% aggregate; admission via JEE Main / 12th merit / institute process",
      avgPackage: "₹4 – 6 LPA",
      highlights: [
        "Core CSE curriculum including programming, data structures, DBMS, OS and networks",
        "Coding clubs, workshops and aptitude/soft‑skills training",
        "Typical roles in software development, testing and IT services"
      ]
    },
    {
      name: "B.Tech CSE (Artificial Intelligence & Machine Learning)",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹2.1 – 3.3 Lakhs/year",
      seats: 60,
      eligibility: "10+2 with PCM, 45–50% aggregate; entrance/merit as per institute norms",
      avgPackage: "₹4 – 6 LPA",
      highlights: [
        "Focus on AI, ML algorithms, Python, data analytics and model deployment",
        "Projects and mini‑projects around predictive analytics and intelligent systems",
        "Prepares for data/ML engineer and AI developer profiles"
      ]
    },
    {
      name: "B.Tech CSE (Data Science)",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹2.1 – 3.3 Lakhs/year",
      seats: 30,
      eligibility: "10+2 with PCM, minimum 45%; merit/entrance based",
      avgPackage: "₹4 – 6 LPA",
      highlights: [
        "Emphasis on statistics, databases, big data tools and visualization",
        "Industry‑oriented projects on real‑world datasets",
        "Suitable for data analyst, BI and junior data engineer roles"
      ]
    },
    {
      name: "B.Tech CSE (Cyber Security)",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹2.1 – 3.3 Lakhs/year",
      seats: 30,
      eligibility: "10+2 with PCM, 45%+; entrance/merit based",
      avgPackage: "₹4 – 6 LPA",
      highlights: [
        "Covers ethical hacking, network security, cryptography and forensics basics",
        "Hands‑on labs with security tools, simulations and case studies",
        "Entry‑level SOC analyst, security support and cyber‑ops roles"
      ]
    },
    {
      name: "B.Tech Mechanical Engineering",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹2.1 – 3.3 Lakhs/year",
      seats: 30,
      eligibility: "10+2 with PCM, 45%+ aggregate",
      avgPackage: "₹3.5 – 5 LPA",
      highlights: [
        "Core mechanical subjects: design, manufacturing, thermal and fluid mechanics",
        "Workshop‑based learning and exposure to CAD/CAM tools",
        "Opportunities in manufacturing, automotive and production industries"
      ]
    },
    {
      name: "B.Tech Civil Engineering",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹2.1 – 3.3 Lakhs/year",
      seats: 30,
      eligibility: "10+2 with PCM, 45%+ aggregate",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Subjects in structural, geotechnical, transportation and environmental engineering",
        "Practical training in surveying and civil design software",
        "Scope in construction, infrastructure firms and government exams"
      ]
    },

    // Other important UG programs
    {
      name: "B.Sc (Agriculture / Forestry / Microbiology / IT / Computer Science etc.)",
      level: "UG",
      stream: "Science & Applied Sciences",
      duration: "3–4 years",
      fees: "₹90,000 – 1.6 Lakhs/year",
      seats: 60,
      eligibility: "10+2 with Science (for core sciences/agriculture) or as per specialization",
      avgPackage: "₹2.5 – 4 LPA (varies by field)",
      highlights: [
        "Multiple B.Sc specializations with strong lab and field components",
        "Prepares for government exams, lab roles and higher studies"
      ]
    },
    {
      name: "BBA (General and specializations like International Business / Transport & Logistics / Retail)",
      level: "UG",
      stream: "Management",
      duration: "3 years",
      fees: "₹1.2 – 2 Lakhs/year",
      seats: 60,
      eligibility: "10+2 (any stream) with minimum 45–50% marks",
      avgPackage: "₹3 – 4.5 LPA",
      highlights: [
        "Foundation in marketing, finance, HR and operations",
        "Case studies, presentations and internships",
        "Good base for MBA and entry‑level corporate roles"
      ]
    },
    {
      name: "BCA (with options in General / Data Science / AI / Cyber Security)",
      level: "UG",
      stream: "IT & Computer Applications",
      duration: "3 years",
      fees: "₹1.0 – 1.6 Lakhs/year",
      seats: 60,
      eligibility: "10+2 (any stream) with Mathematics/Computer Science preferred, 45–50%+",
      avgPackage: "₹3 – 4.5 LPA",
      highlights: [
        "Covers programming, DBMS, networking and web/mobile basics",
        "Specializations aligned with current IT job roles",
        "Pathway to MCA and junior developer/support roles"
      ]
    },
    {
      name: "B.Pharm (Bachelor of Pharmacy)",
      level: "UG",
      stream: "Pharmacy",
      duration: "4 years",
      fees: "₹1.8 – 2.5 Lakhs/year",
      seats: 100,
      eligibility: "10+2 with PCB/PCM, minimum 45–50% (as per PCI norms)",
      avgPackage: "₹3 – 4.5 LPA",
      highlights: [
        "Focus on pharmaceutics, pharmacology, medicinal chemistry and pharmacognosy",
        "Qualifies graduates for registration as pharmacist as per regulations",
        "Careers in pharma industry, hospital pharmacy, QA/QC and marketing"
      ]
    },
    {
      name: "D.Pharm (Diploma in Pharmacy)",
      level: "Diploma",
      stream: "Pharmacy",
      duration: "2 years",
      fees: "₹80,000 – 1.2 Lakhs/year",
      seats: 60,
      eligibility: "10+2 with Science (PCM/PCB) as per PCI norms",
      avgPackage: "₹2.5 – 3.5 LPA",
      highlights: [
        "Entry‑level qualification for retail and community pharmacy",
        "Option to pursue B.Pharm later as per rules"
      ]
    },
    {
      name: "BHM (Bachelor of Hotel Management) / Hospitality programs",
      level: "UG",
      stream: "Hotel Management",
      duration: "3–4 years",
      fees: "₹90,000 – 1.5 Lakhs/year",
      seats: 60,
      eligibility: "10+2 (any stream), 45%+",
      avgPackage: "₹2.5 – 3.5 LPA (entry‑level hospitality roles)",
      highlights: [
        "Covers front office, F&B service, housekeeping and culinary basics",
        "Internships in hotels and resorts"
      ]
    },

    // Key PG programs
    {
      name: "MBA (Marketing / Finance / HR / International Business etc.)",
      level: "PG",
      stream: "Management",
      duration: "2 years",
      fees: "₹1.2 – 2 Lakhs/year",
      seats: 60,
      eligibility: "Graduation with minimum ~50% marks; entrance/merit (CAT/MAT/CMAT or institute test accepted as per year)",
      avgPackage: "₹4 – 6 LPA",
      highlights: [
        "Industry‑linked curriculum with internships and live projects",
        "Grooming for managerial and corporate roles"
      ]
    },
    {
      name: "M.Tech Computer Science & Engineering",
      level: "PG",
      stream: "Engineering",
      duration: "2 years",
      fees: "₹1.8 – 2.5 Lakhs/year",
      seats: 18,
      eligibility: "B.Tech/BE in CSE/IT or allied branch with required marks; GATE/entrance preferred",
      avgPackage: "₹5 – 7 LPA",
      highlights: [
        "Advanced topics in algorithms, systems and applied AI/ML",
        "Research‑oriented with dissertation",
        "Path to R&D roles or academia"
      ]
    },
    {
      name: "M.Pharm (Pharmaceutics / Pharmacology etc.)",
      level: "PG",
      stream: "Pharmacy",
      duration: "2 years",
      fees: "₹1.5 – 2 Lakhs/year",
      seats: 18,
      eligibility: "B.Pharm with required aggregate as per PCI norms",
      avgPackage: "₹4 – 6 LPA",
      highlights: [
        "Research‑centric curriculum in advanced pharmaceutical sciences",
        "Opportunities in R&D, regulatory affairs and teaching"
      ]
    }
  ]
},
{
  slug: "dd-college",
  name: "D.D. College",
location: "25, Nimbuwala, Garhi Cantt, Dehradun, Uttarakhand - 248003",
  type: "Private Degree College",
  rating: "3.5/5",
image: "/images/dd.webp",
logo : "/images/logo/dd.webp",
whyusimg: [
  "/images/whyus/dd1.webp",
  "/images/whyus/dd2.webp",
  "/images/whyus/dd3.webp",
],
feeStructureImage: ["/images/fee/ddfs.webp"],
 faqs: [
  {
    question: "Where is DD College located in Dehradun?",
    answer: "DD College is located in the Garhi Cantonment area of Dehradun, near ONGC. The location is central, safe, and well-connected to the main city."
  },
  {
    question: "What are the flagship courses at DD College?",
    answer: "DD College is well-known for its B.Sc. Agriculture, B.Ed., and B.Sc. in Biotechnology. It also offers popular courses like BCA and BBA with a focus on practical learning."
  },
  {
    question: "Is DD College a government or private college?",
    answer: "DD College is a private self-financing institute. It is affiliated with HNB Garhwal University (a Central University) and Sri Dev Suman Uttarakhand University for different courses."
  },
  {
    question: "What is the fee for B.Sc. Agriculture?",
    answer: "The fee for B.Sc. Agriculture is quite reasonable, typically around ₹50,000 to ₹60,000 per year. This affordability makes it a popular choice for students from agricultural backgrounds."
  },
  {
    question: "Does DD College offer B.Ed. admission?",
    answer: "Yes, DD College offers a B.Ed. program approved by NCTE. Admission is generally based on the B.Ed. entrance exam conducted by the affiliating university or state government."
  },
  {
    question: "Are there separate hostels for boys and girls?",
    answer: "Yes, the college provides separate hostel facilities. The hostels are equipped with basic amenities, and the mess serves hygienic vegetarian food. Hostel fees are approx. ₹75,000 per year."
  },
  {
    question: "Does the college provide scholarship facilities?",
    answer: "The college assists SC/ST/OBC students in applying for state government scholarships (Samaj Kalyan). Merit-based concessions are sometimes offered to university toppers."
  },
  {
    question: "How is the placement support at DD College?",
    answer: "The college has a placement cell that organizes job fairs and campus drives. While it doesn't guarantee 100% placement, it provides good opportunities in local industries, schools (for B.Ed), and agriculture firms."
  },
  {
    question: "Is the campus Wi-Fi enabled?",
    answer: "Yes, the campus has Wi-Fi connectivity for students and staff. There are also computer labs with internet access to support digital learning and project work."
  },
  {
    question: "What documents are needed for admission?",
    answer: "Standard documents required include 10th and 12th marksheets, Transfer Certificate (TC), Migration Certificate, Aadhar Card, and caste certificate (if applicable for scholarship)."
  }
]
,
aboutImages: [
"/images/DD-College/imgi_20_Copy-of-Untitled-1.webp",
"/images/DD-College/imgi_22_DDPS-Dehradun-1.webp",
"/images/DD-College/imgi_8_4-1.webp"
],
brochure: "/brochures/dd.pdf",
cdbrochure: "/brochures/dd.pdf",
  
overview:
    "D.D. College Dehradun is a private affiliated college offering UG and PG programs in Arts, Science, Commerce, Management, Agriculture, Education, Yoga and Law, known for low fees, university-affiliated degrees and 100% placement assistance.",

  established: "2013",
  fees_btech: "N/A (no B.Tech; focus is on BA/BSc/BCom/BBA/BSc Ag, Law, B.Ed etc.)",
galleryImages : [
  "/images/DD-College/imgi_10_Untitled-design-100.webp",
"/images/DD-College/imgi_20_Copy-of-Untitled-1.webp",
"/images/DD-College/imgi_22_DDPS-Dehradun-1.webp",
"/images/DD-College/imgi_8_4-1.webp",
  "data:image/jpeg;base64,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",
  "https://ddcollege.in/wp-content/uploads/2025/05/3-4.webp",
  "data:image/jpeg;base64,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",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ4HTSnXP_-JASZDmlhqpnGPgJBkKPo_Q71eQ&s",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZl3HpuhOA7kuKMMGuQ4WtWopiTzDoAMW-wA&s",
],
highlights: [
  { icon: "🏆", label: "NAAC Grade", value: "B+" },
  { icon: "📊", label: "NIRF Rank", value: "N/A" },
  { icon: "👥", label: "Students", value: "3k+" },
  { icon: "📚", label: "Programs", value: "35+" },
  { icon: "💼", label: "Placement", value: "40-60%" },
  { icon: "🏢", label: "Recruiters", value: "100+" },
],

whyChooseUsData: [
  {
    id: 1,
    title: 'Semi-Government Status Benefits',
    description: 'Stable resources and robust faculty support creating a conducive learning environment with quality education.',
    imageUrl: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 2,
    title: 'Modern Learning Infrastructure',
    description: 'State-of-the-art facilities including spacious classrooms, well-equipped labs, and extensive library resources.',
    imageUrl: 'https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 3,
    title: 'Holistic Development & Affordability',
    description: 'Vibrant campus life with extracurricular activities and reasonable fees making quality education accessible to all.',
    imageUrl: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
],
  admissions: {
    examsAccepted:
      "CUET-UG (for many UG programmes as per university norms), merit in 10+2 marks, and institute-level process for some courses; for Law and B.Ed, university/college-level entrance or merit as applicable in that year.",
    applicationMode: "Online application via ddcollege.in and offline form at campus",
    applicationFee: "₹500 – 1,000 (course-wise, approx.)",
    importantDates: [
      "CUET-UG registration: Feb–Mar (as per NTA schedule)",
      "Institute application window: April–August (varies by course)",
      "Counselling & admission: June–September"
    ]
  },
placements: {
  highestPackage: "₹6 LPA",
  recruitersIndustries: "30+",
  gloriousAlumni: "200+",
  placementRecords: "60%",
  recruitersImage: "/images/recruiters/Screenshot 2025-12-15 201050.webp"
},
  eligibility:
    "UG: 10+2 in relevant stream with about 45–50% marks (Arts/Commerce/Science/Agriculture); Law integrated BA LL.B usually requires 10+2 with 45%+; B.Ed requires graduation; PG (MA/MSc/MCom) requires relevant bachelor’s degree with ~45–50% aggregate. Exact criteria depend on affiliating university and year.",

  topRecruiters:
    "Regional schools, coaching institutes, banks, small and medium enterprises, insurance and EdTech firms (e.g., Byju’s, Tata group roles as per student reviews).",

  placement_highest: "₹5.4 – 6 LPA (best reported offers in recent batches)",
  placement_avg: "₹3.5 – 4.5 LPA (for stronger profiles in BSc/BCom/BBA etc.)",
  placement_perc: "40–60% students getting offers through campus/assisted drives (remaining largely go for higher studies or competitive exams).",

  ranking:
    "Recognised private degree college in Dehradun affiliated to state universities, noted for budget-friendly UG/PG degrees and growing placement assistance cell.",

  ranking_details:
    "• Offers around 35–40 courses across BA, BSc, BCom, BBA, BSc Agriculture, B.Ed, BALLB (Hons), MA, MSc, MCom and PG Diploma.\n• Affiliated to universities such as HNBGU / SDSU / Uttarakhand Sanskrit University / UOU for different streams.\n• College claims 100% placement assistance through its Training & Placement Cell rather than 100% guaranteed placement.",

  facts: [
    "Semester-wise fee is typically in the range of ₹12,500 – 30,000 per semester for most UG/PG programmes, making it cheaper than engineering/private universities.",
    "Campus has basic but functional infrastructure: classrooms, labs (science/computer), library, cafeteria and infirmary.",
    "Dedicated Training & Placement Cell that conducts sessions, talks and drives with local and regional employers.",
    "Offers on-campus and some online/blended options in Yoga and certain PG diplomas.",
    "Law and Yoga programs (BA LL.B, LL.B, MA Yoga, PG Diploma in Yoga) are niche offerings for students targeting those areas."
  ],

  // You can add these meta fields if you like
  total_intake_ug: 1200,         // approx across BA/BSc/BCom/BBA/BSc Ag etc.
  total_intake_pg: 300,          // approx across MA/MSc/MCom/PG Diploma
  avg_package_overall: "₹3 – 4.5 LPA",
  highest_package_overall: "₹5.4 – 6 LPA",
  placement_rate_overall: "40–60% (placement + internship offers)",

  courses: [
    // UG – Arts, Commerce, Science, Management, Agriculture
    {
      name: "B.A (Bachelor of Arts)",
      level: "UG",
      stream: "Arts & Humanities",
      duration: "3 years",
      fees: "₹15,000 – 20,000 per year",
      seats: 180,
      eligibility: "10+2 in any stream with minimum 45% marks (as per university norms)",
      avgPackage: "₹2.5 – 3.5 LPA",
      highlights: [
        "Core subjects like English, History, Political Science, Sociology, etc.",
        "Suitable base for government exams, teaching, content and higher studies (MA, B.Ed)."
      ]
    },
    {
      name: "B.Com / B.Com (Hons.)",
      level: "UG",
      stream: "Commerce",
      duration: "3 years",
      fees: "₹18,000 – 25,000 per year",
      seats: 180,
      eligibility: "10+2 (Commerce/Science/Arts) with about 45–50% marks",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Covers accounting, taxation, finance, business law and economics.",
        "Good foundation for CA/CS/CMA, MBA, MCom and banking/finance jobs."
      ]
    },
    {
      name: "B.Sc (PCM / PCB / Computer Science / General Science)",
      level: "UG",
      stream: "Science",
      duration: "3 years",
      fees: "₹18,000 – 25,000 per year",
      seats: 160,
      eligibility: "10+2 with Science (PCM/PCB) and required percentage (around 45–50%).",
      avgPackage: "₹3 – 4.5 LPA (as per BSc placement reviews)",
      highlights: [
        "Strong base in Physics, Chemistry, Mathematics / Biology and Computer Science depending on combination.",
        "Students opt for MSc, B.Ed, competitive exams or entry-level analytics/teaching roles."
      ]
    },
    {
      name: "B.Sc Agriculture",
      level: "UG",
      stream: "Agriculture",
      duration: "4 years",
      fees: "₹25,000 – 30,000 per semester (approx.)",
      seats: 60,
      eligibility: "10+2 with Science/Agriculture (PCB/PCM) as per university norms.",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Agronomy, soil science, horticulture and allied agricultural subjects.",
        "Scope in agri‑input companies, government agriculture jobs and higher studies (MSc Ag)."
      ]
    },
    {
      name: "BBA (Bachelor of Business Administration)",
      level: "UG",
      stream: "Management",
      duration: "3 years",
      fees: "₹20,000 – 30,000 per year (approx.)",
      seats: 60,
      eligibility: "10+2 in any stream with about 45–50% marks.",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Intro to management: marketing, HR, finance, operations, entrepreneurship.",
        "Good pathway for MBA and entry-level corporate/marketing/sales roles."
      ]
    },
    {
      name: "B.Sc Computer Science / B.Sc IT",
      level: "UG",
      stream: "IT & Computer Science",
      duration: "3 years",
      fees: "₹20,000 – 30,000 per year",
      seats: 60,
      eligibility: "10+2 with Maths/Computer Science preferred; minimum 45–50%.",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Programming fundamentals, data structures, OS, DBMS and basic networking.",
        "Entry‑level roles in IT support, junior developer or further study (MSc CS, MCA)."
      ]
    },
    {
      name: "B.Ed (Bachelor of Education)",
      level: "UG Professional",
      stream: "Education",
      duration: "2 years",
      fees: "₹22,000 – 45,000 per year (depending on session)",
      seats: 100,
      eligibility: "Graduation in any stream with required percentage (often 50%+); as per NCTE/university rules.",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Teacher‑training program with pedagogy, psychology and school internships.",
        "Qualifies for school‑teaching jobs (after TET/CTET as required)."
      ]
    },

    // Law & Yoga
    {
      name: "BA LL.B (Hons.)",
      level: "UG Integrated",
      stream: "Law",
      duration: "5 years integrated",
      fees: "₹30,000 – 40,000 per year (approx.)",
      seats: 60,
      eligibility: "10+2 in any stream with about 45%+ marks (higher for General category as per Bar Council/university norms).",
      avgPackage: "₹3 – 5 LPA (law placements vary widely by profile and location)",
      highlights: [
        "Integrated law degree with combination of BA subjects and core law papers.",
        "Prepares for practice, judiciary exams and corporate legal roles."
      ]
    },
    {
      name: "LL.B (3‑year)",
      level: "UG Professional",
      stream: "Law",
      duration: "3 years",
      fees: "₹25,000 – 35,000 per year",
      seats: 60,
      eligibility: "Graduation in any discipline with required % as per BCI/university.",
      avgPackage: "₹3 – 5 LPA (after experience/practice).",
      highlights: [
        "Three‑year professional law degree for graduates.",
        "Moot courts, legal clinics and bar‑exam‑oriented curriculum."
      ]
    },
    {
      name: "BA / MA / PG Diploma in Yoga",
      level: "UG / PG / PG Diploma",
      stream: "Yoga & Wellness",
      duration: "1–2 years (PGD/MA)",
      fees: "₹15,000 – 25,000 per year",
      seats: 40,
      eligibility: "10+2 for BA; Graduation for MA/PG Diploma in Yoga.",
      avgPackage: "₹2.5 – 3.5 LPA",
      highlights: [
        "Covers yoga philosophy, asanas, therapy and teaching practice.",
        "Roles as yoga instructor, wellness trainer and further specialization."
      ]
    },

    // PG – MA/MSc/MCom
    {
      name: "M.Sc (Chemistry / Mathematics / Physics / Horticulture / Agronomy etc.)",
      level: "PG",
      stream: "Science",
      duration: "2 years",
      fees: "₹20,000 – 35,000 per year (depending on subject)",
      seats: "20–30 per specialization",
      eligibility: "BSc / relevant bachelor’s degree in concerned subject with required % (typically 45–50%+).",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Advanced subject knowledge with practical/project components.",
        "Pathway to research, teaching, labs and competitive exams."
      ]
    },
    {
      name: "M.A (English / History / Yoga Science etc.)",
      level: "PG",
      stream: "Arts",
      duration: "2 years",
      fees: "₹17,500 – 25,000 per year (approx.)",
      seats: "20–30 per specialization",
      eligibility: "BA/BA (Hons) in relevant subject or equivalent with ~45–50%+.",
      avgPackage: "₹2.5 – 3.5 LPA",
      highlights: [
        "Subject‑deepening for humanities and yoga disciplines.",
        "Useful for academia, content, civil services and teaching."
      ]
    },
    {
      name: "M.Com",
      level: "PG",
      stream: "Commerce",
      duration: "2 years",
      fees: "₹17,500 – 25,000 per year",
      seats: 30,
      eligibility: "B.Com/BBA or related degree with required aggregate.",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Advanced accounting, finance, taxation and research methods.",
        "Suitable for finance jobs, higher research and teaching."
      ]
    },
    {
      name: "PG Diploma in Yoga",
      level: "PG Diploma",
      stream: "Yoga & Wellness",
      duration: "1 year",
      fees: "₹15,000 – 20,000 per year",
      seats: 30,
      eligibility: "Graduation in any stream, interest in yoga and wellness.",
      avgPackage: "₹2.5 – 3.5 LPA",
      highlights: [
        "Shorter professional program to become yoga trainer.",
        "Opportunities in schools, gyms, wellness centers and self‑practice."
      ]
    }
  ]
},{
  slug: "sai-college",
  name: "SAI Group of Institutions",
location: "26A, Rajpur Road, Near Hotel Meedo Grand, Dehradun - 248001, Uttarakhand",
  type: "Private Multi-Stream College",
  rating: "3.8/5",
image: "/images/sai.webp",
brochure: "/brochures/sai.pdf",
cdbrochure: "/brochures/sai.pdf",

logo : "/images/logo/sai.webp",
  whyusimg: [
  "/images/whyus/sai1.webp",
  "/images/whyus/sai2.webp",
  "/images/whyus/sai3.webp",
],
faqs: [
  {
    question: "What is Sai Group of Institutions famous for?",
    answer: "Sai Group is most famous for its Paramedical and Healthcare courses. It is a pioneer in offering Physiotherapy (BPT/MPT), Medical Lab Technology (BMLT), and Nursing courses in Dehradun."
  },
  {
    question: "Is the college approved by recognized bodies?",
    answer: "Yes, the courses are approved by the Indian Association of Physiotherapists (IAP), HNB Garhwal University, and Sri Dev Suman Uttarakhand University. The nursing courses are recognized by the Indian Nursing Council (INC)."
  },
  {
    question: "What is the fee for the BPT (Physiotherapy) course?",
    answer: "The BPT course fee is approximately ₹70,000 to ₹85,000 per year. It is a 4.5-year program including a mandatory 6-month internship at affiliated hospitals."
  },
  {
    question: "Does Sai Institute have its own hospital for training?",
    answer: "While it may not have a massive medical college hospital, it has strong tie-ups with reputed hospitals in Dehradun (like CMI, Max, Synergy) for clinical training and internships of its students."
  },
  {
    question: "What are the placement opportunities after BMLT/BPT?",
    answer: "Graduates are placed in hospitals, diagnostic labs, and rehabilitation centers. Many alumni are working in top hospitals in Delhi-NCR and Dehradun. The college also supports students in opening their own clinics."
  },
  {
    question: "Does the college offer Management and IT courses?",
    answer: "Yes, apart from medical streams, Sai Group offers BBA, BCA, B.Com, and Mass Communication courses. However, its core strength remains in the paramedical sciences."
  },
  {
    question: "Is there an entrance exam for admission?",
    answer: "Admission is primarily merit-based on Class 12th marks (PCB for medical streams). For some specific courses or scholarship seats, a personal interview or screening might be conducted."
  },
  {
    question: "How are the hostel facilities?",
    answer: "The college provides separate hostels for boys and girls with strict security. The environment is homely, and the mess provides nutritious food suitable for students from different states."
  },
  {
    question: "What is the mode of application?",
    answer: "Students can apply online through the official website or visit the campus in Dehradun to fill out the form physically. A registration fee is applicable."
  },
  {
    question: "Does the college organize cultural events?",
    answer: "Yes, the college organizes an annual fest called 'Srijan' along with health camps, physiotherapy days, and sports meets to ensure a vibrant campus life."
  }
]
,
aboutImages: [
"/images/Sai-College/imgi_5_labo4.webp",
"/images/Sai-College/imgi_6_5.webp",
"/images/Sai-College/imgi_7_1.webp"
],
overview:
    "SAI Group of Institutions Dehradun is a private multi-disciplinary college offering UG and PG programs in health sciences (Nursing, Pharmacy, Physiotherapy, BMLT), agriculture, management, IT, hospitality and yoga with strong focus on healthcare and allied sciences education.",

  established: "2005",
  fees_overall: "₹45,000 – 6.16 Lakhs (varies by program)",
  galleryImages:[
    "/images/Sai-College/imgi_18_g9.webp",
"/images/Sai-College/imgi_21_g12.webp",
"/images/Sai-College/imgi_22_g21.webp",
"/images/Sai-College/imgi_25_mha-college-in-dehradun.webp",
"/images/Sai-College/imgi_26_g25.webp",
"/images/Sai-College/imgi_29_g28.webp",
"/images/Sai-College/imgi_2_cafe.webp",
"/images/Sai-College/imgi_2_labo1.webp",
"/images/Sai-College/imgi_31_g30.webp",
"/images/Sai-College/imgi_3_cafe1.webp",
"/images/Sai-College/imgi_3_labo2.webp",
"/images/Sai-College/imgi_4_3.webp",
"/images/Sai-College/imgi_5_4.webp",
"/images/Sai-College/imgi_5_cafe3.webp",
"/images/Sai-College/imgi_5_labo4.webp",
"/images/Sai-College/imgi_6_5.webp",
"/images/Sai-College/imgi_7_1.webp",
"/images/Sai-College/imgi_8_2.webp",
  "data:image/jpeg;base64,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",
  "data:image/jpeg;base64,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",
  "data:image/jpeg;base64,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",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQrH_fjzh6HMBHKN6LZlh3Mqkd5sYkyotruog&s",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT2exO3c9lF3o51BJVsZtGmSMWX4TJwP5hstQ&s",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-nA1LwIs_ujsYPsEAuiXV78ayeMLirmXZmQ&s",

  ],
  highlights: [
  { icon: "🏆", label: "NAAC Grade", value: "A" },
  { icon: "📊", label: "NIRF Rank", value: "N/A" },
  { icon: "👥", label: "Students", value: "4k+" },
  { icon: "📚", label: "Programs", value: "40+" },
  { icon: "💼", label: "Placement", value: "82%" },
  { icon: "🏢", label: "Recruiters", value: "400+" },
],
  whyChooseUsData: [
  {
    id: 1,
    title: 'Excellent Placement Records',
    description: '41 LPA highest package with 400+ recruiting industries ensuring strong career prospects for graduates.',
    imageUrl: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 2,
    title: 'State-of-the-Art Infrastructure',
    description: 'Modern facilities with fully ventilated classrooms, dedicated computer labs, and advanced sports amenities.',
    imageUrl: 'https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 3,
    title: 'Highly Qualified Faculty',
    description: 'Experienced and dedicated educators providing outcome-based holistic education in frontier areas of knowledge.',
    imageUrl: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
]
,

  placements: {
  highestPackage: "₹41 LPA",
  recruitersIndustries: "400+",
  gloriousAlumni: "8000+",
  placementRecords: "82%",
  recruitersImage: "/images/recruiters/saiii.webp"
},
  admissions: {
    examsAccepted: "Merit-based on 10+2 marks; some programs require specific entrance tests (NEET for health sciences, CAT/MAT for MBA)",
    applicationMode: "Online & Offline",
    applicationFee: "₹500 – 1,000",
    importantDates: [
      "Applications: August–September & December–June (rolling)",
      "Merit lists: Monthly declarations",
      "Admission: Year-round intake for various programs"
    ]
  },

  eligibility: "10+2 with 45–50% aggregate (varies by course); NEET score for health science programs; graduation for PG courses.",

  topRecruiters: "Apollo Hospitals, Fortis, Max Healthcare, local nursing homes, pharmaceutical companies, regional firms.",

  placement_highest: "₹8 LPA",
  placement_avg: "₹4 – 5 LPA",
  placement_perc: "70–80% (healthcare and nursing strong placement areas)",

  ranking: "Recognized private multi-stream college in Dehradun with strong focus on health sciences and allied programs.",

  ranking_details: "• Over 30 courses across health sciences, pharmacy, agriculture, management and IT\n• Strong healthcare network and clinical training partnerships\n• Active placement support and hospital/industry connect",

  facts: [
    "Strong healthcare focus with B.Sc Nursing, B.Pharma, D.Pharma, BPT, BMLT, BMRIT, B.Sc Agriculture specializations",
    "Clinical training at affiliated hospitals and health centers",
    "Hostel facilities, modern labs and Wi-Fi campus",
    "Scholarships and fee concessions for meritorious students",
    "Regular workshops and seminars in healthcare and allied fields"
  ],

  total_intake_ug: 800,
  total_intake_pg: 150,
  avg_package_overall: "₹3.5 – 5 LPA",
  highest_package_overall: "₹8 LPA",
  placement_rate_overall: "70–80%",

  courses: [
    // Health Sciences – Nursing
    {
      name: "B.Sc Nursing",
      level: "UG",
      stream: "Health Sciences",
      duration: "4 years",
      fees: "₹1.4 – 1.6 Lakhs/year",
      seats: 100,
      eligibility: "10+2 with PCB, NEET score",
      avgPackage: "₹4 – 5.5 LPA",
      highlights: [
        "Comprehensive nursing training with clinical postings in affiliated hospitals",
        "Strong curriculum covering medical-surgical, community and pediatric nursing",
        "High demand for B.Sc Nursing graduates"
      ]
    },
    {
      name: "Post Basic B.Sc Nursing",
      level: "UG",
      stream: "Health Sciences",
      duration: "2 years",
      fees: "₹1 – 1.2 Lakhs/year",
      seats: 50,
      eligibility: "GNM/ANM pass with experience",
      avgPackage: "₹4 – 5 LPA",
      highlights: [
        "Upgrade program for qualified nurses",
        "Advanced nursing concepts and specialization options"
      ]
    },
    {
      name: "GNM (General Nursing & Midwifery)",
      level: "Diploma",
      stream: "Health Sciences",
      duration: "3 years",
      fees: "₹1 – 1.2 Lakhs/year",
      seats: 80,
      eligibility: "10+2 with PCB/PCM",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Entry-level nursing qualification",
        "Practical training and hospital rotation"
      ]
    },

    // Pharmacy
    {
      name: "B.Pharma",
      level: "UG",
      stream: "Pharmacy",
      duration: "4 years",
      fees: "₹90,000 – 1 Lakh/year",
      seats: 60,
      eligibility: "10+2 with PCB, 45%+",
      avgPackage: "₹3.5 – 4.5 LPA",
      highlights: [
        "Pharmaceutical sciences, drug development and regulation",
        "Industry internships and practice"
      ]
    },
    {
      name: "D.Pharma",
      level: "Diploma",
      stream: "Pharmacy",
      duration: "2 years",
      fees: "₹70,000 – 90,000/year",
      seats: 60,
      eligibility: "10+2 with PCB/PCM",
      avgPackage: "₹2.5 – 3.5 LPA",
      highlights: [
        "Entry-level pharmacy qualification",
        "Retail and hospital pharmacy roles"
      ]
    },

    // Allied Health Sciences
    {
      name: "Bachelor of Physiotherapy (BPT)",
      level: "UG",
      stream: "Health Sciences",
      duration: "4 years",
      fees: "₹75,000 – 85,000/year",
      seats: 50,
      eligibility: "10+2 with PCB, 50%+",
      avgPackage: "₹3.5 – 4.5 LPA",
      highlights: [
        "Rehabilitation and sports therapy training",
        "Clinical practice in hospitals and rehabilitation centers"
      ]
    },
    {
      name: "Master of Physiotherapy (MPT)",
      level: "PG",
      stream: "Health Sciences",
      duration: "2 years",
      fees: "₹90,000/year",
      seats: 20,
      eligibility: "BPT with 50%+",
      avgPackage: "₹4 – 5.5 LPA",
      highlights: [
        "Advanced physiotherapy specializations",
        "Research and clinical focus"
      ]
    },
   
    {
      name: "B.Sc Horticulture",
      level: "UG",
      stream: "Agriculture",
      duration: "4 years",
      fees: "₹50,000/year",
      seats: 40,
      eligibility: "10+2 with PCB, 45%+",
      avgPackage: "₹2.8 – 3.8 LPA",
      highlights: [
        "Fruit, vegetable and ornamental gardening",
        "Nursery and farm management"
      ]
    },
   
    {
      name: "B.Sc Forestry",
      level: "UG",
      stream: "Science",
      duration: "4 years",
      fees: "₹50,000/year",
      seats: 40,
      eligibility: "10+2 with PCB, 50%+",
      avgPackage: "₹2.8 – 3.8 LPA",
      highlights: [
        "Forest management and conservation",
        "Government forest department roles"
      ]
    },
    
    {
      name: "B.P.H (Bachelor in Public Health)",
      level: "UG",
      stream: "Health Management",
      duration: "3 years",
      fees: "₹50,000/year",
      seats: 40,
      eligibility: "10+2 with 50%+",
      avgPackage: "₹3 – 3.8 LPA",
      highlights: [
        "Public health and community health",
        "Government health program roles"
      ]
    },
    {
      name: "M.P.H (Master in Public Health)",
      level: "PG",
      stream: "Health Management",
      duration: "2 years",
      fees: "₹75,000/year",
      seats: 20,
      eligibility: "Graduation with 50%+",
      avgPackage: "₹4 – 5 LPA",
      highlights: [
        "Advanced public health specialization"
      ]
    },

    // Management & IT
    {
      name: "BBA",
      level: "UG",
      stream: "Management",
      duration: "3 years",
      fees: "₹49,000/year",
      seats: 60,
      eligibility: "10+2 with 45%+",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Business management fundamentals",
        "Soft skills and communication"
      ]
    },
    {
      name: "MBA",
      level: "PG",
      stream: "Management",
      duration: "2 years",
      fees: "₹70,000/year",
      seats: 60,
      eligibility: "Graduation with 50%+",
      avgPackage: "₹4 – 5.5 LPA",
      highlights: [
        "Healthcare management, marketing, finance specializations"
      ]
    },
    {
      name: "BCA",
      level: "UG",
      stream: "IT",
      duration: "3 years",
      fees: "₹49,000/year",
      seats: 60,
      eligibility: "10+2 with Maths, 45%+",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Programming and software fundamentals"
      ]
    },
    {
      name: "B.Sc IT",
      level: "UG",
      stream: "IT",
      duration: "3 years",
      fees: "₹40,000/year",
      seats: 60,
      eligibility: "10+2 with Maths/CS, 45%+",
      avgPackage: "₹3 – 3.8 LPA",
      highlights: [
        "IT infrastructure and software development"
      ]
    },
    {
      name: "B.Com (Hons)",
      level: "UG",
      stream: "Commerce",
      duration: "3 years",
      fees: "₹49,000/year",
      seats: 60,
      eligibility: "10+2 with 45%+",
      avgPackage: "₹2.8 – 3.5 LPA",
      highlights: [
        "Accounting and finance fundamentals"
      ]
    },
    {
      name: "B.Com",
      level: "UG",
      stream: "Commerce",
      duration: "3 years",
      fees: "₹30,000/year",
      seats: 80,
      eligibility: "10+2 with 45%+",
      avgPackage: "₹2.5 – 3 LPA",
      highlights: [
        "Basic commerce curriculum"
      ]
    },
    {
      name: "Diploma in Yoga",
      level: "Diploma",
      stream: "Wellness",
      duration: "1 year",
      fees: "₹35,000",
      seats: 40,
      eligibility: "10+2 pass",
      avgPackage: "₹2 – 2.5 LPA",
      highlights: [
        "Yoga instruction and wellness training"
      ]
    },
    {
      name: "Diploma in Hotel Management",
      level: "Diploma",
      stream: "Hospitality",
      duration: "1 year",
      fees: "₹70,000",
      seats: 30,
      eligibility: "10+2 pass",
      avgPackage: "₹2.5 – 3 LPA",
      highlights: [
        "Hotel operations and hospitality skills"
      ]
    },
    {
      name: "Diploma in Aviation",
      level: "Diploma",
      stream: "Aviation",
      duration: "1 year",
      fees: "₹50,000",
      seats: 25,
      eligibility: "10+2 pass",
      avgPackage: "₹3 – 3.5 LPA",
      highlights: [
        "Aviation industry preparation"
      ]
    }
  ]
},{
  slug: "institute-of-technology-and-management",
  name: "Institute of Technology and Management (ITM)",
location: "60, Chakrata Road, Opposite Back Gate of Doon School, Dehradun - 248001, Uttarakhand",
  type: "Private University Affiliated Institute",
  rating: "4.0/5",
  logo : "/images/logo/imtm.webp",
whyusimg: [
  "/images/whyus/itm1.webp",
  "/images/whyus/itm2.webp",
  "/images/whyus/itm3.webp",
],
faqs: [
  {
    question: "Is ITM Dehradun a government college?",
    answer: "No, ITM (Institute of Technology and Management) Dehradun is a private institute. It is affiliated with HNB Garhwal University (Central University) and Sri Dev Suman Uttarakhand University."
  },
  {
    question: "What are the top courses offered at ITM?",
    answer: "ITM is well-regarded for its B.Sc. IT, BCA, BBA, and M.Sc. IT programs. It focuses heavily on Information Technology and Management education."
  },
  {
    question: "What is the fee structure for BCA at ITM?",
    answer: "The fee for the BCA program is very affordable, ranging from ₹45,000 to ₹60,000 per year. This makes it a great choice for students looking for quality IT education on a budget."
  },
  {
    question: "Does ITM provide hostel accommodation?",
    answer: "Yes, ITM has hostel facilities for students. The hostels are located near the campus and provide standard amenities with a focus on safety and discipline."
  },
  {
    question: "How are the placements at ITM Dehradun?",
    answer: "ITM has a proactive placement cell. While not comparable to tier-1 universities, it regularly places students in companies like Wipro, TCS (via off-campus drives), and local tech firms in Dehradun."
  },
  {
    question: "Is ITM approved by AICTE?",
    answer: "ITM runs UGC-recognized degree courses through its affiliating universities. For technical courses falling under AICTE purview, it maintains the necessary approvals and standards."
  },
  {
    question: "What is the admission criteria for B.Sc. IT?",
    answer: "Admission to B.Sc. IT requires passing Class 12th with Mathematics as a subject. Selection is usually based on merit in the qualifying examination."
  },
  {
    question: "Does ITM offer distance education courses?",
    answer: "ITM is primarily a regular full-time college. However, it may have study centers for distance programs; it's best to check the latest brochure for specific distance learning options."
  },
  {
    question: "Where is the campus located?",
    answer: "The ITM campus is located on the Rajpur Road/Haridwar Road area (depending on the specific block), which is easily accessible from the city center and offers a good academic environment."
  },
  {
    question: "Are there scholarships for Uttarakhand students?",
    answer: "Yes, eligible students with Uttarakhand domicile can avail of state government scholarships. The college administration assists students in the documentation process for these schemes."
  }
]
,
aboutImages: [
"/images/Institute-Of-Technology-&-Management/imgi_5_animation1.webp",
"/images/Institute-Of-Technology-&-Management/imgi_6_21390_computer lab (1).webp",
"/images/Institute-Of-Technology-&-Management/imgi_6_54471_library 01.webp"
],
placements: {
  highestPackage: "₹52 LPA",
  recruitersIndustries: "800+",
  gloriousAlumni: "15000+",
  placementRecords: "92%",
  recruitersImage: "/images/recruiters/itm.webp"
},

image: "/images/itm.webp",
cdbrochure: "/brochures/itm.pdf",

brochure: "/brochures/itm.pdf",
  overview:
    "ITM Dehradun is a well-established private institute offering diverse UG and PG programs in IT, animation, management, arts, commerce, hotel management and library science with focus on industry-aligned education and strong placements.",

  established: "1998",
  fees_overall: "₹26.5K – 2.1 Lakhs (varies by program)",
  galleryImages: [
  
"/images/itm/imgi_3_56686_classes (1).webp",
"/images/itm/imgi_5_11891_Computer lab (2).webp",
"/images/itm/imgi_5_20089_Classs 01.webp",
"/images/itm/imgi_5_26692_itm.webp",
"/images/itm/imgi_5_31773_Library 2 (1).webp",
"/images/itm/imgi_5_animation1.webp",
"/images/itm/imgi_6_21390_computer lab (1).webp",
"/images/itm/imgi_6_54471_library 01.webp",
"/images/itm/imgi_8_hostel-new-img3.webp"
  ],
    highlights: [
  { icon: "🏆", label: "NAAC Grade", value: "A" },
  { icon: "📊", label: "NIRF Rank", value: "N/A" },
  { icon: "👥", label: "Students", value: "3k+" },
  { icon: "📚", label: "Programs", value: "35+" },
  { icon: "💼", label: "Placement", value: "70-75%" },
  { icon: "🏢", label: "Recruiters", value: "120+" },
],
  whyChooseUsData: [
  {
    id: 1,
    title: 'Expert Faculty Mentorship',
    description: 'Highly qualified professors and industry professionals providing personalized guidance for career development.',
    imageUrl: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 2,
    title: 'Diverse Academic Programs',
    description: 'Wide range of courses across management, technology, and other disciplines catering to varied interests.',
    imageUrl: 'https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 3,
    title: 'Strong Placement Support',
    description: 'Proactive placement process with 90% placement rate ensuring student success in career placements.',
    imageUrl: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
],
  admissions: {
    examsAccepted: "UPSEE / JEE Mains / LEET (laterals), merit-based on 10+2, ATMAT / MAT / CMAT for MBA, CBSE 12th for other programs",
    applicationMode: "Online & Offline",
    applicationFee: "₹1,000 – 1,500",
    importantDates: [
      "Applications: November–June (rolling)",
      "Merit Declaration: Monthly",
      "Admissions: July–September"
    ]
  },

  eligibility: "10+2 with 45–50% (varies by course); graduation with 50%+ for PG.",

  topRecruiters: "TCS, Infosys, Wipro, IBM, Accenture, Amazon, Microsoft, local and regional IT firms.",

  placement_highest: "₹15 LPA",
  placement_avg: "₹4 LPA",
  placement_perc: "75–85% (IT and animation have better placement rates)",

  ranking: "Ranked #46 among Indian Universities by NIRF; known for IT and animation specializations with strong industry connections.",

  ranking_details: "• 1950+ students placed in recent batches\n• 590+ recruiters visiting campus annually\n• 91% overall placement rate\n• Focus on emerging tech and creative fields",

  facts: [
    "28+ courses across IT, computer applications, animation, management, arts, commerce and hospitality",
    "Specializations in AI, Data Science, Full Stack Development, Animation & VFX",
    "Industry partnerships with tech companies and animation studios",
    "Hostel, Wi-Fi campus, laboratories and design studios",
    "Active placement cell with dedicated training programs"
  ],

  total_intake_ug: 600,
  total_intake_pg: 150,
  avg_package_overall: "₹3.5 – 5 LPA",
  highest_package_overall: "₹15 LPA",
  placement_rate_overall: "75–85%",

  courses: [
  

    // UG – IT & Computer Applications
    {
      name: "B.Sc Information Technology (B.Sc IT)",
      level: "UG",
      stream: "IT",
      duration: "3 years",
      fees: "₹1.2 – 1.5 Lakhs/year",
      seats: 100,
      eligibility: "10+2 with Maths/CS, 45–50%",
      avgPackage: "₹3.5 – 4.5 LPA",
      highlights: [
        "Programming, networking, web development and databases",
        "Good entry point for software support and development roles"
      ]
    },
    {
      name: "BCA (Bachelor of Computer Applications)",
      level: "UG",
      stream: "IT",
      duration: "3 years",
      fees: "₹1.2 – 1.5 Lakhs/year",
      seats: 120,
      eligibility: "10+2 with Maths, 45%+",
      avgPackage: "₹3.5 – 4.5 LPA",
      highlights: [
        "Software development fundamentals",
        "Pathway to MCA and IT careers"
      ]
    },
    {
      name: "B.Sc Computer Science",
      level: "UG",
      stream: "IT",
      duration: "3 years",
      fees: "₹1.1 – 1.4 Lakhs/year",
      seats: 80,
      eligibility: "10+2 with Maths, 45%+",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Programming and computational fundamentals"
      ]
    },

    // Animation & Design
    {
      name: "B.Sc Animation",
      level: "UG",
      stream: "Design & Media",
      duration: "4 years",
      fees: "₹1.5 – 1.8 Lakhs/year",
      seats: 60,
      eligibility: "10+2 any stream, 45%+",
      avgPackage: "₹4 – 5.5 LPA",
      highlights: [
        "3D animation, VFX, motion graphics with industry tools",
        "Portfolio development and studio training",
        "Animation studio and gaming roles"
      ]
    },
    {
      name: "B.A Fine Arts",
      level: "UG",
      stream: "Arts & Design",
      duration: "3 years",
      fees: "₹90,000 – 1.2 Lakhs/year",
      seats: 50,
      eligibility: "10+2 any stream, 45%+",
      avgPackage: "₹2.5 – 3.5 LPA",
      highlights: [
        "Visual arts, painting, sculpture and design"
      ]
    },

    // Management & Commerce
    {
      name: "BBA (Bachelor of Business Administration)",
      level: "UG",
      stream: "Management",
      duration: "3 years",
      fees: "₹1 – 1.3 Lakhs/year",
      seats: 100,
      eligibility: "10+2 any stream, 45%+",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Business fundamentals, marketing, HR and finance"
      ]
    },
    {
      name: "B.Com (Bachelor of Commerce)",
      level: "UG",
      stream: "Commerce",
      duration: "3 years",
      fees: "₹90,000 – 1.1 Lakhs/year",
      seats: 80,
      eligibility: "10+2 with 45%+",
      avgPackage: "₹2.8 – 3.5 LPA",
      highlights: [
        "Accounting, taxation and finance"
      ]
    },
    {
      name: "B.Com (Hons.)",
      level: "UG",
      stream: "Commerce",
      duration: "3 years",
      fees: "₹1 – 1.2 Lakhs/year",
      seats: 60,
      eligibility: "10+2 with 50%+",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Advanced commerce curriculum"
      ]
    },

    // Arts & Media
    {
      name: "B.A (Bachelor of Arts)",
      level: "UG",
      stream: "Arts",
      duration: "3 years",
      fees: "₹75,000 – 1 Lakh/year",
      seats: 80,
      eligibility: "10+2 any stream, 45%+",
      avgPackage: "₹2.5 – 3 LPA",
      highlights: [
        "English, History, Political Science, Sociology"
      ]
    },
    {
      name: "B.A JMC (Bachelor of Arts in Journalism & Mass Communication)",
      level: "UG",
      stream: "Media",
      duration: "3 years",
      fees: "₹1 – 1.2 Lakhs/year",
      seats: 60,
      eligibility: "10+2 any stream, 45%+",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Journalism, broadcasting and media production",
        "Media industry roles"
      ]
    },

    // Library Science
    {
      name: "B.Lib.Sc (Bachelor of Library Science)",
      level: "UG",
      stream: "Library & Info Management",
      duration: "1 year",
      fees: "₹35,000/year",
      seats: 30,
      eligibility: "Graduation in any stream",
      avgPackage: "₹2.5 – 3 LPA",
      highlights: [
        "Library management and information organization",
        "Niche specialized field"
      ]
    },

    // Hospitality
    {
      name: "BHM (Bachelor of Hotel Management)",
      level: "UG",
      stream: "Hospitality",
      duration: "3 years",
      fees: "₹1.2 – 1.5 Lakhs/year",
      seats: 60,
      eligibility: "10+2 any stream, 45%+",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Hotel operations, F&B and hospitality management"
      ]
    },

    // Diploma
    {
      name: "Diploma in Hotel Management",
      level: "Diploma",
      stream: "Hospitality",
      duration: "1 year",
      fees: "₹50,000 – 70,000",
      seats: 40,
      eligibility: "10+2 pass",
      avgPackage: "₹2.5 – 3 LPA",
      highlights: [
        "Quick hospitality certification"
      ]
    },

    // PG Courses
    {
      name: "M.Sc Information Technology",
      level: "PG",
      stream: "IT",
      duration: "2 years",
      fees: "₹1.2 – 1.5 Lakhs/year",
      seats: 40,
      eligibility: "B.Sc IT / BCA with 50%+",
      avgPackage: "₹4.5 – 6 LPA",
      highlights: [
        "Advanced IT and software engineering",
        "Strong placement in IT companies"
      ]
    },
    {
      name: "M.Sc Animation",
      level: "PG",
      stream: "Design & Media",
      duration: "2 years",
      fees: "₹1.3 – 1.6 Lakhs/year",
      seats: 30,
      eligibility: "B.Sc Animation or related with 50%+",
      avgPackage: "₹4.5 – 5.5 LPA",
      highlights: [
        "Advanced VFX and motion design",
        "Animation studio and film industry roles"
      ]
    },
    {
      name: "M.Com (Master of Commerce)",
      level: "PG",
      stream: "Commerce",
      duration: "2 years",
      fees: "₹90,000 – 1.1 Lakhs/year",
      seats: 40,
      eligibility: "B.Com with 50%+",
      avgPackage: "₹3.5 – 4.5 LPA",
      highlights: [
        "Finance, accounting and business specializations"
      ]
    },
    {
      name: "M.Lib.Sc (Master of Library Science)",
      level: "PG",
      stream: "Library & Info Management",
      duration: "1 year",
      fees: "₹40,000",
      seats: 20,
      eligibility: "B.Lib.Sc or graduation",
      avgPackage: "₹2.8 – 3.5 LPA",
      highlights: [
        "Advanced library and information science"
      ]
    }
  ]
},
{
  slug: "doon-group-of-colleges",
  name: "Doon Group of Colleges",
location: "Chakrata Road, Shri Dev Suman Nagar, Akashdeep Colony, Khurbura Mohalla, Dehradun - 248001, Uttarakhand",
  type: "Private Multi-Stream College",
  rating: "3.6/5",
  logo : "/images/logo/doon.webp",
whyusimg: [
  "/images/whyus/doon2.webp",
  "/images/whyus/doon4.webp",
  "/images/whyus/doon1.webp",
],
image : "/images/doongroup.webp",
brochure: "/brochures/doon.pdf",
cdbrochure: "/brochures/doon.pdf",
faqs: [
  {
    question: "Where is Doon Group of Colleges located?",
    answer: "The college is located in the scenic area of Selaqui and Camp Road in Dehradun. The campuses are lush green, providing a peaceful environment conducive to learning, away from city noise."
  },
  {
    question: "What courses are Doon Group of Colleges famous for?",
    answer: "It is most renowned for its Agriculture and Forestry programs (B.Sc & M.Sc). Other popular courses include B.Ed, Hotel Management (BHM), and Fisheries Science (B.F.Sc)."
  },
  {
    question: "What is the fee for B.Sc. Agriculture?",
    answer: "The fee for B.Sc. Agriculture is approximately ₹50,000 to ₹60,000 per year. The total course fee generally falls between ₹2 Lakhs to ₹2.4 Lakhs, making it a very cost-effective option."
  },
  {
    question: "Is Doon Group of Colleges approved by ICAR?",
    answer: "While the college follows the ICAR syllabus for its Agriculture courses, it is affiliated with HNB Garhwal University (Central University) and Sri Dev Suman Uttarakhand University, which grant the degrees."
  },
  {
    question: "Does the college offer B.Ed admission?",
    answer: "Yes, the college offers a B.Ed program recognized by NCTE. Admission is usually based on the state-level entrance exam or merit, as per university guidelines."
  },
  {
    question: "Are there hostel facilities for boys and girls?",
    answer: "Yes, separate hostels are available with mess facilities. The hostel fee is around ₹75,000 to ₹85,000 per year, which includes accommodation and vegetarian meals."
  },
  {
    question: "How are the placements for Hotel Management?",
    answer: "The college has good industry connections for its BHM students, offering internships and placements in reputed hotel chains like Taj, ITC, and Hyatt, as well as local resorts in Uttarakhand."
  },
  {
    question: "Does the college have its own agricultural land?",
    answer: "Yes, being an agriculture-focused college, it has its own agricultural fields and polyhouses where students gain practical hands-on experience in farming and organic cultivation."
  },
  {
    question: "What is the admission process?",
    answer: "Admission is primarily direct based on Class 12th merit. Interested students can fill out the application form online or visit the campus for counseling and seat reservation."
  },
  {
    question: "Is there a uniform code at Doon Group of Colleges?",
    answer: "Yes, students are expected to wear the college uniform on specific days and during formal functions to maintain discipline and a sense of unity among students from diverse backgrounds."
  }
]
,
aboutImages: [
"/images/Doon-Group-Of-Colleges/imgi_54_course-img01.webp",
"/images/Doon-Group-Of-Colleges/imgi_55_accordion-img.webp",
"/images/Doon-Group-Of-Colleges/imgi_7_welcome.webp"
],
  overview:
    "Doon Group of Colleges Dehradun offers diverse UG and PG programs in science, agriculture, management, IT, education and library science with focus on practical learning and placements.",

  established: "2005",
  fees_overall: "₹35K – 2.8 Lakhs (varies by program)",
  galleryImages: [
  
   "/images/Doon-Group-Of-Colleges/imgi_14_laboratory.webp",
"/images/Doon-Group-Of-Colleges/imgi_15_hostel.webp",
"/images/Doon-Group-Of-Colleges/imgi_16_classroom1.webp",
"/images/Doon-Group-Of-Colleges/imgi_2_n5ab5e75fa829f.webp",
"/images/Doon-Group-Of-Colleges/imgi_33_n5b4829846a6c5.webp",
"/images/Doon-Group-Of-Colleges/imgi_34_n5b482986650ed.webp",
"/images/Doon-Group-Of-Colleges/imgi_35_n5b482988e05d7.webp",
"/images/Doon-Group-Of-Colleges/imgi_54_course-img01.webp",
"/images/Doon-Group-Of-Colleges/imgi_55_accordion-img.webp",
"/images/Doon-Group-Of-Colleges/imgi_7_welcome.webp",
"/images/Doon-Group-Of-Colleges/imgi_9_library.webp",
       "data:image/jpeg;base64,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",
        "data:image/jpeg;base64,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",
         "data:image/jpeg;base64,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",
 
           "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQBmSLMjOR7GzzJLQiLnUf9wjrBC7i-eDfQQQ&s",
],
highlights: [
  { icon: "🏆", label: "NAAC Grade", value: "A" },
  { icon: "📊", label: "NIRF Rank", value: "#89" },
  { icon: "👥", label: "Students", value: "5k+" },
  { icon: "📚", label: "Programs", value: "90+" },
  { icon: "💼", label: "Placement", value: "70%" },
  { icon: "🏢", label: "Recruiters", value: "12+" },
],
placements: {
  highestPackage: "₹25 LPA",
  recruitersIndustries: "200+",
  gloriousAlumni: "30000+",
  placementRecords: "70%",
  recruitersImage: "/images/recruiters/doon.webp"
},
whyChooseUsData: [
  {
    id: 1,
    title: 'Diverse Multi-Disciplinary Courses',
    description: 'Comprehensive programs in engineering, management, and other fields with industry alignment.',
    imageUrl: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 2,
    title: 'Modern Campus Facilities',
    description: 'Well-maintained infrastructure with comfortable hostels, sports facilities, and adequate academic resources.',
    imageUrl: 'https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 3,
    title: 'Active Industry Interface',
    description: 'Strong collaborations with companies, workshops, and internships ensuring practical exposure.',
    imageUrl: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
],
  admissions: {
    examsAccepted: "Merit-based on 10+2 marks; CUET-UG / university entrance for some; CAT/MAT for MBA",
    applicationMode: "Online & Offline",
    applicationFee: "₹500 – 1,200",
    importantDates: [
      "Applications: March–August (rolling)",
      "Merit Lists: Monthly declarations",
      "Admissions: April–August"
    ]
  },

  eligibility: "10+2 with 45–50% (varies by course); graduation with ~50% for PG.",

  topRecruiters: "IBM, TCS, Infosys, regional tech and pharma firms, schools and education sector.",

  placement_highest: "₹8.5 – 10 LPA",
  placement_avg: "₹3.5 – 4.5 LPA",
  placement_perc: "60–70%",

  ranking: "Recognized private college in Dehradun with focus on science and agriculture programs.",

  ranking_details: "• Offers 40+ UG and PG courses\n• Strong science and agriculture focus\n• Active placement and internship support",

  facts: [
    "Strong science programs (B.Sc, M.Sc in multiple disciplines)",
    "Dedicated agriculture and forestry programs",
    "B.Ed and library science specializations",
    "Wi-Fi campus with labs and library",
    "Scholarships and fee concessions available"
  ],

  total_intake_ug: 700,
  total_intake_pg: 200,
  avg_package_overall: "₹3 – 4.5 LPA",
  highest_package_overall: "₹8.5 – 10 LPA",
  placement_rate_overall: "60–70%",

  courses: [
    // Science Programs
    {
      name: "B.Sc (Physics / Chemistry / Mathematics)",
      level: "UG",
      stream: "Science",
      duration: "3 years",
      fees: "₹1.35 – 1.65 Lakhs total",
      seats: 60,
      eligibility: "10+2 with Science, 45–50%",
      avgPackage: "₹3 – 3.8 LPA",
      highlights: [
        "Strong fundamentals in PCM subjects",
        "Good for higher studies and competitive exams"
      ]
    },
    {
      name: "B.Sc (Biology / Zoology / Botany)",
      level: "UG",
      stream: "Science",
      duration: "3 years",
      fees: "₹1.5 – 2 Lakhs total",
      seats: 60,
      eligibility: "10+2 with Science, 45%+",
      avgPackage: "₹2.8 – 3.5 LPA",
      highlights: [
        "Life sciences fundamentals",
        "Pathway to medicine and research"
      ]
    },
    {
      name: "B.Sc Computer Science",
      level: "UG",
      stream: "Science & IT",
      duration: "3 years",
      fees: "₹1.35 – 1.65 Lakhs total",
      seats: 60,
      eligibility: "10+2 with Maths, 45%+",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Programming and IT fundamentals"
      ]
    },
    {
      name: "M.Sc (Chemistry / Physics / Mathematics / Zoology / Botany / Environmental Science)",
      level: "PG",
      stream: "Science",
      duration: "2 years",
      fees: "₹1 – 1.6 Lakhs total",
      seats: 20,
      eligibility: "B.Sc in relevant subject with 50%+",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Advanced subject specialization",
        "Research and teaching pathway"
      ]
    },

    // Agriculture & Forestry
    {
      name: "B.F.Sc (Bachelor of Forestry Science)",
      level: "UG",
      stream: "Agriculture",
      duration: "4 years",
      fees: "₹2.8 Lakhs total",
      seats: 40,
      eligibility: "10+2 with PCB/PCM, 50%+",
      avgPackage: "₹3.5 – 4.5 LPA",
      highlights: [
        "Forest management and environmental conservation",
        "Government forest department roles"
      ]
    },
    {
      name: "M.F.Sc (Master of Forestry Science)",
      level: "PG",
      stream: "Agriculture",
      duration: "2 years",
      fees: "₹1.6 Lakhs total",
      seats: 15,
      eligibility: "B.F.Sc with 50%+",
      avgPackage: "₹4 – 5 LPA",
      highlights: [
        "Advanced forestry specialization"
      ]
    },

    // Health Sciences
    {
      name: "BPT (Bachelor of Physiotherapy)",
      level: "UG",
      stream: "Health Sciences",
      duration: "4 years",
      fees: "₹2.8 Lakhs total",
      seats: 40,
      eligibility: "10+2 with PCB, 50%+",
      avgPackage: "₹3.5 – 4.5 LPA",
      highlights: [
        "Rehabilitation and sports therapy",
        "Hospital and clinic roles"
      ]
    },
    {
      name: "MPT (Master of Physiotherapy)",
      level: "PG",
      stream: "Health Sciences",
      duration: "2 years",
      fees: "₹1.6 Lakhs total",
      seats: 15,
      eligibility: "BPT with 50%+",
      avgPackage: "₹4 – 5 LPA",
      highlights: [
        "Advanced physiotherapy specializations"
      ]
    },

    // Management & Commerce
    {
      name: "BBA",
      level: "UG",
      stream: "Management",
      duration: "3 years",
      fees: "₹1.5 Lakhs total",
      seats: 60,
      eligibility: "10+2 any stream, 45%+",
      avgPackage: "₹3 – 3.8 LPA",
      highlights: [
        "Business fundamentals and soft skills"
      ]
    },
    {
      name: "MBA",
      level: "PG",
      stream: "Management",
      duration: "2 years",
      fees: "₹1.13 – 1.34 Lakhs total",
      seats: 40,
      eligibility: "Graduation with 50%+",
      avgPackage: "₹4 – 5.5 LPA",
      highlights: [
        "Business specializations and placements"
      ]
    },
    {
      name: "BCA",
      level: "UG",
      stream: "IT",
      duration: "3 years",
      fees: "₹1.5 Lakhs total",
      seats: 60,
      eligibility: "10+2 with Maths, 45%+",
      avgPackage: "₹3 – 3.8 LPA",
      highlights: [
        "Software fundamentals"
      ]
    },
    {
      name: "MCom",
      level: "PG",
      stream: "Commerce",
      duration: "2 years",
      fees: "₹1 – 1.2 Lakhs total",
      seats: 40,
      eligibility: "B.Com with 50%+",
      avgPackage: "₹3.5 – 4 LPA",
      highlights: [
        "Finance and accounting specialization"
      ]
    },

    // Education
    {
      name: "B.Ed (Bachelor of Education)",
      level: "UG",
      stream: "Education",
      duration: "2 years",
      fees: "₹90K – 1.56 Lakhs total",
      seats: 80,
      eligibility: "Graduation with 50%+",
      avgPackage: "₹2.8 – 3.5 LPA",
      highlights: [
        "Teacher training program"
      ]
    },

    // Library Science
    {
      name: "B.Lib.Sc",
      level: "UG",
      stream: "Library & Info Management",
      duration: "1 year",
      fees: "₹35K total",
      seats: 30,
      eligibility: "Graduation any stream",
      avgPackage: "₹2.5 – 3 LPA",
      highlights: [
        "Library management"
      ]
    },
    {
      name: "M.Lib.Sc",
      level: "PG",
      stream: "Library & Info Management",
      duration: "1 year",
      fees: "₹40K total",
      seats: 20,
      eligibility: "B.Lib.Sc or graduation",
      avgPackage: "₹2.8 – 3.5 LPA",
      highlights: [
        "Advanced library science"
      ]
    }
  ]
},{
  slug: "maya-group-of-colleges",
  name: "Maya Group of Colleges",
location: "NH-72, Near Hotel The Competent Palace, Chakrata Road, Selaqui, Dehradun - 248011, Uttarakhand",  type: "Private Multi-Disciplinary College",
  rating: "3.8/5",
image : "/images/maya.webp",
logo : "/images/logo/maya.webp",
whyusimg: [
  "/images/whyus/maya1.webp",
  "/images/whyus/maya2.webp",
  "/images/whyus/maya3.webp",
],
faqs: [
  {
    question: "What institutions come under Maya Group of Colleges?",
    answer: "Maya Group comprises the Maya Institute of Technology & Management (MITM) and Maya Devi University. It offers a wide spectrum of courses from Engineering and Management to Pharmacy and Hotel Management."
  },
  {
    question: "Is Maya Group of Colleges good for B.Tech?",
    answer: "Yes, it is a well-known option for B.Tech in Dehradun, offering specializations like CSE, Mechanical, and Civil Engineering. It focuses on practical workshops and has decent placement support."
  },
  {
    question: "What is the highest placement package at Maya Group?",
    answer: "The highest package reported has touched ₹25 LPA in recent years, with average packages hovering around ₹4-5 LPA. Top recruiters include Amazon, HCL, and IBM."
  },
  {
    question: "What are the fees for B.Pharma at Maya Group?",
    answer: "The B.Pharma course fee is approximately ₹1 Lakh per year. The college provides well-equipped labs and is approved by the Pharmacy Council of India (PCI)."
  },
  {
    question: "Does Maya Group offer Hotel Management courses?",
    answer: "Yes, it offers a Bachelor of Hotel Management (BHM) degree. The college has excellent training kitchens and a mock bar to train students for the hospitality industry."
  },
  {
    question: "Are there scholarship opportunities?",
    answer: "Yes, Maya Group offers scholarships based on merit (percentage in qualifying exam), for Uttarakhand domicile students, and for students from economically weaker sections."
  },
  {
    question: "How is the campus life at Maya Group?",
    answer: "The campus is vibrant with regular cultural fests, sports meets, and technical workshops. It has a large playground, gym, and cafeteria, ensuring a lively atmosphere for students."
  },
  {
    question: "Is hostel facility available on campus?",
    answer: "Yes, the college provides on-campus hostels with options for AC and Non-AC rooms. The hostel fee ranges from ₹75,000 to ₹90,000 per year depending on the facilities chosen."
  },
  {
    question: "What is the admission procedure?",
    answer: "Students can apply online or offline. Admission is generally based on merit in Class 12th or Diploma (for lateral entry). For some courses, a personal interview might be conducted."
  },
  {
    question: "Does the college provide transportation?",
    answer: "Yes, a fleet of buses connects the campus with Dehradun city, Vikas Nagar, and surrounding areas, making daily commute convenient for day scholars."
  }
]
,
aboutImages: [
"/images/Maya-Group-of-Colleges/imgi_90_admission-sQGDMeLU.webp",
"/images/Maya-Group-of-Colleges/imgi_92_1712318656phpYfvh4b.webp",
"/images/Maya-Group-of-Colleges/imgi_95_1580103032phpbg9PZ8.webp"
],
cdbrochure: "/brochures/maya.pdf",


brochure: "/brochures/maya.pdf",
  overview:
    "Maya Group of Colleges Dehradun offers a wide range of B.Tech, B.Sc, B.Pharm, management, education and hospitality programs with strong emphasis on industry-aligned curriculum and placements.",

  established: "2000",
  fees_overall: "₹50K – 6.6 Lakhs (varies by program)",
  galleryImages: [
    "/images/Maya-Group-of-Colleges/imgi_101_1580103147phpbtjygY.webp",
"/images/Maya-Group-of-Colleges/imgi_7_BV4A0045-DRgQDx-N.webp",
"/images/Maya-Group-of-Colleges/imgi_83_1712318643php9DXSQF.webp",
"/images/Maya-Group-of-Colleges/imgi_86_1580102929phpTf3vhM.webp",
"/images/Maya-Group-of-Colleges/imgi_89_1712318602phpjbqJkU.webp",
"/images/Maya-Group-of-Colleges/imgi_90_admission-sQGDMeLU.webp",
"/images/Maya-Group-of-Colleges/imgi_92_1712318656phpYfvh4b.webp",
"/images/Maya-Group-of-Colleges/imgi_95_1580103032phpbg9PZ8.webp",
"/images/Maya-Group-of-Colleges/imgi_98_1712318624phpLCzg63.webp",
  "data:image/jpeg;base64,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",
  "data:image/jpeg;base64,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",
  "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxITEhUSEhIVFRUXGBcXFxgYGBkXGBYZFxYYGBcXGBgaHyghGholHRgXIjEiJSktLi4uGB8zODMtNygtLisBCgoKDg0OGhAQGzUlICUtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLf/AABEIAO0A1QMBIgACEQEDEQH/xAAcAAABBQEBAQAAAAAAAAAAAAAFAAECAwQGBwj/xAA+EAACAQMDAgQEBAQEBgEFAAABAhEAAyEEEjEFQRMiUWEGcYGRMkKhsVLB0fAUI2LhBxUzgpLxclNkc6LS/8QAGQEAAwEBAQAAAAAAAAAAAAAAAAECAwQF/8QAJxEAAgICAQMEAgMBAAAAAAAAAAECEQMhEhMxQQQiUWEUcYGRoTL/2gAMAwEAAhEDEQA/APXRT00U9UA4p6jUqBCNRqRqNAxUqU0poAVKlNNQAqVKlQA9KlSoAVKnpUAOKmoqupA0wLKD/F3hf4V/FbaJUB4nYxYBWmPLBPPagXxj8RNt8LSXDvHmdkAeBu2bJEwxb27c1j+HOo3bjmxr1ZrKoRNxQ1t2BBJZsCPw7ZGSTExUOaehA3VdJYLb1FnUjU7s7hC3mUBS6K+3IIxJjG3vmuzt2Bat3BY8O0QgZmAm5+U+cYliNwmZoGlrR3byLbRLNld5lbioHYQI2KZIkGQY4M81d8S2SLL2H8VgGUqLUboyyf8AyCi2VgjOKlasDiPjfp9+zd/xCLdNtvPvkOu7fDg+glUIHHI96P8ATfiS1ZCay+hF27YCIVgW5A2xcMiD5ZjbgEgTFLWaO9bsaXStaST4gAuEm2guK5L3GxLhd3IGWzkVjtabT6Zbul1ARrRCea2G3PjkMRtCAzJBJ80k+sU02xAfqeoe4Be1IS9ePbC7XCgrtCtLHbGI498VR0/o5vrO+3ZgFijlk/DuLGYO1SqkfiyWjtVOtsWWMaa2+0Md112DBgSpEuSqqcQADn6mkOrr4oO8kbBbueIN0rDg+XgKNwIWTn5Vmmr2Bk6beViwXUNaACwNz7T+L8OZjH609P03W6ayGBVFVj5SUW8TAg5cgqvcD/VSqlxoD6DiltpCnrpKGilTzSoAiajVhFQIoAampE01AD0qalNAD09NNKaAJUqanoAempU1AEqamp6AOL65e02k1dl3BZ3fdu2GV3SrPvEAgBj5QJBI9qGdd1Wj0RuWzpLo8SVD7tyP+UghyRABJyMbq6n4x0aPp2a4YCBmmJzGJGCR2jvNcHoNDY1t64by3rrKiFNlwHbGIKDuB3/2rGT3SJY+g6iV066prFp9h2WrsqHONzkqx8xUSpM54is/S7l+9eW+l0m0h8RzqHAkySqnt4bBmAABgGhGq11vT3nWy9u/ZG4WkuAkq5wx2ztIWIluTmKb4XuXrrHTItl98+RtsqwkrcGRJWSQJOOBio80Bq6h1i5dvi7etrF47vyufD3AqF/MCRtjgmt+r64uqYA6gWdKFuWha8Mb7aC1g+cSRIB9ZTiug1/wXet2LVm0f8QxJ33LhCbVCgrb3Dz7GYTCnDR2xXOdS0QL3bJZkus73nLKrM205Q7VhTtM/m+QmqcWkAC1fXLlsNp1vG8ittRiIBEyCRPKkYjjHeh669Hui6y+cNMSYZgQSNsEx2j3mq7mrZSAN351SVHkDEhuY3E5yY+VXaHVC26lLaE7lyw3tgqAMGfyjIzzWLYgr1TpoV83NOgIDbboFwhmAZwoCNsG5jg9oHaA1FOudP1xvvdhAbu24QhUDKgA7Sdy4EebuDSqt/A9ntAp6QFPXWUQNODTxTRQBKaiaUUooArYU1TIqMUARpU9NQA9Kmp6AHFPUaU0ASmmmmpqAJTQv4kuXls7rDqrhkw3DgsAVJ/LM80SrkvjjW3vJbslxB3XSqGVVRu3LcaEkcQZ/ED2qZukJnPfEPxHf/w9sDaATtXc9t7jLtIDOMxlQ4aeYxQDofU2ss163aVTEDfKkwVWLYxJwZyZ31X1i14sXrVxXCkJ4YcvdUwRndGDng5LSYq09OslLDLrh4SkrcVyGe3cA3E2QYlSxWDjketc23KyS/WaK3qPM4Nu4AyMQkCVm4FAUjb5XAO4x5Rnmgnwh1PTaRn1LWfEdYRFYjb5pJuDHlI2gfVqK9Ctf4p3fT7tUyhmZLhCbRuZbcqWgyIMTOCIgxWjWdLt6k+HY8BLltZZe6m4Ya0GI3OykHtw2IiqSrYz1D4c+IbWrtyn4tiuyd1DTtBPEmK8p+JOl21tC/eF63qmd5yG8TzQFYoSoubGQn1AiMChfwn1UWNdbDEWySQRuYAMQUBcSBIwfNjn1Fdtr7dq3auW3a1dO8uq2iylyZUgkDzMByv+ntWl8kM8/wD8GyWXvXAyspti2nlM7pJ48wMZB4MfKhdnJY3HNvJUtsEkgrKyYg5yf60Y6hrzbutp10uxW3LbViviBoYiWA8xkyPTiTQ/T32v3Jd7asSWJcwCXkuxMEDAMxkyKxcfgVHcaS4t1EZHVSFVWNxw7PtUANnCjnApVzmqsW9OqLe09u5dK7iQ7kbTBtyqkbXg5nkbfelVK/IH0NTioA1Ka6SiW2kVpgasApiK9tMRVtNNAFW2mK1oC0iKAMpWm21pK1WRQMoIpqu21HbSAhSirNlNtoAhTVIimigBqG9Z0QYG5sa4yI4W3uhWLiDK8ExIz6micUopNWB4mjtoxcR7JZiN4ukwqynFs7YBhjxgZHrWK38RImm/w6ojbjMsiu4P4ZAIME4yBwo4o18aK5W4n4Srljb3EwA+y20ZgZYY7ySK5a30y1cVWa8FdeBK5grukfimWkCM54Irkd3SCtWV6vqDXLm8zuIAZpnftmJx+1Lp+uezcR0aVR1uExkOMQrH2xj0qi/YNsgMCB/EQQD6gCJHB59623dYLtk2oQ7AQsYdjGGOPw+3ufSpV3Q5OPFV3Oj03xVp7zOl1VRnueML1vZuU20AdGJQf9QIB/3miXw71/S3QHKtbVFAXxYv3HBI3oojBJBljk4PavLPFYhVAJgiUjLR5RkHOMUV6feWw4e2hVm3QGk7efLHMz3NbqXyzNt+D0X4y6nordtSljcxwGc5gSxEsSQTJE8jHpXnekvWblvTjxWS8lplBOFDo6i0McD8249wZ5irtdrb11iLz+WAYWMGf3Ht6iuduWVF3Z5tm7J4w049p/rVZJwcvb2LjCXG5B+3euvN68A7XIIN2wLhKKAqbSwO1YHGOJ70qZ+sXbYVEvIEUbV3BWgAzA8pAyTxzNKsm14JaPo0GpBqhSBrqKLd9S31RNSDUAXE001HdSmgC1Xp91Ug1MGgRMvTSKgajNAFsCm2VCakpoAfZTFaTX1ABZlWeJIE/KeaV6+irLOqjsSRH75oAiUod1Tq2n043X71u2P9TAH6Dk1xHxLd6jeu7LeuVbBGTatm23fGSSfnPeuYbomhsktqLpuv/rbcfoBmatYpvx/ZDyRXk67Wf8UtLJXT27l8iZaNiCPc5/Sqem/HusfczaS1s3AKwuHuRggifuB8q5XWdf06Wzbs2QFcEDAXd2wBk/WgljXXvD8O3NtSSTjaSecH0gAdqylKEXuV/odzlqKOz631i1qLFxTp0RxLF2ydxMk25yBOSB7+tc9perWbJ3naWiBtWDPq78/bj3oT0vRPdnzkQVEqJMGZHtS1PT7Vud0lh+KTu47eg5H3FZLKo+5IfTb1JjdZ6kl4m4DtYZPcGBE4x68DvWHQW2f/AKcARJbbAGDwCczB+tEC1lbVxwoZQJjvAZZOPb3qHV1W2xFskI4DKu7swUlTJyOTk96xcnK5FOCjVdgZf0W0E7iAI3Ec+/GMZxUumusbSdpURPcryCD3kURezduKQVWBG0AgDuIEc8H70ENtkZjt2gGDmYbMGPQ8VK2qZo4uroN/4poLAxwpx29R86E6y7/mhQCNxB8+JlsEx2/qa3afUDbOwh42nEkY5/X71k1as7qGbC5JgbpLQB96mKSYnx8ENXpNxGwljHmMSJ3MAFA4EAc95pURW/dE7FJ7SsKCBwffvT1ak0LjL4PpECkBTgU8V3EjGo1OKaKAIzSmn204SgBA1YDUYqm/q7aficD9/tTSsTdGmlFANd8T20EgfVjtFch1n/iOiyBcn2TA/wDI5+1X02v+tEdReNnpF/UImXYL8z/KhWr+I7a/gBb1J8oH3ryK/wDFGqvDfatkKWC7znJ9z/SuY6hqdRdcqbrMsrhiMTyY4qeeKP2VwyNX2PR/iT4n0LOHvCwzqcQguOPbcZj5Yrntb8eFsae1uMQC0tHpCrwPrQLqmh2Wkt8zDGeZLEc103w30+34cRGQf0j0qF6lvUVRUvTUrk7OZTq+t1dxbb3SoaRAlQME/hWJ4rbrehW0i214m6QGCEhTt7nbzHPNXdIRLetUsQFW4cngCSOfka2de0wv69NTZZSi2gh5EsC8wYgiGFYPK5J8mdHQ4yjxQHvW009uSs7iFmQAvlYznviiOp0RGmS4VuKzlllsHAxgYAkf2KlrtNbuqLVwSu4HGMiQOMxBNP1fzDzExumJiCBHFc9qvs2eB87XYx9E19y0jbFDDuw48s9p45zWfq+sVmY7TJYMQATBKoDn1lYj/ep9LZrYMgwSQMHzCTwTAjnvV3Ubg8Mw6zAJVCWPImSoI/Wpt9jKeKO/dsHWNOuxypDdipPscboEHGR+1Vv1HeFQ5CHyBoEM3EkZNWWre5VW3abccE4UZPbbk/Oht3Q3FyE4nOM+nf8AeqUWzHIqrRrXUMhAO2BzB8pn0olZS3eDBo2kjtxMZHtiucJdkfaMiCY4BJ4iOflxW7p10QXDny8g/mwdwIBkf70ca2Vjm4v6Lb4a1Nm4ZTi3cOCO4Vv5VkOxGCtu3ZBJzziAOI71pu65nWLi7lbjgduTOSY9+1DRYUEOXLexniM/v+lNd9kzcW9BnRAFYlsehj9qVR6d1TYsKhYTz8vTNKizbqtdn/h0Nn41AYLF9T7H/cUQtfHm3Hi31j1k/wAzXL9VUKewaRx/fpULlwLaEAklHPJjBbnkcCvRj62cnTS/o55+kjGPJNnb2P8AiJ/91/5KD/KiVj/iCf8A61o/MR/SvO7GlRxbYqPMqEjE5A9v5Vg0up094ogslSyvBkEeSTkACmvVXdxWiZemaqpPZ7Ba+Pp/+ifk0fzrQfj22oJfw09Dvmfpya8S1q2EJQhp2bpWI/Ht/iqB6eni7Y7z9KT9Rjr/AI/0FgnbXI9K6z/xNEeXxGBMeUbFn0k5Ncvqfi3V3SRbQW/n+L9aAY8igQJAj7j9xRrQ6K4LjMzDZ5woB7eIWBhcfh+tYy9TKnWv0bR9KrV7sjqdF4gHiaovdP5AYgDme+MURsjSWrRt+TxGUKZ/FLCVzySaos9Otrda7uaSXPbaN0T79vXvV6x+LYCeC20SAJiW9pPesJZIt72bxwNRXjYU0OnUaUiYi4hjj8yz+lcVc0m+41qdpYLBicq4P7CjlzqqDHiKD6A7yT/2Tmgmqvql3eVdiFJABC4B7kgms02aNQSdsJ/EmUBjiPr55/nTafWXdu1GPyUZPeMCahri/h7iiqIlcl54Pm3YP2it3w5065eU+LccqATAOxREH8Kx68RTSb8hKcYxtK0Ziuw7rhVSf42AJ+kz+lXae7AJXe4yYRMf+Tx+1XajpFpLpCIIkEYjsD3q34q6g2lW1tlg9woZ8oAMHhee/enGClZOTNOKX2Y9PqLjmFtKuCZdiY9cLtH3mp6vS3ApLPIEGFVQvbuBPf1o30hBvGAR5uRP5TAP2rnPjPT3v+YW2CubfhqTzsB/zF+U4FOEU4tkzclkSsxdK0e+64Jkw23cx2jylvtW7xrPlBeNoA8qmGyZyTgcVV0hwLxnjM/Jlj+tEX6cgUbWIbknaMiBEyTgQfvUp6sWfFJz9qKbFwkeIjAgEHbH6SO1YdRgNbdlt/iMnJZ5/Dj0MYmBFarN5rRO8gSCYHJM9uxGaHjRpdVpaX3Eg7cH2PvM59azi6IyQcqS7guzvJ2q0MDA5kxgfT29q02ulu7lJ2NB4ysiI+YzV+hVbLbiNw4LY8uc/Xj9KJvqAzqyebEBVGcxHbmKd+QxY4uNyA7AIo0+oBVpGSQUIAiQR39uaHdRugXUVCdpgZyRnie8e9beqK9zcXGwLzLCcdwDmZ9KE+Ig27jJ9RA+4+33qoq3f+GM37jTbvKvL7J7f0xSq/p6qxdvLlsTHAwI/WmocktNHQqewr8QODc4jKHv/CD/ADqiyCMi4q+3iBT9pqrUIYkjupnnnIM/KjHT9VpUtr4xAc7iBBYkLntTStm85cIWjAHPO9CfXxE7fWm8RycMDz+ZDg896LILV1EuW08pBIBABgMRx9KJ3egWws7VOG9B2+XvT4kPK6TORuhiDhT24Q4mYkyYmqELeLLGDGSYEfyo8Oko+dgIgjEDjPpNBeoaJVvqqr2WRz2p+Bc25NULW3gWDFpAIyvn47cj96LWtW7QEtHjl2AGMfhEn/8AasXULIV1wBz2/wBbAV1GnRdn4u8gf9q9hiZmopbL5S1XkErY1LEeZUUSDtAB4BEFpY89vSk/SAzQ7uxAVoJZz+JgcHAHHftRqzZVdx5JIPAxCKvrn8NSS+qtuO2SsZ9AZ4mJkmi0iOnKS/kHXdHbQ2/IPxEenYdvpQnqdhhqLir+LbeCxnMSuDXSW7yQQWBzwIb7R9a57qJIvhvQkksQuIHO8ikmauKpm7qiP/hbe4efadwMSDtHNaPh3Wqls7i0kMMD+IDv9Kx6zXC4pUMpgFoBkxx2xH1rF0q+H8lsux4JCbRjtLHP2qk3domShxpvQQ6RpmtoEa4XOSWaQTM+pNEtbfs3tq3xaeDuAmQGAInnn2oPrLVxWANomf47h+XCgfvWvS6B2UEJaXgYTdz/APk3UkpWxSyY+K0aW1lsNG7MflPB+lQ1AlPwPEGSVMD6ms/+AvTDX3C7oAUhBzxCAURToigBm5gyWYM2P/dJRvyEs3GtHLLeVbuWRcD8TR68AAlvtRddXKwGJBx5bZP6uVoTc04a6p9PvXVaa4kMCrEKxGAo4aD/ACpxSaDNklB6Odu3yW/6NxjPJdU78wFP709vSXixO1FjPrMCeCc/+66DVWl3bgMeUj1yoMcUR6Sifm2A7e8ExJHf5iiMU2RmvipWco+ivkf9TaD2VUWfsAaWn6IZJZyxI5Jnj5/1ord1tt77W0uB2AVoiFUAbSREDnmKnduQreUMdpgepgmPXNN96CMFLHbB1/4bDp/lkboIHmUKcHBjPOK5X4k6X4YHlCkemRkSDP0rsel9Y1D20usgtAEyjeWQC2fNB4g0A+NLq3AGBBgLMEEYkYI5xFX2aMYJb/RzmnvOFCgmAMYn50q1aAeQR7+vrSqXp9jSOG1dhvqlyRg4K2jBMn8K+gFNp9ZtWN0ekMB/MGsd5maS0scZOYjik9xE8IsslnYfl7bCJke9JLkzeb4QCA6mMyRHGWUnn1JqF7rDN+dgOMXI+kTFWdOS3esJc2Rlh27N7CgdjVA31Qg41GzlQILAZhMjH+9UoXZk8rSToJN1U4gwP9NwCfnDVmu60NcViY9ywP6zRO/asoyq8DduA5zjOYMUO19hCbTWwCpHI4PmPt7UUqsam3Kh7+pViCp4ieTEH6TRI9WbAS2+eMBRxPMt+1D9RuDwVgBhBzkbUPJwck8Uf01ppBwB5f4R2Ib39KmkNylSMVzU6g4CDO2ZLNEz2AX0qt9HqCPxAYJkKvYj8ze0/aj66Nj5twAgYk8gseB7EVDW9PN1VUPsgt2mQUKxyIyQfpQqsl8mmDV6azL5rznA/M0cicLj/wB1TqtEodLcYkfqAe/1owlnwbW2d5RQszEwAPehvUtQd6OYBG2c94NKzRQ7/obpYRtKCgPO3MTieQJqfRJ0u4ugYhkxMxvwMjHcVk1UALateVSZIUzkZJMk+prT0d4J86r2PmA4NVauyeD4cQ5qr3imdm2C3/dn2Fa9FYIJbc5BA2jcdg4BgcTih51ayJuF49AzfarV1a9kuR/8SB/fNJyV2g6fsUWzVdUbpGf19+1X3Qu3aWHMxByPmB8qFX9egkSo+dxF/QsDWJut2xJF6yPWXBj/AMQalNjlGDStg68g8UdgJH6j7V1FjYAfKx3GecSSJjy+1cfq9Uki4bi7ZJ3BWYGfQATn5Vp/54IABuwB+S0BgA92b2NEU60Xl4N+46bUbTkYEAR8o9eait7vA9MqMCR3PaRNc1/zNmAYJeIicm2uPoDT+OTzYIngve5mcfhXOKFyvQnPHx+g+7oDuhVkYwFJE+0f2ar1F1QskgDOCdx+frQC4LxJAsWhBOSbjcTnLxWbqAui227ZmJYKAZOBnmlJSIeZV7UEup6tFEBhzHYj1Mj+lcjrdxEBhHdTyCSePbijOkuPcURdVTk8Lv8AKDGAJ7frWfWaZthYXGYwYkYGBwOOMVUItbZzcnNmLQyFKk8EilTLqktiGicmQAZ9zzFKm7b7DWelQavx4alPw+H/AAx+ZvyyY49afQXYElQ0GRKzBxwYMcCqtMzOGXEBTAEKBzxA9SfvQ7U2AwQsxXzAYG6Z9cihbkdT9sN+A7pOpMARlVOIVdoI/Ngc1A9QQHBI+WPlWXpGjtPbZts/5jjjPCkdz61i12ktqZZTHiiI2r9/KZFVSurMepUU6CT9YUfm5/1CfbvVF/qSMBBHPrOAD86frFgIyDZzc24xgz7VVZ0qC0hKlT5sZ43Hmcj58UnUVbG8jUtj3tcHIiBHpu79+P2oievhQo82YAOw5JwBkj0oTf1SzkAe4Pf0P6VuvI7i01pAyiNxhSQVuKeTkeUsaUabJWe1rub26xcHKXDP+lAOQP4j3NPf6pdXPhtkx/1EXME/wZ4ooLG5hERDgnA/gK857Gn1OnZgvhmDuUnO3ygwc/WikaXLewKNVduJPhAiJhndu/tFUdRLhZKpuEbVhivfncxJPPeK6HS6NvC2t+KCPxT6x5hQ/wCJFCx6f7if3pFK7q/AOtPe3puCAboxbVZlSTnnketY7njE3Ql1l2hiAGCgQCcnHp3NEBZmGUg7nUjmRCkGcetUIgN24nHiKyzzEqRMDnmneyVG4NFfTNCbhAe6WJQMQLwfludoM8d6XXOl2UYAlFlLhlt5jAAICqQcsOfWt3Tei+BcR/Fki34ZG2JgnMk/KinV+irqAnnKQrAwu4+aPcd1FVzjz7mfB9Oq2BuhdOti0ANjw2SARggMI3AHg+lY+p6az4ty0WKkqjeW2nYA/jLy0we1dP0zpIspsD7h5eQAcIq+p9JqOq6RZulmKtvKhZBAwAwAAIPcjPqoo5bY5Y24I5W6VCKoyAOTEnmJArVb1ygrOVgAjI5B/wD6P6UN6pojbkREe8nP78GsttWdgqjJwPtJPyrNX3M5yl2Z03Stapui2MLEZMxAn6/Ki19Mp5VP+YvImAQy8A+4rjNITbvrwYbk8ek11uq6mgUgEbv0/wDeKzc+nvuOM08bRPSa8tq7thisZiFHKqJHqO/HesfxHH+HYg4x+9BE1rJqzdBySfSPMIafvRLquoV7Lw0nB7Hg8e1Wn2DE7hI5l+o3UUBLrqBOAxUSTPaK1BnNzVLJJ3Ssk4ktxM9iKu6PqjbS5s/ESuZjHE/361h6levW2lmkE4hpz+9bqVqiILjUgaysO9KrHbue9KrFo6Jb+1W47QYiM0yXlVSYBIKsoPrxIptX00qrQ+4Y7GOe81PQ6awyjxGfecYIjmQBPeuK13RpPKnJ15Rt6f1G0tuBCyWJAEZJPP0j7VjTXAX2YztIHv29D86lp+lpmN5AZhn2Pp6xQ+4Yvgdt0H5TEf36VTlbZnLLpKuwTbrPM7pkjGJzWHVazc4btEQeTPP8qKf8stBjtLMJ/Mox9aF9RsbbkYgQ0HH7dqlTT0TPLJqmZLewsFKn7/0otp+ri2sLbwJ4OOfeaKjTWbiAqjBo5CxzzmM/Ws+l6YqrG1j8xNS8v0Usji9Iaz8RHkWvnn147VYPiWCB4cTwJOf0rH1jSMEZllQgLHy8wJq3pXTnNpWIZi6hgSOJE/zp8/byNPyJV2Lr/XrjeVBtI5Pf5ZobrdSbsqZLKIEnn1/ai2l6aVGUJPcnvXNwTeK/6ivH996UZOX8Ev1E0lot02qdUU9g64+TCtZ1hDl8SSI9q36jTnwvwzG0z8mBq+/08tE2ziiWRtdhvNNqkgRqOrNvVuDifrPaih67cA4gD2+1c/1W0RdM87vt2ArdoTevz/lTbBKkjGR7zOKqnVr+SVlnul3HvfEN73+g/pmq16tdbzkkHIUHBJ9Pl/SjY0TqANqgfPignxHbIKSfUiM/WojK3VCeTJWzJqb9x4NxT/OD2xVF67Itm2hBCQxUMZ3Mxz9NorpBaZrSuAvAaJ57x8+1Yeg2mKMUgjeRmZgAAfpWiyPi3Q+U3sEFHkHY3pxUlVzu3I2T6H+4rpnsHAJUH5T/ADp/8Cx5ufZQKlTk/BPGXwci9m4OEb2x70ws3s+Q89665tAP4iauTQoRz/WrU38FKD8nCtpr0xt961WNA5kvbJ7j51140VsZx96a6loLugRHzmr6jGoJHC6q0UIDc0q19Y1S3HBRdsCPnnmmroi9bJfc7m5pbu3aRbiIPmP70LforEBQFTzbiQ7E+mPpRtXHerFuL6V4n5ORGHUkZ7l1gx8O1tXJy0sTjPGPlQTqHSLzsSlsAlpndHzrqVYVNXFJ+sndh1GC0uXwgXwlkACSZmOfvQ6/o7rsWewrnEGYiOf0iumDgdv2qBu98/el+XO7oHkb7gHoul1FrDLuBOdzEmPrRi1fcAzbA9Iq7x6g12fWj8vI3ZXWkZ9XedrZUIsn+KCp/wDkByPans6i6AoNq3AABCDauMeUdhVniioNfp/k5Q60i19S2P8AK+f+1CL+khw1vToO5nOfbPNb2un1qBZuwpr1GQOrJ9y+xrnVTNhXkRtMEH74H+3vNVHXXjJZFB9jj9IiorupbT3NV+TOqH1ZGPXWt8E2k3CPNj1z9I/esvSNHds7oI8xk+vyowMUi1J+onVAssjHqrdx12gwe5Mmap1ejLKoiSvc9/XtRAsaibkelLqyFzZVb3AcRntwPpWPQWHtm5Awzlhkd/2zNby9RLe1V1pFdVmQ27k9ue5n+VatpIjjEf3imNyom7S6r+BrKR8AxBJInmkygdxif1pjcqJaarqsXVIs0fmn6VlvOYgrj2HHpitRYRnn6RHyqAg/2Imrjl+iuoAtdpASCEbv2A/alRzbTVqvUtB1EFFYU5b3qs3fY1AuP4fvXn0c5bu96l4h96qLinFwUUIt8Y+9SF8+n7moC57Ujc9qVAWeJPal4lUG57Ut/vT4gXbvaoFvaq/F9qYv70UIu+lKazm7T+JRQy5iPWmmoB/SaRb2NAE5pM9Vg9opm+lA0OXqG/2NSJPaP2qBDeoirRSQ80wPqaeluHrQ6E1RXvHrTk0iB6VIH0pCKdv0pQKsJ9QKifamBEimC45qVOXpgRA96VQIng0qAstL0273+1UipBfeiiS0N/ZqQaqwB61PaKWhklapEe5ptsegqHi/L60DJxTk1WLsnFJD7TRQUW7qiWHoKrE/KkonM0CotVx6Umc9qqpGfT+dLQizefUVHxqaG7/pUYPr78UaAdr/ALUxvzUImosPWqpBRYbvrSDz/f8AWmCLH4vpFVspo0BcrUtw7VWlomBU79or6fSigH3U276VTI9c0lf606AuqJn1qHiA81XdvhTlSe+PTk01G3SGi1vWkKrs3VbjHpu+eKm49f8Ab70NU6HQzL7kUqruPSp0wou8T2p/G9h+lZ7bTk/apLdH8IocSqo0LcLYAmoPfggHE/WT/f2prfpWHXuyEHduB7MMD7fKqhBN0AUZ/eqt9DNFqZaAInPMx7CiO+aUoOLoVly3fpUyq81lLGalqNwjzYNTTCy43T2A/rTh/YfrWXxfNEeke30q5AWmTxPGOMzScAStlhu+1NuPpHv3qkMYqaNOfpS4jLlY9/pVW0Af2KktIikOiJY/KkVHfPzpG4RIFRLd+KYqJYpY9aXaZ9B/vWcEegz3ppCLBP8AZpifWqrjn+dVhzMVSiS0WsY7Z+dMT7U5tR9JqRtzkn+xVUFEFvqJJnyqTzQ3U6sk7AeQPYRzPrRXWWgCVgHyjP6z86Gam2qrvI3NIWT6H+da4uPcpDadFRjnygCDOD8/XmiQyobEfOhupsi2HIkwREniYP8AM1XptSQrTnaJ+eRz96qUOe0FWEmePX7Uqr0zEiZ5ilWdEn//2Q==",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTzwKdjpC3ooIbd-n5VjCaN5BeXD_3GgTw1jg&s",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRkeHh8GiaqpMMBGY4Uja5iq-qzFg2Fn2twQQ&s",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTO2UrK25jGYnSTTMKeeBjn0IagGmUo5OvtPg&s",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4pS9SV0R4rnGJIP8MQzybPZ_Qf_crm0otKA&s",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSpYdCpq03P2qLi5opyybAwieiZAs2FsO7gw&s",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQSpB5WBeZnVTW-TG5g9VIDkKsKPCLtwx1wvw&s",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBUbkU2BAoF0L5364d0oimX9u8_mfYTnYPjQ&s",

  ],
  highlights: [
  { icon: "🏆", label: "NAAC Grade", value: "A+" },
  { icon: "📊", label: "NIRF Rank", value: "N/A" },
  { icon: "👥", label: "Students", value: "8k+" },
  { icon: "📚", label: "Programs", value: "143+" },
  { icon: "💼", label: "Placement", value: "75%" },
  { icon: "🏢", label: "Recruiters", value: "250+" },
],
  whyChooseUsData: [
  {
    id: 1,
    title: 'Job-Oriented Curriculum',
    description: 'Comprehensive programs in engineering, pharmacy, management designed with industry standards and practical focus.',
    imageUrl: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 2,
    title: 'Excellent Placement Records',
    description: '48 LPA highest package with 500+ recruiters ensuring students secure positions in leading companies.',
    imageUrl: 'https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: 3,
    title: 'Holistic Development Ecosystem',
    description: 'Beautiful Himalayan campus providing sporting, cultural opportunities and entrepreneurship development modules.',
    imageUrl: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
],
  placements: {
  highestPackage: "₹48 LPA",
  recruitersIndustries: "500+",
  gloriousAlumni: "11000+",
  placementRecords: "92%",
  recruitersImage: "/images/recruiters/maya.webp"
},
  admissions: {
    examsAccepted: "JEE Main / UKSEE for B.Tech; merit-based for other UG programs; CAT/MAT for MBA",
    applicationMode: "Online & Offline",
    applicationFee: "₹1,000 – 1,500",
    importantDates: [
      "Applications: April–August (rolling)",
      "Merit/Entrance Lists: May–August",
      "Admissions: June–September"
    ]
  },

  eligibility: "10+2 with 45–50% (varies by course); for PG, graduation with 45–50%+.",

  topRecruiters: "Cisco, IBM, L&T, TATA, Godrej, Sun Pharma, regional tech firms and schools.",

  placement_highest: "₹12 – 14 LPA",
  placement_avg: "₹4 – 5 LPA",
  placement_perc: "65–75%",

  ranking: "Recognized multi-disciplinary college in Dehradun with diversified program offerings and industry connections.",

  ranking_details: "• 50+ UG and PG courses across engineering, science, pharmacy, management, education and hotel management\n• Strong recruitment network with 100+ companies\n• Active placement and training programs",

  facts: [
    "B.Tech specializations in CSE, Mechanical, Civil, ECE, IT with emerging tech focus",
    "B.Pharma and D.Pharma programs with strong industry partnerships",
    "BBA, B.Com, B.Sc and hospitality management programs",
    "Modern labs, hostels and Wi-Fi enabled campus",
    "Scholarships for merit and reserved categories"
  ],

  total_intake_btech: 300,
  total_intake_ug_overall: 800,
  total_intake_pg: 200,
  avg_package_overall: "₹3.5 – 5 LPA",
  highest_package_overall: "₹12 – 14 LPA",
  placement_rate_overall: "65–75%",

  courses: [
    // B.Tech Engineering
    {
      name: "B.Tech Computer Science & Engineering",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹2.5 – 3 Lakhs/year",
      seats: 120,
      eligibility: "10+2 PCM, 50%+; JEE Main / UKSEE",
      avgPackage: "₹4.5 – 6 LPA",
      highlights: [
        "Core CSE with emerging tech focus",
        "Coding and placement training",
        "IT industry roles"
      ]
    },
    {
      name: "B.Tech Information Technology",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹2.5 – 3 Lakhs/year",
      seats: 60,
      eligibility: "10+2 PCM, 50%+; JEE Main",
      avgPackage: "₹4 – 5.5 LPA",
      highlights: [
        "IT systems and networks",
        "Software development roles"
      ]
    },
    {
      name: "B.Tech Mechanical Engineering",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹2.3 – 2.8 Lakhs/year",
      seats: 60,
      eligibility: "10+2 PCM, 50%+; JEE Main",
      avgPackage: "₹3.5 – 5 LPA",
      highlights: [
        "Design, manufacturing and thermal engineering",
        "Manufacturing and automotive roles"
      ]
    },
    {
      name: "B.Tech Civil Engineering",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹2.3 – 2.8 Lakhs/year",
      seats: 60,
      eligibility: "10+2 PCM, 50%+",
      avgPackage: "₹3 – 4.5 LPA",
      highlights: [
        "Structural and construction engineering",
        "Infrastructure and construction roles"
      ]
    },
    {
      name: "B.Tech Electronics & Communication Engineering",
      level: "UG",
      stream: "Engineering",
      duration: "4 years",
      fees: "₹2.3 – 2.8 Lakhs/year",
      seats: 60,
      eligibility: "10+2 PCM, 50%+",
      avgPackage: "₹3.5 – 5 LPA",
      highlights: [
        "Electronics and telecom focus",
        "IoT and embedded systems"
      ]
    },

    // Science Programs
    {
      name: "B.Sc (Physics / Chemistry / Mathematics / Biology)",
      level: "UG",
      stream: "Science",
      duration: "3 years",
      fees: "₹1.8 – 2.4 Lakhs total",
      seats: 60,
      eligibility: "10+2 with Science, 45%+",
      avgPackage: "₹2.8 – 3.8 LPA",
      highlights: [
        "Strong science fundamentals",
        "Higher studies and research pathway"
      ]
    },
    {
      name: "M.Sc (Physics / Chemistry / Mathematics / Biology / Environmental Science)",
      level: "PG",
      stream: "Science",
      duration: "2 years",
      fees: "₹98.6K – 1.6 Lakhs total",
      seats: 20,
      eligibility: "B.Sc in relevant subject, 45–50%+",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Advanced specialization"
      ]
    },

    // Pharmacy
    {
      name: "B.Pharma",
      level: "UG",
      stream: "Pharmacy",
      duration: "4 years",
      fees: "₹2 – 2.5 Lakhs/year (approx.)",
      seats: 80,
      eligibility: "10+2 with PCB, 45%+",
      avgPackage: "₹3.5 – 4.5 LPA",
      highlights: [
        "Comprehensive pharmacy education",
        "Pharma industry and hospital roles"
      ]
    },
    {
      name: "D.Pharma",
      level: "Diploma",
      stream: "Pharmacy",
      duration: "2 years",
      fees: "₹90,000 – 1.2 Lakhs/year",
      seats: 60,
      eligibility: "10+2 with PCB",
      avgPackage: "₹2.5 – 3.5 LPA",
      highlights: [
        "Entry-level pharmacy qualification"
      ]
    },

    // Management & Commerce
    {
      name: "BBA",
      level: "UG",
      stream: "Management",
      duration: "3 years",
      fees: "₹1.8 Lakhs total",
      seats: 60,
      eligibility: "10+2 any stream, 45%+",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Business fundamentals and management"
      ]
    },
    {
      name: "B.Com",
      level: "UG",
      stream: "Commerce",
      duration: "3 years",
      fees: "₹1.8 Lakhs total",
      seats: 60,
      eligibility: "10+2 with 45%+",
      avgPackage: "₹2.8 – 3.5 LPA",
      highlights: [
        "Commerce and finance focus"
      ]
    },

    // Hospitality
    {
      name: "BHM (Bachelor of Hotel Management)",
      level: "UG",
      stream: "Hospitality",
      duration: "3 years",
      fees: "₹2.8 Lakhs total",
      seats: 60,
      eligibility: "10+2 any stream, 45%+",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Hotel operations and hospitality management",
        "Hospitality industry roles"
      ]
    },

    // IT & Computer Applications
    {
      name: "BCA",
      level: "UG",
      stream: "IT",
      duration: "3 years",
      fees: "₹1.5 – 1.8 Lakhs total",
      seats: 60,
      eligibility: "10+2 with Maths, 45%+",
      avgPackage: "₹3 – 4 LPA",
      highlights: [
        "Software development fundamentals"
      ]
    },

    // Education
    {
      name: "B.Ed",
      level: "UG",
      stream: "Education",
      duration: "2 years",
      fees: "₹80K – 1.2 Lakhs total",
      seats: 80,
      eligibility: "Graduation with 50%+",
      avgPackage: "₹2.5 – 3.5 LPA",
      highlights: [
        "Teacher training and education specialization"
      ]
    },

    // PG
    {
      name: "MBA",
      level: "PG",
      stream: "Management",
      duration: "2 years",
      fees: "₹1.2 – 1.5 Lakhs/year",
      seats: 60,
      eligibility: "Graduation with 50%+; CAT/MAT",
      avgPackage: "₹4.5 – 6 LPA",
      highlights: [
        "Business specializations and corporate roles"
      ]
    },
    {
      name: "M.Tech Computer Science & Engineering",
      level: "PG",
      stream: "Engineering",
      duration: "2 years",
      fees: "₹1.3 – 1.6 Lakhs/year",
      seats: 30,
      eligibility: "B.Tech CSE with 50%+; GATE preferred",
      avgPackage: "₹5 – 7 LPA",
      highlights: [
        "Advanced computing and research focus"
      ]
    }
  ]
},

{
    slug: "tulas-institute",
    name: "Tula's Institute",
location: "Dhoolkot, Post Office: Selaqui, Chakrata Road, Dehradun - 248011, Uttarakhand",
    type: "Private Engineering Institute",
    rating: "4.2/5",
    image: "/images/tula.webp",
    brochure: "/brochures/tulas.pdf",
logo: "/images/logo/tula.webp",    
whyusimg: [
"/images/Tula-Institute/imgi_114_infrastructure1.50a67a88.webp",
"/images/Tula-Institute/imgi_118_infrastructure5.906e1135.webp",
"/images/Tula-Institute/imgi_132_sports4.2395b562.webp"
],
faqs: [
  {
    question: "What is Tula's Institute ranked for?",
    answer: "Tula's Institute is consistently ranked among the top private engineering and management colleges in North India by bodies like The Times of India and Silicon India. It is known for its academic excellence."
  },
  {
    question: "Is Tula's Institute affiliated to a university?",
    answer: "Yes, Tula's Institute is affiliated with Uttarakhand Technical University (UTU) for its technical courses and Sri Dev Suman Uttarakhand University for others. It is also AICTE approved."
  },
  {
    question: "What is the placement record of Tula's Institute?",
    answer: "Tula's boasts a strong placement record with over 650+ companies visiting. The highest package has reached ₹36.5 LPA, and the average package is around ₹4.5 - ₹6 LPA."
  },
  {
    question: "What are the fees for B.Tech CSE?",
    answer: "The fee for B.Tech Computer Science is approximately ₹1.4 Lakhs to ₹1.6 Lakhs per year. The total 4-year fee is roughly ₹6 Lakhs to ₹6.5 Lakhs."
  },
  {
    question: "Does Tula's Institute have a dress code?",
    answer: "Yes, Tula's maintains a professional environment with a prescribed uniform. Students are required to wear the uniform on weekdays to instill a sense of discipline and corporate readiness."
  },
  {
    question: "How are the hostel facilities at Tula's?",
    answer: "Tula's offers some of the best hostel facilities in Dehradun with balcony rooms, 24/7 solar hot water, gym, and recreation rooms. Hostel fees range from ₹1 Lakh to ₹1.4 Lakhs per year."
  },
  {
    question: "What is the admission process for B.Tech?",
    answer: "Admission is based on JEE Mains merit or Class 12th PCM percentage. Candidates can register online on the official website and attend counseling for seat allocation."
  },
  {
    question: "Does the college encourage extracurricular activities?",
    answer: "Absolutely. Tula's is famous for its annual fest 'Sanskriti', celebrity nights, and vibrant student clubs for dance, music, drama, and technical hobbies."
  },
  {
    question: "Are there any collaborations with industries?",
    answer: "Yes, Tula's has tie-ups with companies like Microsoft (Innovation Center), D-Link, and Red Hat Academy to provide industry-relevant certifications and training to students."
  },
  {
    question: "Is the campus ragging-free?",
    answer: "Yes, Tula's Institute is strictly a no-ragging zone. The administration takes severe action against any such activities, ensuring a safe and friendly environment for freshers."
  }
]
,
aboutImages: [
"/images/Tula-Institute/imgi_49_MassCommunication.d91f44a6.webp",
"/images/Tula-Institute/imgi_51_Pharmacy.0aafee50.webp",
"/images/Tula-Institute/imgi_53_BannerImage2.0ea55ef8.webp"
],
    overview:
      "Tula's Institute is a leading private engineering college in Dehradun with strong industry partnerships and focus on technical excellence. Known for diverse engineering specializations, active placement cell, and comprehensive skill development programs covering 15+ B.Tech specializations.",
    established: "2000",
    fees_btech: "₹1.14 – 1.68 Lakhs/year",
    admissions: {
      examsAccepted: "JEE Main / UKSEE / Board Merit",
      applicationMode: "Online",
      applicationFee: "₹1,000",
      importantDates: [
        "Application Opens: December",
        "Last Date to Apply: May",
        "Entrance Exam: Based on JEE Main scores"
      ]
    },
    highlights: [
      { icon: "📊", label: "B.Tech Specializations", value: "15+" },
      { icon: "👥", label: "Students", value: "6,000+" },
      { icon: "📚", label: "Total Programs", value: "37" },
      { icon: "💼", label: "Placement Rate", value: "75-90%" },
      { icon: "🏆", label: "Highest Package", value: "₹36.5 LPA" },
      { icon: "🏢", label: "Top Recruiters", value: "750+" }
    ],
    eligibility: "10+2 with PCM and minimum 45% marks + JEE Main / UKSEE score",
    placements: {
      highestPackage: "₹36.5 LPA",
      averagePackage: "₹5.6 LPA",
      recruitersIndustries: "750+",
      placementRecords: "85%",
      gloriousAlumni: "6000+",
      recruitersImage: "/images/recruiters/tula.webp"
    },
    ranking:
      "Recognized as one of the top private engineering colleges in Uttarakhand with strong industry presence",
    ranking_details:
      "• AICTE Approved Institution\n• Strong placement record with 750+ industry partnerships\n• Diverse specializations in CSE, ECE, Mechanical, Civil, Biotechnology, and Agriculture\n• Active industry collaborations with Adobe, BYJU's, Wipro, and others",
    facts: [
      "15 B.Tech specializations including AI, Data Science, Biotechnology",
      "Modern laboratories with industry-standard equipment and software",
      "Regular industry expert lectures and guest sessions",
      "Active student clubs for coding, robotics, entrepreneurship, and culture",
      "Campus internship opportunities from 5th semester onwards",
      "Strong alumni network across Fortune 500 companies"
    ],
    whyChooseUsData: [
      {
        id: 1,
        title: "Industry-Aligned Curriculum",
        description:
          "Courses designed with industry experts ensuring current, market-relevant technical skills and certifications.",
        imageUrl:
          "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 2,
        title: "Strong Placement Cell",
        description:
          "Dedicated placement team with 750+ industry partnerships, ensuring 75-90% placement success across all branches.",
        imageUrl:
          "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 3,
        title: "Modern Infrastructure",
        description:
          "State-of-the-art labs, well-stocked libraries, workshops, and sports facilities supporting holistic development.",
        imageUrl:
          "https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      }
    ],
    galleryImages: [
     "/images/tula-Institute/bannerImg.8ccc6874.webp",
"/images/tula-Institute/bannerImgLibrary.76d93fb3.webp",
"/images/tula-Institute/bookBank.d31223bf.webp",
"/images/tula-Institute/imgi_101_love4.1400203d.webp",
"/images/tula-Institute/imgi_102_placements1.42a6858f.webp",
"/images/tula-Institute/imgi_103_placements2.cff16af5.webp",
"/images/tula-Institute/imgi_105_placements4.d1b9b496.webp",
"/images/tula-Institute/imgi_114_infrastructure1.50a67a88.webp",
"/images/tula-Institute/imgi_115_infrastructure2.f0e78ac4.webp",
"/images/tula-Institute/imgi_116_infrastructure3.f1a2a8ae.webp",
"/images/tula-Institute/imgi_117_infrastructure4.f3ced496.webp",
"/images/tula-Institute/imgi_118_infrastructure5.906e1135.webp",
"/images/tula-Institute/imgi_120_computer2.63e5a5aa.webp",
"/images/tula-Institute/imgi_122_computer4.47b1d5de.webp",
"/images/tula-Institute/imgi_123_computer5.e23989d5.webp",
"/images/tula-Institute/imgi_127_hostel4.bac7929c.webp",
"/images/tula-Institute/imgi_128_hostel5.391dc230.webp",
"/images/tula-Institute/imgi_132_sports4.2395b562.webp",
"/images/tula-Institute/imgi_133_sports5.0f69adc9.webp",
"/images/tula-Institute/imgi_135_BackgroundVirtual.c0af56c7.webp",
"/images/tula-Institute/imgi_183_RankedBannerDesktop.9cb3842b.webp",
"/images/tula-Institute/imgi_198_stats.4bdb0692.webp",
"/images/tula-Institute/imgi_199_BackgroundImageScroll.8e54697e.webp",
"/images/tula-Institute/imgi_46_Engineering.f9901b19.webp",
"/images/tula-Institute/imgi_47_Business.512c7245.webp",
"/images/tula-Institute/imgi_49_MassCommunication.d91f44a6.webp",
"/images/tula-Institute/imgi_51_Pharmacy.0aafee50.webp",
"/images/tula-Institute/imgi_53_BannerImage2.0ea55ef8.webp"
    ],
    courses: [
      {
        name: "B.Tech Computer Science and Engineering (CSE)",
        duration: "4 years",
        fees: "₹1.15 - 1.68 Lakhs/year"
      },
      {
        name: "B.Tech Electronics and Communication Engineering (ECE)",
        duration: "4 years",
        fees: "₹1.14 - 1.68 Lakhs/year"
      },
      {
        name: "B.Tech Mechanical Engineering",
        duration: "4 years",
        fees: "₹1.14 - 1.68 Lakhs/year"
      },
      {
        name: "B.Tech Civil Engineering",
        duration: "4 years",
        fees: "₹1.14 - 1.68 Lakhs/year"
      },
      {
        name: "B.Tech Biotechnology",
        duration: "4 years",
        fees: "₹1.25 - 1.75 Lakhs/year"
      },
      {
        name: "BCA (Bachelor of Computer Applications)",
        duration: "3 years",
        fees: "₹83,500/year"
      },
      {
        name: "MBA (Master of Business Administration)",
        duration: "2 years",
        fees: "₹2,03,500/year"
      }
    ]
  },

  {
    slug: "shivalik-college-engineering",
    name: "Shivalik College of Engineering (SCE)",
location: "Shimla Bypass Road, Shiniwala, Sherpur, Dehradun - 248197, Uttarakhand",
    type: "Private Engineering College",
    rating: "4.1/5",
    image: "/images/shivalik.webp",
    brochure: "/brochures/shivalik.pdf",
logo: "/images/logo/shivalik.webp",
   whyusimg: [
"/images/Shivalik-College-of-Engineering/imgi_62_1463122682campu2.webp",
"/images/Shivalik-College-of-Engineering/imgi_88_1463122682campu5.webp",
"/images/Shivalik-College-of-Engineering/imgi_90_1463122682campus.webp"
],
faqs: [
  {
    question: "Is Shivalik College of Engineering a good choice for B.Tech?",
    answer: "Shivalik College is a reputable choice for B.Tech in Dehradun, known for its practical learning approach, IIT-affiliated labs, and strong focus on innovation and research."
  },
  {
    question: "What unique facilities does Shivalik College offer?",
    answer: "The college has established an 'Innovation and Entrepreneurship Development Centre' (IEDC) and has a dedicated robotics lab (e-Yantra) in collaboration with IIT Bombay."
  },
  {
    question: "What is the fee structure for B.Tech?",
    answer: "The B.Tech fees are quite competitive, ranging from ₹1.1 Lakhs to ₹1.25 Lakhs per year. This includes tuition and other academic charges, offering good value for money."
  },
  {
    question: "How are the placements at Shivalik College?",
    answer: "Placements are consistent, with a reported 92% placement rate. Major recruiters include Byju's, TCS, Wipro, and Bajaj. The highest package has gone up to ₹30 LPA."
  },
  {
    question: "Does the college offer Diploma courses?",
    answer: "Yes, Shivalik College offers Polytechnic Diploma courses in Civil, Electrical, and Mechanical Engineering for students who have completed their Class 10th."
  },
  {
    question: "Is there a hostel on campus?",
    answer: "Yes, Shivalik provides separate, well-furnished hostels for boys and girls. The environment is secure, and the mess serves nutritious food. Hostel fees are around ₹80,000 per year."
  },
  {
    question: "Does Shivalik College offer scholarships?",
    answer: "The college offers merit-based scholarships for students with high percentage in 12th/JEE, as well as special scholarships for girls and wards of defence personnel."
  },
  {
    question: "What is the B.Sc Agriculture course like?",
    answer: "The college has a dedicated College of Pharmacy and Agriculture. The B.Sc Agriculture program includes practical field work and is affiliated with Sri Dev Suman Uttarakhand University."
  },
  {
    question: "Is the college accessible from the city?",
    answer: "Yes, it is located on Shimla Bypass Road, about 15 km from ISBT Dehradun. The college provides bus facilities for day scholars from all major points in the city."
  },
  {
    question: "How to apply for admission?",
    answer: "Candidates can apply online through the Shivalik College website or visit the admission office on campus. Admission is generally based on merit and seat availability."
  }
]
,
    aboutImages: [
"/images/Shivalik-College-of-Engineering/imgi_95_1463122837lab6.webp",
"/images/Shivalik-College-of-Engineering/imgi_96_1463122837lab33.webp",
"/images/Shivalik-College-of-Engineering/imgi_97_1463122837lab44.webp"
],
    overview:
      "Established in 2008, Shivalik College of Engineering is a non-profit organization pioneering technical education in Uttarakhand. AICTE and PCI accredited with strong partnerships from IIT Bombay, IBM, and industry leaders. Known for excellent placements, modern infrastructure, and comprehensive engineering programs.",
    established: "2008",
    fees_btech: "₹93,900 – 1.24 Lakhs/year",
    admissions: {
      examsAccepted: "JEE Main / UKSEE / Board Merit",
      applicationMode: "Online",
      applicationFee: "₹1,000",
      importantDates: [
        "Application Opens: December",
        "Last Date to Apply: May",
        "Merit List: June"
      ]
    },
    highlights: [
      { icon: "🏆", label: "AICTE Approved", value: "Yes" },
      { icon: "📊", label: "B.Tech Programs", value: "11+" },
      { icon: "👥", label: "Students", value: "4,500+" },
      { icon: "💼", label: "Placement Rate", value: "92%" },
      { icon: "📈", label: "Highest Package", value: "₹42 LPA" },
      { icon: "🏢", label: "Top Recruiters", value: "500+" }
    ],
    eligibility: "10+2 with PCM and minimum 45% marks + JEE Main / UKSEE score",
    placements: {
      highestPackage: "₹42 LPA",
      averagePackage: "₹7 LPA",
      recruitersIndustries: "500+",
      placementRecords: "92%",     
      gloriousAlumni: "1000+",

      recruitersImage: "/images/recruiters/shivalik.webp"
    },
    ranking:
      "Strong tier-2 engineering college with excellent placement record and recognized industry partnerships",
    ranking_details:
      "• AICTE Approved with PCI recognition\n• Consistent 92% placement rate across branches\n• 500+ industry partners including Google, Amazon, Capgemini\n• Strong focus on metallurgical and material science engineering\n• Active industry collaborations and guest lectures",
    facts: [
      "11+ B.Tech specializations with AI, Data Science, IoT specializations",
      "AICTE and PCI accredited institution with quality assurance",
      "Modern laboratories with industry-standard equipment",
      "Strong alumni network working at Google, Amazon, Infosys, TCS",
      "Paid internship opportunities and live company drives",
      "Scholarship programs for merit and Uttarakhand-based students"
    ],
    whyChooseUsData: [
      {
        id: 1,
        title: "Excellent Placement Record",
        description:
          "92% placement rate with top recruiters like Google, Amazon, and Capgemini ensuring strong career prospects.",
        imageUrl:
          "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 2,
        title: "Industry Partnerships",
        description:
          "Collaborations with IIT Bombay, IBM, and 500+ companies providing real-world learning and internships.",
        imageUrl:
          "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 3,
        title: "Specialized Programs",
        description:
          "Advanced specializations in AI, Data Science, IoT, and metallurgical engineering preparing for future tech trends.",
        imageUrl:
          "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      }
    ],
    galleryImages: [
     "/images/Shivalik-College-of-Engineering/imgi_100_1463122837lib.webp",
"/images/Shivalik-College-of-Engineering/imgi_101_1463122837lib3.webp",
"/images/Shivalik-College-of-Engineering/imgi_102_1463122837lib32.webp",
"/images/Shivalik-College-of-Engineering/imgi_107_1615099386BTech_ECE.webp",
"/images/Shivalik-College-of-Engineering/imgi_113_1615099386Polytechnic_in_ElectricalEngineering.webp",
"/images/Shivalik-College-of-Engineering/imgi_115_1615100560cse1.webp",
"/images/Shivalik-College-of-Engineering/imgi_117_1615100561cse6.webp",
"/images/Shivalik-College-of-Engineering/imgi_126_IMG-20250510-WA0004.webp",
"/images/Shivalik-College-of-Engineering/imgi_128_IMG-20250510-WA0003.webp",
"/images/Shivalik-College-of-Engineering/imgi_130_IMG-20250510-WA0005.webp",
"/images/Shivalik-College-of-Engineering/imgi_131_IMG-20250510-WA0002.webp",
"/images/Shivalik-College-of-Engineering/imgi_132_inbound3777785929179636688.webp",
"/images/Shivalik-College-of-Engineering/imgi_133_17129143588517623805358296270696.webp",
"/images/Shivalik-College-of-Engineering/imgi_135_15038_SCE_New.webp",
"/images/Shivalik-College-of-Engineering/imgi_62_1463122682campu2.webp",
"/images/Shivalik-College-of-Engineering/imgi_63_1463122682campu4.webp",
"/images/Shivalik-College-of-Engineering/imgi_88_1463122682campu5.webp",
"/images/Shivalik-College-of-Engineering/imgi_89_1463122682campu6.webp",
"/images/Shivalik-College-of-Engineering/imgi_90_1463122682campus.webp",
"/images/Shivalik-College-of-Engineering/imgi_91_1463122682campuuee.webp",
"/images/Shivalik-College-of-Engineering/imgi_95_1463122837lab6.webp",
"/images/Shivalik-College-of-Engineering/imgi_96_1463122837lab33.webp",
"/images/Shivalik-College-of-Engineering/imgi_97_1463122837lab44.webp",
"/images/Shivalik-College-of-Engineering/imgi_98_1463122837lab667.webp"
    ],
    courses: [
      {
        name: "B.Tech Computer Science and Engineering (CSE)",
        duration: "4 years",
        fees: "₹93,900/year"
      },
      {
        name: "B.Tech CSE with AI and Machine Learning",
        duration: "4 years",
        fees: "₹93,900/year"
      },
      {
        name: "B.Tech Electronics and Communication Engineering (ECE)",
        duration: "4 years",
        fees: "₹93,900/year"
      },
      {
        name: "B.Tech Mechanical Engineering",
        duration: "4 years",
        fees: "₹93,900/year"
      },
      {
        name: "B.Tech Civil Engineering",
        duration: "4 years",
        fees: "₹93,900/year"
      },
      {
        name: "B.Pharma (Bachelor of Pharmacy)",
        duration: "4 years",
        fees: "₹89,300/year"
      },
      {
        name: "BBA (Bachelor of Business Administration)",
        duration: "3 years",
        fees: "₹61,000/year"
      }
    ]
  },

  {
    slug: "jigyasa-university",
    name: "Jigyasa University (formerly Himgiri Zee University)",
location: "Sherpur, Chakrata Road, Dehradun - 248197, Uttarakhand",
    type: "Private University",
    rating: "3.9/5",
    image: "/images/jigyasa.webp",
    brochure: "/brochures/jigyasa_fee_structure.pdf",
logo: "/images/logo/jigyasa.webp",
   whyusimg: [
"/images/Jigyasa-University/imgi_10_1438860891campus1.webp",
"/images/Jigyasa-University/imgi_5_1438859595campus3.webp",
"/images/Jigyasa-University/imgi_13_14388676282b8d9a5c91479be28d2aef02fb83ce9bzeecover.webp"
],
    aboutImages: [
"/images/Jigyasa-University/imgi_7_1438859595campus7.webp",
"/images/Jigyasa-University/imgi_8_1438859595campus8.webp",
"/images/Jigyasa-University/imgi_9_1741765577534LIFE IS A JOURNEY. GET THE BEST AT JU. (1360 x 500 px) (2) (1).webp"
],
faqs: [
  {
    question: "Is Jigyasa University a private or government university?",
    answer: "Jigyasa University is a State Private University established by the Government of Uttarakhand Act. It was formerly known as Himgiri Zee University."
  },
  {
    question: "What is the connection between Jigyasa University and Zee Media?",
    answer: "The university was established by the Taleem Research Foundation, associated with the Zee Group. This legacy provides strong industry connections, especially for Media and Journalism courses."
  },
  {
    question: "What are the most popular courses here?",
    answer: "The university is highly regarded for its Journalism & Mass Communication, Agriculture, and Forestry programs. It also offers Law, Management, and Engineering courses."
  },
  {
    question: "Does Jigyasa University have its own swimming pool?",
    answer: "Yes, the campus boasts world-class sports facilities, including an Olympic-size swimming pool, cricket ground, and other indoor/outdoor sports amenities."
  },
  {
    question: "What is the fee for B.Sc. Agriculture?",
    answer: "The fee for B.Sc. Agriculture is approximately ₹80,000 to ₹1 Lakh per year. The university has its own agricultural farm for practical training."
  },
  {
    question: "How are the placements for Mass Communication?",
    answer: "Due to its media roots, placements for Journalism students are excellent, with opportunities in top news channels, production houses, and digital media firms."
  },
  {
    question: "Is the university UGC recognized?",
    answer: "Yes, Jigyasa University is fully recognized by the University Grants Commission (UGC) under section 2(f), making its degrees valid for all government jobs and higher education."
  },
  {
    question: "Does the university provide transport facilities?",
    answer: "Yes, the university runs a fleet of buses covering Dehradun and nearby areas to ensure easy commuting for students and staff."
  },
  {
    question: "What is the admission criteria?",
    answer: "Admission is based on the Jigyasa University Entrance Exam (JUEE) or national level exams. Direct admission based on merit is also available for certain courses."
  },
  {
    question: "Are there hostels on campus?",
    answer: "Yes, the university has separate, secure hostels for boys and girls with modern amenities, Wi-Fi, and mess facilities. Hostel fees are around ₹90,000 to ₹1.10 Lakhs per year."
  }
]
,
    overview:
      "Jigyasa University offers diverse undergraduate and postgraduate programs across engineering, arts, sciences, and management. With 90% placement rate and strong industry connections, the university provides comprehensive education with modern infrastructure and focus on practical skill development.",
    established: "2006",
    fees_btech: "₹4 – 4.6 Lakhs/year",
    admissions: {
      examsAccepted: "JEE Main / UKSEE / Board Merit",
      applicationMode: "Online",
      applicationFee: "₹1,000",
      importantDates: [
        "Application Opens: December",
        "Last Date to Apply: June",
        "Merit List: Based on entrance exam scores"
      ]
    },
    highlights: [
      { icon: "📊", label: "B.Tech Courses", value: "5+" },
      { icon: "👥", label: "Total Students", value: "3,500+" },
      { icon: "📚", label: "Total Programs", value: "20+" },
      { icon: "💼", label: "Placement Rate", value: "90%" },
      { icon: "🏆", label: "Highest Package", value: "₹34 LPA" },
      { icon: "🏢", label: "Top Recruiters", value: "300+" }
    ],
    eligibility: "10+2 with PCM (45% minimum) + JEE Main / UKSEE / Board Merit",
    placements: {
      highestPackage: "₹34 LPA",
      averagePackage: "₹7 LPA",
      recruitersIndustries: "300+",
      placementRecords: "90%",
            gloriousAlumni: "5000+",

      recruitersImage: "/images/recruiters/jigyasa.webp"
    },
    ranking:
      "Recognized university with good placement statistics and diverse course offerings",
    ranking_details:
      "• UGC Approved Institution\n• 90% placement rate across programs\n• Partnerships with Accenture, Zee Media, Amazon Aptara, Axis Bank\n• Multiple undergraduate and postgraduate programs\n• Focus on skill-based education and industry readiness",
    facts: [
      "5+ B.Tech specializations covering CSE, IT, Civil, Mechanical, ECE",
      "6+ BA specializations in humanities and social sciences",
      "Modern classrooms with multimedia facilities",
      "Active placement cell conducting mock interviews and skill training",
      "Sports and cultural activities with modern facilities",
      "Hostel facilities available for both boys and girls"
    ],
    whyChooseUsData: [
      {
        id: 1,
        title: "High Placement Success Rate",
        description:
          "90% placement rate with average package of ₹7 LPA ensures strong career prospects for graduates.",
        imageUrl:
          "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 2,
        title: "Diverse Programs",
        description:
          "Comprehensive offerings in Engineering, Arts, Sciences, and Management meeting diverse academic interests.",
        imageUrl:
          "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 3,
        title: "Affordable Fees",
        description:
          "Competitive fee structure for engineering programs with scholarship opportunities for merit students.",
        imageUrl:
          "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      }
    ],
    galleryImages: [
  "/images/Jigyasa-University/imgi_10_1438860891campus1.webp",
"/images/Jigyasa-University/imgi_11_1438860891campus4.webp",
"/images/Jigyasa-University/imgi_11_1717052483908WhatsApp Image 2024-05-30 at 12.25.01 PM (2).webp",
"/images/Jigyasa-University/imgi_13_14388676282b8d9a5c91479be28d2aef02fb83ce9bzeecover.webp",
"/images/Jigyasa-University/imgi_14_1717052526279WhatsApp Image 2024-05-30 at 12.25.01 PM.webp",
"/images/Jigyasa-University/imgi_15_1744016377899education_img.webp",
"/images/Jigyasa-University/imgi_16_1740118209731jigyasauniversity_img.webp",
"/images/Jigyasa-University/imgi_5_1438859595campus3.webp",
"/images/Jigyasa-University/imgi_7_1438859595campus7.webp",
"/images/Jigyasa-University/imgi_8_1438859595campus8.webp",
"/images/Jigyasa-University/imgi_9_1741765577534LIFE IS A JOURNEY. GET THE BEST AT JU. (1360 x 500 px) (2) (1).webp"
    ],
    courses: [
      {
        name: "B.Tech Computer Science and Engineering",
        duration: "4 years",
        fees: "₹4 - 4.6 Lakhs/year"
      },
      {
        name: "B.Tech Information Technology",
        duration: "4 years",
        fees: "₹4 - 4.6 Lakhs/year"
      },
      {
        name: "B.Tech Civil Engineering",
        duration: "4 years",
        fees: "₹4 - 4.6 Lakhs/year"
      },
      {
        name: "B.Tech Mechanical Engineering",
        duration: "4 years",
        fees: "₹4 - 4.6 Lakhs/year"
      },
      {
        name: "B.A. (Arts) - Multiple Specializations",
        duration: "3 years",
        fees: "₹1.4 - 2.4 Lakhs/year"
      },
      {
        name: "B.Sc. (Sciences) - Multiple Specializations",
        duration: "3 years",
        fees: "₹2.4 - 3 Lakhs/year"
      },
      {
        name: "MBA (Master of Business Administration)",
        duration: "2 years",
        fees: "₹3 Lakhs/year"
      }
    ]
  },

  {
    slug: "jbit-dehradun",
    name: "JB Institute of Technology (JBIT)",
location: "23 Milestone NH-07, Shankarpur, Chakrata Road, Dehradun - 248009, Uttarakhand",
    type: "Private Engineering College",
    rating: "4.0/5",
    image: "/images/jbit.webp",
    brochure: "/brochures/jbit.pdf",
    logo: "/images/logo/jbit.webp",
 whyusimg: [
"/images/JBIT-Dehradun/imgi_107_jbit-official-image.webp",
"/images/JBIT-Dehradun/imgi_108_JB-Institute-of-Technology-Dehradun.webp",
"/images/JBIT-Dehradun/imgi_110_jbit-dehradun-campus-admission.webp"
],
faqs: [
  {
    question: "Where is the JBIT campus located?",
    answer: "JBIT is located on the Chakrata Road in Dehradun, amidst a sprawling 25-acre lush green campus. It is well-connected to the city while offering a peaceful environment for studies."
  },
  {
    question: "What is the fee structure for B.Tech at JBIT?",
    answer: "The B.Tech fees at JBIT are very affordable, typically ranging from ₹60,000 to ₹80,000 per year. The total 4-year cost is approximately ₹2.4 Lakhs to ₹3.2 Lakhs."
  },
  {
    question: "Does JBIT offer scholarships?",
    answer: "Yes, JBIT offers scholarships to meritorious students, Uttarakhand domicile holders (up to 26% tuition fee waiver), and SC/ST candidates under government schemes."
  },
  {
    question: "How are the placements at JBIT?",
    answer: "JBIT has a dedicated placement cell that organizes campus drives. Regular recruiters include companies like Tech Mahindra, Genpact, and local manufacturing firms. Average packages are around ₹3-4 LPA."
  },
  {
    question: "Is JBIT approved by AICTE?",
    answer: "Yes, JBIT is approved by the AICTE (All India Council for Technical Education) and affiliated with Uttarakhand Technical University (UTU), ensuring valid and recognized degrees."
  },
  {
    question: "Are there hostel facilities available?",
    answer: "Yes, JBIT has separate hostels for boys and girls on campus. The hostels are equipped with 24-hour power backup, Wi-Fi, and recreational areas. Hostel fees are approx. ₹60,000 - ₹75,000 per year."
  },
  {
    question: "What are the admission requirements for Polytechnic?",
    answer: "For admission to the 3-year Polytechnic Diploma, candidates must have passed Class 10th (High School) with Science and Maths subjects from a recognized board."
  },
  {
    question: "Does JBIT have a uniform code?",
    answer: "Yes, JBIT follows a strict dress code. Students are required to wear the college uniform to maintain discipline and equality among students from different backgrounds."
  },
  {
    question: "Can I get a bank loan for studying at JBIT?",
    answer: "Yes, JBIT provides assistance in availing education loans. The college has tie-ups with nationalized banks to facilitate quick loan processing for eligible students."
  },
  {
    question: "What other courses does JBIT offer besides Engineering?",
    answer: "Besides B.Tech and M.Tech, JBIT offers BBA, BCA, B.Sc Agriculture, B.Pharma, and D.Pharma courses, catering to diverse career interests."
  }
]
,

    aboutImages: [
"/images/JBIT-Dehradun/imgi_175_A-New-Design-Made-with-PosterMyWall-2022-12-14T115448.337.webp",
"/images/JBIT-Dehradun/imgi_176_girls-hostel-4.webp",
"/images/JBIT-Dehradun/imgi_179_GlbrkRmbsAAUG8i.webp"
],
    overview:
      "JB Institute of Technology is a recognized engineering college offering B.Tech, MBA, BBA, and Diploma programs with equal treatment to all students regardless of academic background. Known for 83%+ placement rate, no T&P fees, and industry partnerships with Wipro, TCS, HCL, and Oracle.",
    established: "1998",
    fees_btech: "₹1 – 1.2 Lakhs/year",
    admissions: {
      examsAccepted: "JEE Main / UKSEE / Board Merit",
      applicationMode: "Online",
      applicationFee: "₹800",
      importantDates: [
        "Application Opens: December",
        "Last Date to Apply: May",
        "Admission: June onwards"
      ]
    },
    highlights: [
      { icon: "📊", label: "B.Tech Programs", value: "6+" },
      { icon: "👥", label: "Students", value: "2,500+" },
      { icon: "📚", label: "Total Courses", value: "15+" },
      { icon: "💼", label: "Placement Rate", value: "83%+" },
      { icon: "🏆", label: "Highest Package", value: "₹30 LPA" },
      { icon: "🏢", label: "Top Recruiters", value: "200+" }
    ],
    eligibility: "10+2 with PCM and minimum 45% marks + JEE Main / UKSEE score",
    placements: {
      highestPackage: "₹30 LPA",
      averagePackage: "₹3.5 - 4 LPA",
      recruitersIndustries: "200+",
      placementRecords: "83%+",
            gloriousAlumni: "9000+",

      recruitersImage: "/images/recruiters/jbit.webp"
    },
    ranking:
      "Recognized engineering college with consistent placement record and affordable fee structure",
    ranking_details:
      "• AICTE Approved Institution\n• 83%+ placement rate since establishment\n• No training and placement fees charged\n• Top recruiters include Wipro, TCS, HCL, Infosys, Oracle, Bajaj Finserv\n• 4th ranking in Uttarakhand for B.Tech (The Week 2025)",
    facts: [
      "6+ B.Tech specializations in CSE, ECE, Mechanical, Civil, and more",
      "No T&P (Training & Placement) fees - student-friendly policy",
      "Equal treatment to all students regardless of 10th/12th percentages",
      "Partnerships with major IT companies for internships",
      "Modern labs and workshop facilities",
      "Active campus placements from 4th semester onwards"
    ],
    whyChooseUsData: [
      {
        id: 1,
        title: "No T&P Fees Policy",
        description:
          "Unique student-friendly approach with zero training and placement fees ensuring financial accessibility.",
        imageUrl:
          "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 2,
        title: "Strong Industry Partnerships",
        description:
          "Collaborations with Wipro, TCS, HCL, and Oracle providing assured placements and internship opportunities.",
        imageUrl:
          "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 3,
        title: "Equal Opportunity Culture",
        description:
          "Merit-based evaluation ensuring all students get equal placement opportunities and career support.",
        imageUrl:
          "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      }
    ],
    galleryImages: [
     "/images/JBIT-Dehradun/imgi_107_jbit-official-image.webp",
"/images/JBIT-Dehradun/imgi_108_JB-Institute-of-Technology-Dehradun.webp",
"/images/JBIT-Dehradun/imgi_110_jbit-dehradun-campus-admission.webp",
"/images/JBIT-Dehradun/imgi_111_JBIT-DEHRADUN.webp",
"/images/JBIT-Dehradun/imgi_133_hi-tech-software-lab.webp",
"/images/JBIT-Dehradun/imgi_136_bba-department.webp",
"/images/JBIT-Dehradun/imgi_152_Untitled-design-23.webp",
"/images/JBIT-Dehradun/imgi_160_1622959010phpRZtSPf.webp",
"/images/JBIT-Dehradun/imgi_165_869510274.webp",
"/images/JBIT-Dehradun/imgi_175_A-New-Design-Made-with-PosterMyWall-2022-12-14T115448.337.webp",
"/images/JBIT-Dehradun/imgi_176_girls-hostel-4.webp",
"/images/JBIT-Dehradun/imgi_179_GlbrkRmbsAAUG8i.webp",
"/images/JBIT-Dehradun/imgi_72_1622959024php0fbbPR.webp",
"/images/JBIT-Dehradun/imgi_75_1622959046phpgv8pNN.webp",
"/images/JBIT-Dehradun/imgi_78_1622959058php0SnZeh.webp",
"/images/JBIT-Dehradun/imgi_81_1622811415phpOlFUhb.webp",
"/images/JBIT-Dehradun/imgi_84_1622811400phpkXyPRp (1).webp",
"/images/JBIT-Dehradun/imgi_84_1622811400phpkXyPRp.webp",
"/images/JBIT-Dehradun/imgi_87_1622959010phpRZtSPf.webp"],

    courses: [
      {
        name: "B.Tech Computer Science and Engineering (CSE)",
        duration: "4 years",
        fees: "₹1 - 1.15 Lakhs/year"
      },
      {
        name: "B.Tech Electronics and Communication Engineering (ECE)",
        duration: "4 years",
        fees: "₹1 - 1.15 Lakhs/year"
      },
      {
        name: "B.Tech Mechanical Engineering",
        duration: "4 years",
        fees: "₹1 - 1.15 Lakhs/year"
      },
      {
        name: "B.Tech Civil Engineering",
        duration: "4 years",
        fees: "₹1 - 1.15 Lakhs/year"
      },
      {
        name: "Diploma Engineering (CSE, Mechanical, Civil)",
        duration: "3 years",
        fees: "₹60,000 - 75,000/year"
      },
      {
        name: "MBA (Master of Business Administration)",
        duration: "2 years",
        fees: "₹1.5 - 2 Lakhs/year"
      },
      {
        name: "BBA (Bachelor of Business Administration)",
        duration: "3 years",
        fees: "₹80,000 - 1 Lakh/year"
      }
    ]
  },
  {
    slug: "dbs-global-university",
    name: "DBS Global University",
location: "Mi-122, Behind Pharma City, Selaqui, Dehradun - 248001, Uttarakhand",
    type: "Private University",
    rating: "4.3/5",
    image: "/images/dbs.webp",
    brochure: "/brochures/dbs-global.pdf",
    logo: "/images/logo/dbs.webp",
  whyusimg: [
"/images/DBS-Global-University/imgi_60_11.webp",
"/images/DBS-Global-University/imgi_65_1.webp",
"/images/DBS-Global-University/imgi_66_10.webp"
],
faqs: [
  {
    question: "Is DBS Global University same as Doon Business School?",
    answer: "Yes, DBS Global University is the university status evolution of the renowned Doon Business School (DBS). It continues the legacy of DBS with expanded autonomy and course offerings."
  },
  {
    question: "What is the highest placement package at DBS?",
    answer: "DBS is famous for its high ROI. The highest international package has gone up to ₹24 LPA, while domestic packages often touch ₹15-18 LPA. Top recruiters include Deloitte, HDFC Bank, and Berger Paints."
  },
  {
    question: "What makes the PGDM program at DBS unique?",
    answer: "The PGDM program includes additional certifications like SAP-UA, NISM, and French language classes. It focuses heavily on practical exposure, industry visits, and winter internships."
  },
  {
    question: "What are the fees for the MBA program?",
    answer: "The MBA/PGDM fees range from ₹4.5 Lakhs to ₹7.5 Lakhs for the full two-year program, depending on whether you choose the base MBA or the Global PGDM with international immersion."
  },
  {
    question: "Does the college provide international exposure?",
    answer: "Yes, DBS Global offers international student exchange programs and educational tours to countries like Singapore and Dubai for students opting for the 'Global' category courses."
  },
  {
    question: "Is the campus residential?",
    answer: "DBS has a vibrant residential campus with separate hostels for boys and girls. The hostels have distinct categories (Standard/Deluxe) with varying amenities like AC and attached washrooms."
  },
  {
    question: "What is the admission criteria for MBA?",
    answer: "Admission is based on CAT/MAT/CMAT/XAT scores followed by a Group Discussion (GD) and Personal Interview (PI). Your past academic record and work experience also carry weight."
  },
  {
    question: "Are there undergraduate courses available?",
    answer: "Yes, apart from MBA, DBS Global offers BBA, BCA, B.Com (Hons), B.Sc Agriculture, and Mass Communication courses with the same industry-focused curriculum."
  },
  {
    question: "Where is the college located?",
    answer: "The campus is located in Selaqui, the industrial hub of Dehradun. This proximity to industries helps in arranging frequent factory visits and guest lectures."
  },
  {
    question: "Does DBS have a uniform?",
    answer: "Yes, professional business attire (uniform) is mandatory for management students on weekdays to groom them for the corporate world."
  }
]
,
    aboutImages: [
"/images/DBS-Global-University/imgi_73_1763816579phpEikjEA.webp",
"/images/DBS-Global-University/imgi_82_1763816632phpjisTuu.webp",
"/images/DBS-Global-University/imgi_91_1763817802phphCVUAM.webp"
],
    overview:
      "DBS Global University (Doon Business School) is a premier institution ranked #1 B-School in Uttarakhand by The Week 2023. Known for strong MBA programs, DBS offers 350+ companies visiting annually with 89.5% placement rate. Programs span Engineering, Management, and Commerce streams with focus on skill development and industry collaboration.",
    established: "2007",
    fees_btech: "₹2.28 – 2.94 Lakhs/year",
    admissions: {
      examsAccepted: "JEE Main / UKSEE / Board Merit / Management Quota",
      applicationMode: "Online",
      applicationFee: "₹1,200",
      importantDates: [
        "Application Opens: December",
        "Last Date to Apply: May end",
        "Merit List: June"
      ]
    },
    highlights: [
      { icon: "🏆", label: "#1 UK Ranking", value: "B-School" },
      { icon: "📊", label: "Companies", value: "350+" },
      { icon: "👥", label: "Students", value: "8,000+" },
      { icon: "📚", label: "Programs", value: "40+" },
      { icon: "💼", label: "Placement Rate", value: "89.5%" },
      { icon: "🏢", label: "Highest Package", value: "₹23LPA" }
    ],
    eligibility: "10+2 with 45-50% marks + JEE Main / UKSEE / Management Quota",
    placements: {
      highestPackage: "₹23.75 LPA",
      averagePackage: "₹8.9 LPA",
      recruitersIndustries: "350+",
      placementRecords: "89%",
            gloriousAlumni: "5000+",

      recruitersImage: "/images/recruiters/dbs.webp"
    },
    ranking:
      "Ranked #1 B-School in Uttarakhand and #5 Top Promising Finance Management University in India",
    ranking_details:
      "• The Week 2023: #1 B-School in Uttarakhand\n• AICTE, UGC, BCI, PCI Approved\n• Top 5 Finance Management University in India 2025\n• 350+ industry partnerships across sectors\n• Strong recruiter network: KPMG, Wipro, HCL, Accenture, Amazon, Axis Bank",
    facts: [
      "Ranked #1 B-School in Uttarakhand with national recognition",
      "350+ companies visit campus annually ensuring maximum placement opportunities",
      "Programs in Engineering, Management, Commerce, and Law",
      "State-of-the-art facilities with modern labs and libraries",
      "Strong focus on skill development and industry internships",
      "Active placement cell with 89.5% placement success"
    ],
    whyChooseUsData: [
      {
        id: 1,
        title: "Top-Ranked B-School",
        description:
          "Recognized as #1 B-School in Uttarakhand, ensuring premium quality education and industry recognition.",
        imageUrl:
          "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 2,
        title: "Massive Industry Connect",
        description:
          "350+ companies annually visit campus with 89.5% placement rate and highest package of ₹23.75 LPA.",
        imageUrl:
          "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 3,
        title: "Multi-Stream Programs",
        description:
          "Comprehensive offerings in Engineering, MBA, BBA, Commerce, and Law meeting diverse career aspirations.",
        imageUrl:
          "https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      }
    ],
    galleryImages: [
"/images/DBS-Global-University/imgi_100_1763816450phpU8o9to.webp",
"/images/DBS-Global-University/imgi_106_1763816466phpcjLyTT.webp",
"/images/DBS-Global-University/imgi_109_1763816497phpiRxJsq.webp",
"/images/DBS-Global-University/imgi_60_11.webp",
"/images/DBS-Global-University/imgi_61_1763815707phpkpCSBp.webp",
"/images/DBS-Global-University/imgi_65_1.webp",
"/images/DBS-Global-University/imgi_66_10.webp",
"/images/DBS-Global-University/imgi_67_11.webp",
"/images/DBS-Global-University/imgi_67_1763816537phpyApuwn.webp",
"/images/DBS-Global-University/imgi_73_1763816579phpEikjEA.webp",
"/images/DBS-Global-University/imgi_82_1763816632phpjisTuu.webp",
"/images/DBS-Global-University/imgi_91_1763817802phphCVUAM.webp"
    ],
    courses: [
      {
        name: "B.Tech Computer Science and Engineering",
        duration: "4 years",
        fees: "₹2.28 Lakhs/year"
      },
      {
        name: "B.Tech Electronics and Communication",
        duration: "4 years",
        fees: "₹2.28 Lakhs/year"
      },
      {
        name: "B.Tech Mechanical Engineering",
        duration: "4 years",
        fees: "₹2.28 Lakhs/year"
      },
      {
        name: "MBA (Master of Business Administration)",
        duration: "2 years",
        fees: "₹4.2 - 5 Lakhs/year"
      },
      {
        name: "BBA (Bachelor of Business Administration)",
        duration: "3 years",
        fees: "₹1.8 - 2.5 Lakhs/year"
      },
      {
        name: "B.A LL.B (Hons)",
        duration: "5 years",
        fees: "₹1.7 - 2.2 Lakhs/year"
      },
      {
        name: "B.Com (Bachelor of Commerce)",
        duration: "3 years",
        fees: "₹1.4 - 1.8 Lakhs/year"
      }
    ]
  },

  {
    slug: "combined-pg-institute-medical-sciences",
    name: "Combined PG Institute of Medical Sciences & Research",
location: "Kuanwala, P.O. Harrawala, Haridwar Road, Dehradun - 248160, Uttarakhand",
    type: "Private Medical & Health Sciences Institute",
    rating: "3.8/5",
    image: "/images/cimsr.webp",
    brochure: "/brochures/cimsr.pdf",
    logo: "/images/logo/cimsr.webp",
   whyusimg: [
"/images/CIMSR/imgi_10_slider-08.webp",
"/images/CIMSR/imgi_20_about.webp",
"/images/CIMSR/imgi_2_banner03.webp"
],

faqs: [
  {
    question: "Is CIMS Dehradun a medical college for MBBS?",
    answer: "No, CIMS is a Paramedical and Nursing institute. It specializes in courses like B.Sc Nursing, Physiotherapy (BPT), BMLT, and GNM, not MBBS."
  },
  {
    question: "What is CIMS affiliated with?",
    answer: "CIMS is affiliated with HNB Garhwal University (Central University) and Sri Dev Suman Uttarakhand University. Its nursing courses are recognized by the Indian Nursing Council (INC)."
  },
  {
    question: "What hospital is attached to CIMS for training?",
    answer: "CIMS is associated with the CMI (Combined Medical Institute) Hospital in Dehradun, a reputed multi-specialty hospital, ensuring students get high-quality clinical training."
  },
  {
    question: "What is the fee for B.Sc Nursing?",
    answer: "The fee for B.Sc Nursing is approximately ₹1 Lakh to ₹1.2 Lakhs per year. The course duration is 4 years, and admission is often through the state nursing entrance exam."
  },
  {
    question: "Does CIMS offer hostel facilities?",
    answer: "Yes, CIMS provides separate hostel accommodation for boys and girls. The girls' hostel is particularly strict about security and timings. Hostel fees are around ₹75,000 per year."
  },
  {
    question: "How are the placements for BPT graduates?",
    answer: "Graduates are placed in top hospitals like Max, Apollo, and Fortis, or they start their own physiotherapy clinics. The college claims a high placement rate for its skilled students."
  },
  {
    question: "Where is the CIMS campus located?",
    answer: "The academic campus is located in Haridwar Road, Kuanwala, Dehradun. It is easily accessible and provides a serene environment suitable for medical studies."
  },
  {
    question: "What is the admission process for BMLT?",
    answer: "Admission to Bachelor of Medical Lab Technology (BMLT) is generally based on merit in Class 12th (PCB). Students can fill the application form online or visit the campus."
  },
  {
    question: "Are scholarships available?",
    answer: "The institute assists eligible students from SC/ST/OBC categories in applying for government scholarships. Merit scholarships are also available for university toppers."
  },
  {
    question: "Does the college organize health camps?",
    answer: "Yes, CIMS regularly organizes free health camps in rural areas where students get to practice their skills and serve the community under the supervision of senior doctors."
  }
]
,
aboutImages: [
"/images/CIMSR/imgi_39_bachelor-of medical-lab-technology.webp",
"/images/CIMSR/imgi_8_slider-06.webp",
"/images/CIMSR/imgi_9_slider-07.webp"
],
  whyusimg: [
  "/images/whyus/Screenshot 2025-12-16 202818.webp",
    "/images/whyus/Screenshot 2025-12-16 202935.webp",

  "/images/whyus/Screenshot 2025-12-16 202906.webp",
],
    overview:
      "Combined PG Institute of Medical Sciences & Research (CIMSR) specializes in health sciences education across Nursing, Paramedical, and Allied Health Sciences. With experienced faculty, modern infrastructure, and comprehensive training programs, CIMSR prepares students for careers in healthcare with emphasis on practical skills and patient care.",
    established: "1998",
    fees_btech: "₹1.5 – 2.4 Lakhs/year",
    admissions: {
      examsAccepted: "NEET / Board Merit / Institute Entrance",
      applicationMode: "Online/Offline",
      applicationFee: "₹500",
      importantDates: [
        "Application Opens: April",
        "Last Date to Apply: August",
        "Merit List: August-September"
      ]
    },
    highlights: [
      { icon: "🏥", label: "Specializations", value: "10+" },
      { icon: "👥", label: "Students", value: "2,000+" },
      { icon: "📚", label: "Courses", value: "27+" },
      { icon: "👨‍🏫", label: "Faculty Experience", value: "15-25 yrs" },
      { icon: "🏨", label: "Hostel Facilities", value: "Boys & Girls" },
      { icon: "🔬", label: "Labs", value: "Fully Equipped" }
    ],
    eligibility:
      "10+2 with Biology (45-50% minimum) + NEET / Board Merit / Institute Entrance",
    placements: {
      highestPackage: "N/A",
      averagePackage: "Healthcare sector placements",
      recruitersIndustries: "100+",
      placementRecords: "85%+",
      gloriousAlumni: "950+",
      recruitersImage: "/images/recruiters/cimsr.webp"
    },
    ranking:
      "Recognized institute for nursing and paramedical education with strong healthcare sector placements",
    ranking_details:
      "• 25+ years of experience in health sciences education\n• UGC & INC (Indian Nursing Council) Approved\n• Partnerships with major hospitals (Apollo, Fortis, Max, CMO Dehradun)\n• Modern clinical training facilities\n• Strong focus on practical skill development and patient care ethics",
    facts: [
      "10+ specializations in Nursing, Paramedical, and Allied Health Sciences",
      "Modern nursing labs, operation theatre simulations, and clinical units",
      "Experienced faculty with 15-25 years of professional background",
      "Partnerships with Fortis, Max Healthcare, Apollo, and government hospitals",
      "Active clinical placements with 85%+ success rate",
      "Hostel facilities for both boys and girls with security and amenities"
    ],
    whyChooseUsData: [
      {
        id: 1,
        title: "Experienced Faculty",
        description:
          "Faculty with 15-25 years of clinical and teaching experience ensuring world-class nursing and paramedical education.",
        imageUrl:
          "https://images.unsplash.com/photo-1576091160550-112173f31446?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 2,
        title: "Hospital Partnerships",
        description:
          "Direct affiliations with Fortis, Max Healthcare, Apollo, and CMO ensuring practical training and clinical placements.",
        imageUrl:
          "https://images.unsplash.com/photo-1576091160669-112176f1c925?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 3,
        title: "Modern Infrastructure",
        description:
          "State-of-the-art labs, OT simulations, clinical units, and learning resources supporting comprehensive healthcare education.",
        imageUrl:
          "https://images.unsplash.com/photo-1579154204601-01d8f8a63e8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      }
    ],
    galleryImages: [
"/images/CIMSR/imgi_10_slider-08.webp",
"/images/CIMSR/imgi_11_slider-09.webp",
"/images/CIMSR/imgi_12_slider-10.webp",
"/images/CIMSR/imgi_13_slider-11.webp",
"/images/CIMSR/imgi_15_slider-13.webp",
"/images/CIMSR/imgi_16_slider-15.webp",
"/images/CIMSR/imgi_20_about.webp",
"/images/CIMSR/imgi_26_ott.webp",
"/images/CIMSR/imgi_2_banner03.webp",
"/images/CIMSR/imgi_39_bachelor-of medical-lab-technology.webp",
"/images/CIMSR/imgi_8_slider-06.webp",
"/images/CIMSR/imgi_9_slider-07.webp"],
    courses: [
      {
        name: "B.Sc (Hons) Nursing",
        duration: "4 years",
        fees: "₹2.4 Lakhs/year"
      },
      {
        name: "GNM (General Nursing and Midwifery)",
        duration: "3 years",
        fees: "₹1.8 Lakhs/year"
      },
      {
        name: "B.Sc Medical Laboratory Technology",
        duration: "3 years",
        fees: "₹1.8 Lakhs/year"
      },
      {
        name: "B.Sc Operation Theatre Technology",
        duration: "3 years",
        fees: "₹1.8 Lakhs/year"
      },
      {
        name: "B.Sc Paramedical Sciences",
        duration: "3 years",
        fees: "₹1.5 Lakhs/year"
      },
      {
        name: "M.Sc Nursing",
        duration: "2 years",
        fees: "₹1.5 Lakhs/year"
      },
      {
        name: "ANM (Auxiliary Nursing Midwifery)",
        duration: "2 years",
        fees: "₹1.2 Lakhs/year"
      }
    ]
  },

  {
    slug: "sardar-bhagwan-singh-university",
    name: "Sardar Bhagwan Singh (SBS) University",
location: "Gullar Ghati Road, Balawala, Dehradun - 248161, Uttarakhand",
    type: "Private University",
    rating: "3.9/5",
    image: "/images/sbs.webp",
    brochure: "/brochures/sbs.pdf",
    logo: "/images/logo/sbs.webp",
    whyusimg: [
      "/images/whyus/sbs-1.webp",
      "/images/whyus/sbs-2.webp",
      "/images/whyus/sbs-3.webp"
    ],
aboutImages: [
"/images/SBS-University/imgi_108_sbsu_gallery_0034.webp",
"/images/SBS-University/imgi_124_sbsu_gallery_0130.webp",
"/images/SBS-University/imgi_130_sbs_gallery065.webp"
],
faqs: [
  {
    question: "What is SBS University famous for?",
    answer: "SBS (formerly SBSPGI) is the pioneer of Pharmacy and Physiotherapy education in Uttarakhand. It is most famous for its Pharmacy (B.Pharm/M.Pharm) and Biotech courses."
  },
  {
    question: "Is SBS University a Sikh minority institution?",
    answer: "Yes, it was established as a Sikh minority institute (SBSPGI) and maintains that heritage, although admission is open to students of all communities and religions."
  },
  {
    question: "What is the ranking of SBS University?",
    answer: "SBS is consistently ranked among the top pharmacy colleges in North India. It has a legacy of over 28 years (established 1994) in delivering quality medical education."
  },
  {
    question: "What are the fees for B.Pharm?",
    answer: "The fee for B.Pharm is approximately ₹1.1 Lakhs to ₹1.3 Lakhs per year. The course is PCI approved and highly regarded in the pharmaceutical industry."
  },
  {
    question: "Does SBS University have its own entrance exam?",
    answer: "For most UG courses, admission is merit-based. However, for specific PG courses or scholarship seats, the university may conduct an interview or screening test."
  },
  {
    question: "How is the infrastructure at SBS University?",
    answer: "The campus covers 25 acres and features specialized herbal gardens, advanced pharma labs, a physiotherapy OPD, and a well-stocked library with thousands of medical journals."
  },
  {
    question: "What companies visit for placements?",
    answer: "Top pharma giants like Sun Pharma, Cipla, Dr. Reddy's, and Macleods are regular recruiters. For physiotherapists, major hospital chains recruit directly from the campus."
  },
  {
    question: "Are there hostels on campus?",
    answer: "Yes, the 'Mata Gujri' Girls Hostel and 'Banda Bahadur' Boys Hostel provide accommodation with Wi-Fi, laundry, and hygienic mess facilities. Security is a top priority."
  },
  {
    question: "Does the university offer B.Tech?",
    answer: "While its roots are in medical sciences, SBS does offer B.Tech in Biotechnology and some other streams, leveraging its strong biology and science infrastructure."
  },
  {
    question: "What extracurricular activities are there?",
    answer: "SBS is known for its vibrant cultural life, including the annual fest, Lohri celebrations, sports meets, and active participation in NCC and NSS units."
  }
]
,
    overview:
      "SBS University offers diverse programs spanning Pharmacy, Health Sciences, Agriculture, Horticulture, Life Sciences, and Management. With focus on practical learning, industry-oriented curriculum, and modern facilities, SBS provides comprehensive education for healthcare, agricultural, and management career paths.",
    established: "2010",
    fees_btech: "₹1.07 – 3.6 Lakhs/year",
    admissions: {
      examsAccepted: "NEET (Pharmacy/Health Sci) / Board Merit / CUET",
      applicationMode: "Online",
      applicationFee: "₹800",
      importantDates: [
        "Application Opens: May",
        "Last Date to Apply: June",
        "Merit List: June-July"
      ]
    },
    highlights: [
      { icon: "💊", label: "Pharmacy Programs", value: "4+" },
      { icon: "👥", label: "Students", value: "3,500+" },
      { icon: "📚", label: "Courses", value: "36+" },
      { icon: "🔬", label: "Labs", value: "Modern" },
      { icon: "🏥", label: "Hospital Tie-ups", value: "50+" },
      { icon: "📊", label: "Placement Rate", value: "80%+" }
    ],
    eligibility:
      "10+2 with 50% marks + NEET (for Pharmacy/Health Sci) / Board Merit / CUET",
    placements: {
      highestPackage: "₹18 LPA",
      averagePackage: "₹5 - 6 LPA",
      recruitersIndustries: "150+",
      placementRecords: "80%+",
       gloriousAlumni: "10000+",

      recruitersImage: "/images/recruiters/graphic.webp"
    },
    ranking:
      "Recognized university with strong programs in pharmaceutical sciences and health education",
    ranking_details:
      "• UGC & PCI Approved Institution\n• Strong pharmacy and health sciences focus\n• 50+ hospital partnerships for clinical training\n• Modern research and teaching labs\n• 80%+ placement rate across programs\n• Focus on pharmaceutical innovation and healthcare excellence",
    facts: [
      "4+ Pharmacy programs (B.Pharm, M.Pharm, D.Pharm, PharmD)",
      "10+ Health Sciences programs (Nursing, MLT, Paramedical)",
      "Modern pharmaceutical labs with latest equipment",
      "50+ hospital partnerships for clinical training",
      "Agriculture and Horticulture programs with field training",
      "Active placement cell with 80%+ success rate"
    ],
    whyChooseUsData: [
      {
        id: 1,
        title: "Pharmacy Excellence",
        description:
          "Comprehensive pharmacy programs (B.Pharm, M.Pharm, D.Pharm) with modern labs and pharmaceutical research focus.",
        imageUrl:
          "https://images.unsplash.com/photo-1576091160550-112173f31446?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 2,
        title: "Healthcare Network",
        description:
          "50+ hospital partnerships ensuring comprehensive clinical training and placement opportunities in healthcare sector.",
        imageUrl:
          "https://images.unsplash.com/photo-1576091160669-112176f1c925?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 3,
        title: "Diverse Programs",
        description:
          "36+ courses spanning Pharmacy, Health Sciences, Agriculture, Management, and Life Sciences for diverse career paths.",
        imageUrl:
          "https://images.unsplash.com/photo-1579154204601-01d8f8a63e8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      }
    ],
    galleryImages: [
    "/images/SBS-University/imgi_108_sbsu_gallery_0034.webp",
"/images/SBS-University/imgi_115_sbsu_gallery_0060.webp",
"/images/SBS-University/imgi_116_sbsu_gallery_0061.webp",
"/images/SBS-University/imgi_124_sbsu_gallery_0130.webp",
"/images/SBS-University/imgi_126_sbsu_gallery_0132.webp",
"/images/SBS-University/imgi_130_sbs_gallery065.webp",
"/images/SBS-University/imgi_132_sbs_gallery067.webp",
"/images/SBS-University/imgi_134_sbsu_gallery_0091.webp",
"/images/SBS-University/imgi_135_sbsu_gallery_0092.webp",
"/images/SBS-University/imgi_15_sbs_picture_01.webp",
"/images/SBS-University/imgi_4_media_header-slider-images_home_slider1_1767415735_dfd38896.webp",
"/images/SBS-University/imgi_90_sbsu_gallery_0008.webp",
"/images/SBS-University/imgi_98_sbsu_gallery_0002.webp",
    ],
    courses: [
      {
        name: "B.Pharm (Bachelor of Pharmacy)",
        duration: "4 years",
        fees: "₹3.33 - 5.5 Lakhs/year"
      },
      {
        name: "M.Pharm (Master of Pharmacy)",
        duration: "2 years",
        fees: "₹1.16 Lakhs/year"
      },
      {
        name: "D.Pharm (Diploma in Pharmacy)",
        duration: "2 years",
        fees: "₹70,000/year"
      },
      {
        name: "B.Sc (Hons) Nursing",
        duration: "4 years",
        fees: "₹2.33 - 4.47 Lakhs/year"
      },
      {
        name: "B.Sc (Hons) Medical Laboratory Technology",
        duration: "3 years",
        fees: "₹1.07 - 3.57 Lakhs/year"
      },
      {
        name: "B.Sc (Hons) Agriculture",
        duration: "4 years",
        fees: "₹1.07 - 3.57 Lakhs/year"
      },
      {
        name: "BBA (Bachelor of Business Administration)",
        duration: "3 years",
        fees: "₹1.65 Lakhs/year"
      }
    ]
  },

  {
    slug: "dit-university",
    name: "DIT University (Dehradun Institute of Technology)",
location: "Mussoorie Diversion Road, Dehradun - 248009, Uttarakhand",
    type: "Private University",
    rating: "4.1/5",
    image: "/images/dit.webp",
    brochure: "/brochures/dit.pdf",
    logo: "/images/logo/dit.webp",
  whyusimg: [
"/images/DIT-University/imgi_21_air-amphitheatre.webp",
"/images/DIT-University/imgi_23_lab2.webp",
"/images/DIT-University/imgi_33_computing-facilities1.webp"
],
faqs: [
  {
    question: "Is DIT University private or government?",
    answer: "DIT University is a private university. It started as Dehradun Institute of Technology in 1998 and was upgraded to a full-fledged university in 2013 due to its academic excellence."
  },
  {
    question: "What is the highest package offered at DIT?",
    answer: "DIT has a stellar placement record. The highest package recently touched ₹58 LPA, with a large number of students bagging offers above ₹10 LPA from companies like Palo Alto, Amazon, and Adobe."
  },
  {
    question: "How much is the B.Tech fee at DIT?",
    answer: "DIT is a premium institution. B.Tech fees range from ₹2 Lakhs to ₹2.5 Lakhs per year depending on the branch. The total cost for 4 years is approximately ₹10 Lakhs to ₹12 Lakhs."
  },
  {
    question: "Does DIT accept JEE Mains scores?",
    answer: "Yes, DIT accepts JEE Mains scores for B.Tech admission. It also conducts its own counseling based on Class 12th Board marks for a certain percentage of seats."
  },
  {
    question: "How are the hostel facilities at DIT?",
    answer: "DIT offers world-class on-campus hostels (Ravi, Shivalik, etc.) with options for Single/Double occupancy and AC. The hostels look like apartment complexes and have strict security."
  },
  {
    question: "Is admission to DIT University difficult?",
    answer: "Admission is competitive, especially for the CSE branch. A good score in JEE Mains or above 85-90% in Class 12th is usually required for the top branches."
  },
  {
    question: "What is the B.Arch program like at DIT?",
    answer: "The Faculty of Architecture at DIT is one of the best in the region, approved by the Council of Architecture (COA). It focuses on modern design, sustainability, and practical studio work."
  },
  {
    question: "Does DIT offer scholarships?",
    answer: "Yes, DIT offers merit scholarships for students with >90% in Boards/JEE, scholarship for Uttarakhand State Domicile (26% on tuition fee), and scholarships for siblings of alumni."
  },
  {
    question: "Is there a dress code at DIT?",
    answer: "No, DIT University does not have a mandatory uniform for most courses. Students are expected to dress in decent casuals, fostering a more liberal university atmosphere."
  },
  {
    question: "How far is DIT from the city center?",
    answer: "DIT is located on Mussoorie Road at Makkawala, about 10-12 km from the Clock Tower. The location is scenic, right at the foothills of Mussoorie, offering a beautiful campus view."
  }
],

aboutImages: [
"/images/DIT-University/imgi_39_computing-facilitiesnptl.webp",
"/images/DIT-University/imgi_43_1702104766_0413b7c80e10624ff6be.webp",
"/images/DIT-University/imgi_44_1702104820_5b0ad4fcd74bace14a2d.webp"
],
    overview:
      "DIT University is a comprehensive private university offering 118+ courses across Engineering, Sciences, Management, Design, Law, and Architecture. With AICTE and UGC accreditation, modern infrastructure, and strong industry partnerships, DIT focuses on producing skilled professionals ready for global careers.",
    established: "2006",
    fees_btech: "₹2.27 – 2.40 Lakhs/year",
    admissions: {
      examsAccepted: "JEE Main / NATA / Board Merit / Management Quota",
      applicationMode: "Online",
      applicationFee: "₹1,500",
      importantDates: [
        "Application Opens: January",
        "Last Date to Apply: July",
        "Entrance Exam: June onwards"
      ]
    },
    highlights: [
      { icon: "📊", label: "B.Tech Programs", value: "37+" },
      { icon: "👥", label: "Students", value: "12,000+" },
      { icon: "📚", label: "Total Courses", value: "118+" },
      { icon: "💼", label: "Placement Rate", value: "95%+" },
      { icon: "🏆", label: "Highest Package", value: "₹60 LPA" },
      { icon: "🏢", label: "Recruiters", value: "500+" }
    ],
    eligibility:
      "10+2 with 50% marks (45% for SC/ST) + JEE Main / NATA / Board Merit",
    placements: {
      highestPackage: "₹60 LPA",
      averagePackage: "₹8 - 12 LPA",
      recruitersIndustries: "500+",
      placementRecords: "95%+",
            gloriousAlumni: "15000+",

      recruitersImage: "/images/recruiters/dbs.webp"
    },
    ranking:
      "Top private university with 95%+ placement rate and strong industry recognition",
    ranking_details:
      "• AICTE & UGC Approved Institution\n• 37+ B.Tech specializations across Engineering disciplines\n• 95%+ placement rate with 500+ industry partners\n• Partnerships with Google, Microsoft, Adobe, Accenture, Amazon\n• Modern infrastructure with state-of-the-art labs\n• Strong focus on innovation, research, and entrepreneurship",
    facts: [
      "37+ B.Tech specializations including AI, Data Science, Blockchain, IoT",
      "118+ courses across Engineering, Management, Law, Design, Architecture, Sciences",
      "Modern campus with smart classrooms, advanced labs, and library",
      "500+ industry partnerships ensuring diverse internship and job opportunities",
      "95%+ placement rate with highest package ₹60 LPA",
      "Active innovation center supporting student startups and research"
    ],
    whyChooseUsData: [
      {
        id: 1,
        title: "Excellent Placements",
        description:
          "95%+ placement rate with 500+ recruiters including Google, Microsoft, Accenture, and Amazon. Highest package ₹60 LPA.",
        imageUrl:
          "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 2,
        title: "Diverse Programs",
        description:
          "118+ courses across Engineering, Management, Law, Design, and Architecture meeting all academic interests.",
        imageUrl:
          "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 3,
        title: "Modern Infrastructure",
        description:
          "State-of-the-art labs, smart classrooms, innovation center, and comprehensive facilities supporting holistic learning.",
        imageUrl:
          "https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      }
    ],
    galleryImages: [
      "/images/DIT-University/imgi_17_classroom1.webp",
"/images/DIT-University/imgi_17_ml_harris.webp",
"/images/DIT-University/imgi_21_air-amphitheatre.webp",
"/images/DIT-University/imgi_23_lab2.webp",
"/images/DIT-University/imgi_25_lab4.webp",
"/images/DIT-University/imgi_27_lab6.webp",
"/images/DIT-University/imgi_28_lab7.webp",
"/images/DIT-University/imgi_32_auditorium_chair.webp",
"/images/DIT-University/imgi_33_computing-facilities1.webp",
"/images/DIT-University/imgi_39_1702104632_0670bdb756706a4161a6.webp",
"/images/DIT-University/imgi_39_computing-facilitiesnptl.webp",
"/images/DIT-University/imgi_43_1702104766_0413b7c80e10624ff6be.webp",
"/images/DIT-University/imgi_44_1702104820_5b0ad4fcd74bace14a2d.webp"
    ],
    courses: [
      {
        name: "B.Tech Computer Science and Engineering (CSE)",
        duration: "4 years",
        fees: "₹2.27 - 2.40 Lakhs/year"
      },
      {
        name: "B.Tech CSE with Specializations (AI, Data Science, Blockchain)",
        duration: "4 years",
        fees: "₹2.27 - 2.40 Lakhs/year"
      },
      {
        name: "B.Tech Electronics and Communication Engineering",
        duration: "4 years",
        fees: "₹2.27 Lakhs/year"
      },
      {
        name: "B.Tech Mechanical Engineering",
        duration: "4 years",
        fees: "₹2.27 Lakhs/year"
      },
      {
        name: "B.Tech Civil Engineering",
        duration: "4 years",
        fees: "₹2.27 Lakhs/year"
      },
      {
        name: "B.Arch (Bachelor of Architecture)",
        duration: "5 years",
        fees: "₹3.02 - 3.12 Lakhs/year"
      },
      {
        name: "MBA (Master of Business Administration)",
        duration: "2 years",
        fees: "₹4.88 Lakhs/year"
      }
    ]
  },
  



{
  slug: "ims-unison-university",
  name: "IMS Unison University (IUU)",
  location: "Rajpur, Dehradun - 248001, Uttarakhand",
  type: "Private University",
  rating: "4.0/5",
  image: "/images/ims/imgi_160_ims-unison-university-rajpur-dehradun-institutes-fd98tod95i.webp",
  brochure: "/brochures/ims-unison.pdf",
  logo: "/images/logo/ims.webp",
 
  overview:
    "IMS Unison University (IUU) is a private university in Dehradun offering over 30 programs in Management, Law, Mass Communication, Liberal Arts, Hospitality, and Computer Applications. With 25+ years of legacy, strong rankings, and a corporate-driven curriculum, the university is known for its industry-aligned programs and vibrant campus life.",
  established: "1996 (University status 2013)",
  fees_btech: "N/A (focus on BBA, Law, MBA, BCA, BA(JMC))",
  admissions: {
    examsAccepted: "CUET / CLAT / CAT / MAT / XAT / CMAT / University Test / Board Merit",
    applicationMode: "Online",
    applicationFee: "₹1,000",
    importantDates: [
      "Application Opens: January",
      "Early Round: March–April",
      "Regular Round: May–July"
    ]
  },
  highlights: [
    { icon: "👨‍💼", label: "Streams", value: "8+" },
    { icon: "📚", label: "Courses", value: "30+" },
    { icon: "👥", label: "Students", value: "3,000+" },
    { icon: "💼", label: "Placement Rate", value: "90%+" },
    { icon: "🏢", label: "Recruiters", value: "400+" },
    { icon: "🏆", label: "Rankings", value: "Top 30 BBA / MBA"}
  ],
  eligibility:
    "10+2 with 45–50% marks for UG (BBA, B.Com (Hons), BA(JMC), Law); Graduation with 50% marks for PG (MBA, MA, LLM, MCA).",
  placements: {
    highestPackage: "₹20–23 LPA",
    averagePackage: "₹5–7 LPA (flagship programs)",
    recruitersIndustries: "400+",
    placementRecords: "90%+",
    gloriousAlumni: "12000+",
    recruitersImage: "/images/recruiters/ims.webp"
  },
  ranking:
    "Well-ranked private university for BBA, B.Com and MBA in national surveys like India Today, Outlook and Times B-School rankings.",
  ranking_details:
    "• Ranked in Top 30 for BBA in Outlook-ICARE 2024 (Rank #28, #1 in Uttarakhand)\n• Ranked by Times of India among Top 20 MBA Institutes (2021–2025 range)\n• India Today ranking in B.Com category with steady performance\n• QS I-GAUGE E-LEAD certified for digital learning\n• Approved by UGC, AICTE, BCI\n• Part of Unison Education & Research Foundation",
  facts: [
    "Legacy of 25+ years, started as Institute of Management Studies in 1996.",
    "University status granted in 2013 by Government of Uttarakhand.",
    "Offers 30+ programs across Management, Law, Mass Communication, Liberal Arts, Hospitality and IT.",
    "400+ recruiters with strong corporate presence in BFSI, consulting, media, IT and legal firms.",
    "Modern 10–12 acre campus with smart classrooms, moot court, media studios and labs.",
    "Consistent 90%+ placement for flagship BBA, MBA, Law and Communication programs."
  ],
   whyusimg: [
"/images/ims/imgi_174_WhatsApp_Image_2026_01_05_at_4_30_31_PM_ff417d5897a5fe6827c5016320438619.webp",   
"/images/ims/imgi_229_IMS-Unison-Library.webp",
 "/images/ims/imgi_175_hostel-img02.webp"
  ],
  whyChooseUsData: [
    {
      id: 1,
      title: "Strong Industry Placements",
      description:
        "90%+ placements with 400+ recruiters visiting campus, offering roles in consulting, BFSI, IT, media, and legal sectors.",
    },
    {
      id: 2,
      title: "Top-Ranked BBA & MBA",
      description:
        "Nationally ranked for BBA, B.Com, and MBA by India Today, Outlook-ICARE, and Times B-School, with strong academic reputation.",
      imageUrl:
"/images/ims/imgi_229_IMS-Unison-Library.webp"
    },
    {
      id: 3,
      title: "Industry-Oriented Curriculum",
      description:
        "Case-study and corporate-driven curriculum, moot court, media labs, internships, and live projects for real-world exposure.",
      imageUrl:
"/images/ims/imgi_175_hostel-img02.webp",
    }
  ],
   aboutImages: [
"/images/ims/imgi_199_banner-1-new_11zon.webp",
"/images/ims/imgi_224_inbound6749687199325525358.webp",
"/images/ims/imgi_215_1620651681phpGzaN8X.webp",
],
faqs: [
  {
    question: "Is IMS Unison University good for Law?",
    answer: "Yes, IMS Unison is one of the top choices for Law in Uttarakhand. Its School of Law offers BA LL.B (Hons) and BBA LL.B (Hons) and is known for its moot court competitions, legal aid clinic, and 100% internships for students."
  },
  {
    question: "What is the fee structure for BBA at IMS?",
    answer: "The BBA fee is typically between ₹1.6 Lakhs to ₹1.7 Lakhs per year. The university follows a semester system, and the total fee for the 3-year program is approximately ₹4.8 Lakhs to ₹5 Lakhs."
  },
  {
    question: "Does IMS Unison provide transport facilities?",
    answer: "Yes, the university has a fleet of buses covering all major routes in Dehradun. The transport fee is optional and charged annually based on the pickup location."
  },
  {
    question: "What are the hostel facilities like?",
    answer: "IMS Unison has separate hostels for boys and girls with modern amenities like Wi-Fi, laundry, common rooms with TV, and 24/7 security. The hostels are known for being clean and well-maintained."
  },
  {
    question: "Is the MBA program at IMS Unison residential?",
    answer: "While it is not strictly mandatory for all, staying in the hostel is highly recommended for MBA students due to the rigorous schedule of assignments, group projects, and late-night library access."
  },
  {
    question: "Does the university offer scholarships?",
    answer: "Yes, IMS Unison offers merit-based scholarships (up to 90% of tuition fee) for students with excellent academic records in Class 12th or graduation. There are also special scholarships for Uttarakhand domicile students."
  },
  {
    question: "How is the placement record of IMS Unison?",
    answer: "The university has a strong placement cell with a record of over 90% placements for eligible students. Top recruiters include Times of India, HDFC Bank, and Tommy Hilfiger, with packages averaging ₹5-6 LPA."
  },
  {
    question: "What entrance exams are accepted?",
    answer: "For Law, CLAT and LSAT scores are accepted. For Management (MBA), CAT/MAT/CMAT/XAT scores are considered. The university also conducts its own entrance test for students without these scores."
  },
  {
    question: "Are there any student clubs?",
    answer: "Yes, the university has a vibrant student life with various clubs like the Literary Club, Moot Court Society, Cultural Club, and Sports Club, organizing events throughout the year."
  },
  {
    question: "Is the campus Wi-Fi enabled?",
    answer: "Yes, the entire campus, including classrooms, library, and hostels, is Wi-Fi enabled with high-speed internet connectivity to support digital learning."
  }
]
,
  galleryImages: [
"/images/ims/imgi_160_ims-unison-university-rajpur-dehradun-institutes-fd98tod95i.webp",
"/images/ims/imgi_180_1567583240inrfraaa.webp",

   "/images/ims/imgi_114_hostel-img3.webp",
"/images/ims/imgi_123_1589355530_MG_2926.webp",
"/images/ims/imgi_124_hostel-img08.webp",
"/images/ims/imgi_150_1740454037php83S35f.webp",
"/images/ims/imgi_157_classroom1.webp",
"/images/ims/imgi_166_transport-image3.webp",
"/images/ims/imgi_174_1589355273PHOTO-2018-08-23-16-12-06_1.webp",
"/images/ims/imgi_174_WhatsApp_Image_2026_01_05_at_4_30_31_PM_ff417d5897a5fe6827c5016320438619.webp",
"/images/ims/imgi_175_hostel-img02.webp",
"/images/ims/imgi_190_1589355530w1.webp",
"/images/ims/imgi_191_hostel-mess1.webp",
"/images/ims/imgi_199_banner-1-new_11zon.webp",
"/images/ims/imgi_202_hostel-mess8.webp",
"/images/ims/imgi_204_Screenshot-2025-02-04-at-12.45.12 AM.webp",
"/images/ims/imgi_212_399823498_637005725307888_1786514268541228712_n.webp",
"/images/ims/imgi_215_1620651681phpGzaN8X.webp",
"/images/ims/imgi_224_inbound6749687199325525358.webp",
"/images/ims/imgi_227_WhatsApp_Image_2026_01_05_at_4_30_33_PM_de871aa2971dce008f9033edd06f1f6a.webp",
"/images/ims/imgi_229_IMS-Unison-Library.webp"
  ],
  courses: [
  {
    name: "BBA (Bachelor of Business Administration)",
    duration: "3 years",
    fees: "₹1.6 - 2.2 Lakhs/year"
  },
  {
    name: "B.Com (Hons)",
    duration: "3 years",
    fees: "₹1.1 - 1.6 Lakhs/year"
  },
  {
    name: "BA (Journalism & Mass Communication)",
    duration: "3 years",
    fees: "₹1.2 - 1.4 Lakhs/year"
  },
  {
    name: "BA (Hons) Journalism & Mass Communication with Research",
    duration: "4 years",
    fees: "₹1.2 - 1.4 Lakhs/year"
  },
  {
    name: "BA in Liberal Arts",
    duration: "3 years",
    fees: "₹1.2 - 1.4 Lakhs/year"
  },
  {
    name: "BA (Hons) English / Economics / Psychology",
    duration: "3 years",
    fees: "₹1.1 - 1.4 Lakhs/year"
  },
  {
    name: "BA (Hons) with Research (Liberal Arts / Economics / English / Psychology)",
    duration: "4 years",
    fees: "₹1.2 - 1.5 Lakhs/year"
  },
  {
    name: "BCA (Bachelor of Computer Applications)",
    duration: "3 years",
    fees: "₹1.1 - 1.4 Lakhs/year"
  },
  {
    name: "BHM (Bachelor of Hotel Management)",
    duration: "4 years",
    fees: "₹1.2 - 1.5 Lakhs/year"
  },
  {
    name: "B.Sc (Hons) – Hospitality / Hotel Management / Allied Fields",
    duration: "4 years",
    fees: "₹1.2 - 1.5 Lakhs/year"
  },
  {
    name: "BA LL.B (Hons) / BBA LL.B (Hons)",
    duration: "5 years",
    fees: "₹1.8 - 2.2 Lakhs/year"
  },
  {
    name: "LL.B (Bachelor of Laws)",
    duration: "3 years",
    fees: "₹1.2 - 1.6 Lakhs/year"
  },
  {
    name: "LL.M (Master of Laws – multiple specialisations)",
    duration: "1 year",
    fees: "₹80,000 - 1.3 Lakhs total"
  },
  {
    name: "MBA (Master of Business Administration)",
    duration: "2 years",
    fees: "₹3.2 - 3.9 Lakhs/year"
  },
  {
    name: "MA in Media, Communication and Design",
    duration: "2 years",
    fees: "₹60,000 - 80,000/year"
  },
  {
    name: "MA (English / Economics / Psychology / Liberal Arts)",
    duration: "2 years",
    fees: "₹60,000 - 90,000/year"
  },
  {
    name: "MCA (Master of Computer Applications)",
    duration: "2 years",
    fees: "₹85,000 - 1.1 Lakhs/year"
  },
  {
    name: "PhD (Law / Management / Media / Hotel Management)",
    duration: "3 - 5 years",
    fees: "As per university norms"
  }
]

}
,




  {
    slug: "alpine-group-of-institutes",
    name: "Alpine Group of Institutes",
location: "Nanda Ki Chawki, Prem Nagar, Dehradun - 248007, Uttarakhand",
    type: "Private College & Institute",
    rating: "3.8/5",
    image: "/images/alpine.webp",
    brochure: "/brochures/alpine.pdf",
    logo: "/images/logo/alpine.webp",
whyusimg: [
"/images/Alpine-Institute/imgi_10_IMG-20230423-WA0032.webp",
"/images/Alpine-Institute/imgi_24_IMG-20230423-WA0000.webp",
"/images/Alpine-Institute/imgi_35_Green_Campas-500x300.webp"
],
faqs: [
  {
    question: "What is Alpine Group of Institutes best known for?",
    answer: "Alpine Group is best known for its specialized courses in Aircraft Maintenance Engineering (AME), Agriculture, and Pharmacy. It is one of the few institutes in the region offering DGCA-approved AME courses."
  },
  {
    question: "Is the Aircraft Maintenance Engineering (AME) course approved?",
    answer: "Yes, the AME course is approved by the Directorate General of Civil Aviation (DGCA), Government of India. This certification is crucial for a career in aviation engineering."
  },
  {
    question: "What are the fees for B.Sc. Agriculture?",
    answer: "The fees for B.Sc. Agriculture are quite reasonable, typically around ₹60,000 to ₹70,000 per year. The college has its own agricultural fields for practical training."
  },
  {
    question: "Does Alpine Institute provide placement assistance?",
    answer: "Yes, the institute has a proactive placement cell. AME students often get placed in airlines and MROs, while management and agriculture students find roles in their respective industries."
  },
  {
    question: "Are there hostel facilities on campus?",
    answer: "Yes, Alpine provides separate hostels for boys and girls with necessary amenities. The hostels are secure and offer a homely environment with mess facilities."
  },
  {
    question: "Can I get admission based on Class 12th marks?",
    answer: "Yes, for most undergraduate courses like B.Sc., BBA, and BCA, admission is direct and based on merit in Class 12th. For AME, there might be a specific eligibility criteria as per DGCA norms."
  },
  {
    question: "Does the college offer Hotel Management?",
    answer: "Yes, Alpine offers a Hotel Management course with a focus on practical training. The college has well-equipped food production labs and a training restaurant."
  },
  {
    question: "Is the campus ragging-free?",
    answer: "Alpine Institute maintains a strict zero-tolerance policy towards ragging. The anti-ragging committee ensures the safety and comfort of all new students."
  },
  {
    question: "How far is the college from the airport?",
    answer: "The college is located in the Prem Nagar area, which is about 35-40 km from the Jolly Grant Airport, but it is well-connected to the Dehradun city center and railway station (approx. 12 km)."
  },
  {
    question: "Do they offer scholarships for girls?",
    answer: "Yes, the institute often provides special fee concessions and scholarships to meritorious girl students and students from the weaker sections of society."
  }
]
,
   aboutImages: [
"/images/Alpine-Institute/imgi_7_IMG-20230423-WA0029.webp",
"/images/Alpine-Institute/imgi_8_IMG-20230423-WA0008.webp",
"/images/Alpine-Institute/imgi_9_IMG-20230423-WA0028.webp"
],
    overview:
      "Alpine Group of Institutes is a premier institute established in 1994, specializing in Aircraft Maintenance Engineering (AME), Engineering, Management, and Hotel Management. With AICTE approval, strong industry partnerships, and 100% placement focus, Alpine delivers specialized technical and management education for aviation and hospitality sectors.",
    established: "1994",
    fees_btech: "₹0.8 – 1.8 Lakhs/year",
    admissions: {
      examsAccepted: "AME CEE / JEE Main / Board Merit / Institute Entrance",
      applicationMode: "Online",
      applicationFee: "₹500",
      importantDates: [
        "Application Opens: August",
        "Last Date to Apply: September",
        "Merit List: September-October"
      ]
    },
    highlights: [
      { icon: "✈️", label: "AME Programs", value: "DGCA Approved" },
      { icon: "👥", label: "Students", value: "3,500+" },
      { icon: "📚", label: "Courses", value: "25+" },
      { icon: "💼", label: "Placement Rate", value: "100%" },
      { icon: "🏆", label: "Highest Package", value: "₹90 LPA" },
      { icon: "🎓", label: "Specializations", value: "12+" }
    ],
    eligibility:
      "10+2 (PCM/PCB) with 45-50% marks + AME CEE / JEE Main / Board Merit",
    placements: {
      highestPackage: "₹90 LPA",
      averagePackage: "₹8 - 15 LPA",
      recruitersIndustries: "200+",
      placementRecords: "95%",
            gloriousAlumni: "20000+",

      recruitersImage: "/images/recruiters/maya.webp"
    },
    ranking:
      "Premier institute with AICTE approval and 100% placement record in specialized fields",
    ranking_details:
      "• AICTE (All India Council for Technical Education) Approved\n• Established 1994 - 30 years of excellence\n• DGCA Approved AME Programs (Aircraft Maintenance Engineering)\n• 100% Placement Guarantee\n• Central Government University Affiliated\n• 200+ industry partnerships across aviation, IT, management, hospitality sectors\n• Highest package: ₹90 LPA (Aviation sector)",
    facts: [
      "Specialized in Aircraft Maintenance Engineering (AME) with DGCA approval",
      "100% placement guarantee across all programs",
      "B.Tech, BBA, B.Sc, Diploma, and Certificate programs available",
      "Unique AME + B.Sc dual degree option",
      "Modern labs with aviation-grade equipment",
      "Strongest placement record: Highest package ₹90 LPA in aviation sector"
    ],
    whyChooseUsData: [
      {
        id: 1,
        title: "Aviation Excellence",
        description:
          "DGCA-approved Aircraft Maintenance Engineering programs with highest package ₹90 LPA and specialized aviation industry placement.",
        imageUrl:
          "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 2,
        title: "100% Placement Guarantee",
        description:
          "Assured placement with average package ₹8-15 LPA across engineering, management, and hospitality programs.",
        imageUrl:
          "https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 3,
        title: "Diverse Programs",
        description:
          "25+ specialized courses across AME, B.Tech, BBA, Hotel Management, and Agriculture meeting multiple career paths.",
        imageUrl:
          "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      }
    ],
    galleryImages: [
"/images/Alpine-Institute/imgi_10_IMG-20230423-WA0032.webp",
"/images/Alpine-Institute/imgi_11_IMG-20230423-WA0005.webp",
"/images/Alpine-Institute/imgi_128_162694752020210612192756.webp",
"/images/Alpine-Institute/imgi_12_IMG-20230423-WA0004.webp",
"/images/Alpine-Institute/imgi_13_IMG-20230423-WA0001.webp",
"/images/Alpine-Institute/imgi_24_IMG-20230423-WA0000.webp",
"/images/Alpine-Institute/imgi_35_Green_Campas-500x300.webp",
"/images/Alpine-Institute/imgi_42_162694748620210612_192756.webp",
"/images/Alpine-Institute/imgi_43_1626947486580.webp",
"/images/Alpine-Institute/imgi_4_IMG-20230423-WA0024.webp",
"/images/Alpine-Institute/imgi_59_Who-we-are.webp",
"/images/Alpine-Institute/imgi_5_IMG-20230423-WA0002.webp",
"/images/Alpine-Institute/imgi_5_popup-video-poster-900x500.webp",
"/images/Alpine-Institute/imgi_6_IMG-20230423-WA0006.webp",
"/images/Alpine-Institute/imgi_7_IMG-20230423-WA0029.webp",
"/images/Alpine-Institute/imgi_8_IMG-20230423-WA0008.webp",
"/images/Alpine-Institute/imgi_9_IMG-20230423-WA0028.webp"
    ],
    courses: [
      {
        name: "B.Tech Aeronautical Engineering + AME",
        duration: "4 years",
        fees: "₹1.8 Lakhs/year"
      },
      {
        name: "Aircraft Maintenance Engineering (AME)",
        duration: "3 years",
        fees: "₹1.5 Lakhs/year"
      },
      {
        name: "B.Tech Computer Science (AI & ML, Data Science)",
        duration: "4 years",
        fees: "₹1.4 - 1.75 Lakhs/year"
      },
      {
        name: "BBA (Bachelor of Business Administration)",
        duration: "3 years",
        fees: "₹70,000 - 95,000/year"
      },
      {
        name: "B.Sc Agriculture",
        duration: "4 years",
        fees: "₹70,000 - 95,000/year"
      },
      {
        name: "Bachelor of Hotel Management (BHM)",
        duration: "3-4 years",
        fees: "₹50,000 - 80,000/year"
      },
      {
        name: "Diploma in Civil Engineering",
        duration: "3 years",
        fees: "₹35,000 - 60,000/year"
      }
    ]
  },
  {    slug: "subharti-university",
    name: "Ras Bihari Bose Subharti University",

location: "Subhartipuram, Kotda Santoor, Nanda Ki Chowki, Premnagar, Dehradun - 248007, Uttarakhand",    type: "Private University",
    rating: "3.7/5",
    image: "/images/subharti.webp",
    brochure: "/brochures/subharti.pdf",
    logo: "/images/logo/subharti.webp",
 whyusimg: [
"/images/Subharti-University/imgi_15_activity.webp",
"/images/Subharti-University/imgi_18_hostel.webp",
"/images/Subharti-University/imgi_39_1498909123IMG_6669.webp"
],
faqs: [
  {
    question: "Is Ras Bihari Bose Subharti University recognized?",
    answer: "Yes, it is a State Private University recognized by the UGC (University Grants Commission). It was established under the Uttarakhand Government Act in 2016."
  },
  {
    question: "What courses are popular at Subharti University Dehradun?",
    answer: "The university is popular for its medical and paramedical courses, including B.Sc. Nursing, BPT, BNYS (Naturopathy & Yogic Sciences), and D.Pharma."
  },
  {
    question: "Does the university offer BNYS course?",
    answer: "Yes, it is one of the few universities offering a full-fledged Bachelor of Naturopathy & Yogic Sciences (BNYS) degree, which is gaining immense popularity in the wellness sector."
  },
  {
    question: "What is the fee for B.Ed.?",
    answer: "The fee for the B.Ed. program is approximately ₹40,000 to ₹50,000 per year, making it one of the most affordable options for teacher training in Dehradun."
  },
  {
    question: "Are there hostel facilities available?",
    answer: "Yes, the university provides hostel accommodation for students. The hostels are basic but comfortable, with mess facilities serving vegetarian food."
  },
  {
    question: "How is the placement for Nursing students?",
    answer: "Nursing graduates have high employability. The university's strong focus on healthcare education ensures that students get placed in private and government hospitals."
  },
  {
    question: "What is the admission process?",
    answer: "Admission is primarily based on merit in the qualifying examination (Class 12th or Graduation). For some technical courses, an entrance test or interview might be conducted."
  },
  {
    question: "Is the campus Wi-Fi enabled?",
    answer: "Yes, the campus has Wi-Fi connectivity for academic purposes. Students can access online resources and digital libraries to support their studies."
  },
  {
    question: "Does the university offer Ph.D. programs?",
    answer: "Yes, Subharti University offers Ph.D. programs in various disciplines like Education, Commerce, Science, and Arts, following UGC regulations."
  },
  {
    question: "Where is the university located?",
    answer: "The campus is situated in Kotda Santaur, Aamwala Road, Dehradun. It is in a quiet, pollution-free area, ideal for academic pursuits."
  }
]
,
    aboutImages: [
"/images/Subharti-University/imgi_50_14989105991456292632IMG_0390.webp",
"/images/Subharti-University/imgi_51_14989105991456292632IMG_0394.webp",
"/images/Subharti-University/imgi_56_642b114614d0fca2fad96a1976b0ba92.webp"
],
    overview:
      "Ras Bihari Bose Subharti University is a multi-disciplinary private university offering comprehensive programs across Engineering, Medical Sciences, Nursing, Pharmacy, and Management. With multiple colleges on campus and modern facilities, Subharti provides diverse career pathways spanning engineering, healthcare, and business streams.",
    established: "1992",
    fees_btech: "₹1.5 – 3.6 Lakhs/year",
    admissions: {
      examsAccepted: "JEE Main / NEET / SNET (Subharti Entrance) / Board Merit",
      applicationMode: "Online/Offline",
      applicationFee: "₹800",
      importantDates: [
        "Application Opens: February",
        "Last Date to Apply: July",
        "SNET Exam: May-June"
      ]
    },
    highlights: [
      { icon: "🏥", label: "Affiliated Colleges", value: "8+" },
      { icon: "👥", label: "Total Students", value: "8,000+" },
      { icon: "📚", label: "Programs", value: "50+" },
      { icon: "🔬", label: "Labs & Facilities", value: "Modern" },
      { icon: "📊", label: "Placement Rate", value: "75%+" },
      { icon: "🏆", label: "Highest Package", value: "₹11 LPA" }
    ],
    eligibility:
      "10+2 with 45-50% marks + JEE Main / NEET / SNET / Board Merit",
    placements: {
      highestPackage: "₹11 LPA",
      averagePackage: "₹3.5 - 4.5 LPA",
      recruitersIndustries: "150+",
      placementRecords: "75%+",
            gloriousAlumni: "4000+",

      recruitersImage: "/images/recruiters/uu.webp"
    },
    ranking:
      "Multi-disciplinary university recognized for engineering, medical, and management education",
    ranking_details:
      "• UGC, AICTE, BCI, PCI Approved Institution\n• 30+ years of educational excellence\n• 8+ affiliated colleges offering diverse programs\n• 150+ industry partnerships\n• Strong focus on skill development and practical training\n• Active research centers and innovation labs",
    facts: [
      "Multiple affiliated colleges spanning Engineering, Medicine, Nursing, Pharmacy, Commerce",
      "SNET entrance test for merit-based admissions",
      "Modern infrastructure with advanced labs and clinical facilities",
      "150+ recruiters visiting campus annually",
      "75%+ placement rate with focus on skill enhancement",
      "Hostel facilities with security and modern amenities"
    ],
    whyChooseUsData: [
      {
        id: 1,
        title: "Multi-Disciplinary Campus",
        description:
          "8+ affiliated colleges offering Engineering, Medicine, Nursing, Pharmacy, Management ensuring diverse educational pathways.",
        imageUrl:
          "https://images.unsplash.com/photo-1461749280684-ddefd3b96369?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 2,
        title: "Diverse Career Options",
        description:
          "50+ programs across healthcare, engineering, business, and science streams meeting varied career aspirations.",
        imageUrl:
          "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 3,
        title: "Affordable Education",
        description:
          "Competitive fee structure with scholarship options making quality education accessible to deserving students.",
        imageUrl:
          "https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
      }
    ],
    galleryImages: [
    "/images/Subharti-University/imgi_15_activity.webp",
"/images/Subharti-University/imgi_16_lab.webp",
"/images/Subharti-University/imgi_173_1_f7eff0f41c5bc5a8e0b2df5c3ee87f74.webp",
"/images/Subharti-University/imgi_174_2_87a6b226f09fca89382f95dfb9a781d9.webp",
"/images/Subharti-University/imgi_176_4_ce392271cf357415631d79c48035e44c.webp",
"/images/Subharti-University/imgi_18_hostel.webp",
"/images/Subharti-University/imgi_25_IMG_20231030_140328.webp",
"/images/Subharti-University/imgi_39_1498909123IMG_6669.webp",
"/images/Subharti-University/imgi_4_main-banner_1.webp",
"/images/Subharti-University/imgi_50_14989105991456292632IMG_0390.webp",
"/images/Subharti-University/imgi_51_14989105991456292632IMG_0394.webp",
"/images/Subharti-University/imgi_56_642b114614d0fca2fad96a1976b0ba92.webp",
"/images/Subharti-University/imgi_5_main-banner_2.webp"
    ],
    courses: [
      {
        name: "B.Tech (Multiple Specializations)",
        duration: "4 years",
        fees: "₹1.5 - 1.8 Lakhs/year"
      },
      {
        name: "MBBS (Bachelor of Medicine, Bachelor of Surgery)",
        duration: "5.5 years",
        fees: "₹18 - 20 Lakhs/year"
      },
      {
        name: "B.Sc (Hons) Nursing",
        duration: "4 years",
        fees: "₹1.25 - 1.4 Lakhs/year"
      },
      {
        name: "B.Pharm (Bachelor of Pharmacy)",
        duration: "4 years",
        fees: "₹1.5 - 2 Lakhs/year"
      },
      {
        name: "BBA (Bachelor of Business Administration)",
        duration: "3 years",
        fees: "₹70,000 - 90,000/year"
      },
      {
        name: "B.Com (Bachelor of Commerce)",
        duration: "3 years",
        fees: "₹55,000 - 75,000/year"
      },
      {
        name: "BNYS (Bachelor of Naturopathy and Yogic Sciences)",
        duration: "4 years",
        fees: "₹3.6 Lakhs/year"
      }
    ]
  },

];
